import React, { Component } from "react";
import {
  GET_IDEA_URL,  APPROVED,  PENDING,  SENT_BACK,  REJECTED,  DELEGATE_IDEA_URL,
  GET_METADATA,  DATA_BRIDGE_CAMPAIGN,  OTHER_REGIONS,  ACCESS_TOKEN,  PROJECT_VIEW,
  COMPLETE_STATUS,  AWAITING_MASTER_BLACKBELT_APPROVAL,
  PPT_CONTENT,  SIGNOFF_CONTENT,  USER_DATA,  REVIEW_IDEA_URL,  SUBMIT_IDEA_URL,
  AWAITING_QAULITY_CHECK_REVIEW,  DISPLAYPROJECTTHEME,
  AIFIRST,  IDEA_ADMIN_UPDATE,  AI_DOC_LINK, YESORNO,   REPLICABILITYOPTIONS,
   GENAIOPTIONS,AWAITING_PROJECT_APPROVAL,
  CANCEL,
  NO_VD,
  AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION
} from "../assets/constants/constants";
import Toast from "light-toast";
import {
  selectValidation as selectStyle,
  textBoxValidation,
} from "../utils/FieldValidation";
import Select from "react-select";
import UpdatedSpeech from "./UpdatedSpeech";
import ValueDelivery from "../utils/ValueDelivery";
import ShowTree from "../utils/ShowTree";
import { Link } from "react-router-dom";


const projectType = [
  {
    value: 0,
    label: "GB",
  },
  {
    value: 1,
    label: "BB",
  },
  {
    value: 2,
    label: "MBB",
  },
];

export class ViewIdeaPage extends Component {
  sessionData = JSON.parse(localStorage.getItem(USER_DATA));
  accessToken = localStorage.getItem(ACCESS_TOKEN);
  constructor(props) {
    super(props);

    const isApprovalPage = `${this.props.location.approval}`;
    let isViewAllIdea = this.props.location.isViewAllIdea;
    let isViewAllProject = this.props.location.isViewAllProject;
    let propsData = this.props.location;

    this.state = {
      ideaItem: {},
      onInitPageTime: "",
      WorkflowStatus: "",
      Comment: "",
      accountName: "",
      campaignName: "",
      serviceLineName: "",
      approvalPage: isApprovalPage,
      isViewAllIdea: isViewAllIdea,
      propsData: propsData,
      isViewAllProject: isViewAllProject,
      reviewComments: [],
      businessImpactMasterList: [],
      businessImpactValueArray: [],
      summaryArray: [],
      fteTotal: 0,
      dollarTotal: 0.0,
      commentLog: false,
      cancelRequest: false,
      activeIdea: false,
      selectStyle: {},
      adminUserList: [],
      admin: false,
      adminOHR: "",
      isLeanIdea: false,
      leanIdeaSelectedOption: null,
      leanIdeaSelectedOptionList: [
        {
          value: 1,
          label: "Lean",
        },
        {
          value: 2,
          label: "Lean+Idea",
        },
      ],
      userRole: "",
      userRoleId: "",
      ifBBUpdaterNull: "",
      ifMBBUpdaterNull: "",
      Role: "",
      speechModal: false,
      transcriptValue: "",
      modalIndex: "",
      previousTextForSpeech: "",

      showHistoricalBI: false,

      showClientFields: false,
      showGOLFields: false,

      golFilename: "",
      golContent: "",
      golFileType: "",
      golOhr: "",
      golEmail: "",
      golFullname: "",

      fpnaFilename: "",
      fpnaContent: "",
      fpnaFileType: "",
      fpnaName: "",
      fpnaEmail: "",
      fpnaOhr: "",
      clientName: "",
      clientRole: "",
      clientSignOffDate: "",
      signOffFilename: "",
      IsVDType: "",
     
      
      isAwaitingProjCreation:false,
      qcComments: [],
      qcCommentLog: false,
      QCOHR: "",
      qcCommentsWithVD: [],
      lastFinalComment: "",
      lastApprovalStatus: "",
      lastQCCOmment: "",
      FinalImpactDollar: "",
      FinalImpactFTE: "",
      finalReviewComments: [],
      golFpnaFileDetails: [],
      isFpnaRequired: false,
      displayProjectTheme: false,
      //clustor states starts here
      clusterModal: false,
      projectTypeSelectedOption: null,
      projectIDSelectedOption: null,
      clustorProjects: [],
      guidSelectedOption: null,
      showHirearchy: true,
      showTreeHirearchy: false,
      clusterData: [],
      isClusterSaveDisabled: true,
      displayParentAlpha: "",
      clusterOptionSearched: false,
      enableClusterAction: false,
      ideasAI: [],


      // ....DB states start here...

      replicabilityIndex: [],


      //LDT approval
      IsQBR: [],
      QBRDate: "",
      LDTApproverName: "",
      LDTApproverOHR: "",
      LDTApproverEmail: "",
      ldtLeadApprovalSelectedOption: [],
      displayLDTCommentLog: false,
      isLDTApprover: false,
      ldtApprovalComment: "",
      LDTLogs: [],
      qbrChanged: false,
      qbrLastSubmittedDate: "",




  

      //AI
      isIdeaReplicable: "",

      campaignList: [],
      campaignInsight: "",


      methodologies: "",
      // productivity
      contractedUploadedOHRCount: 0,
      nonContractedUploadedOHRCount: 0,
      totalOHRUploaded: 0,
      // Code by TR start
      IdeaOwnerCanEdit: false,
      isIdeaPending: false,
      accountList: [],
      accountNameSelectedOption: null,
      verticalSelectedOption: null,
      subVerticalSelectedOption: null,
      regionSelectedOption: null,
      subRegionSelectedOption: null,
      countrySelectedOption: null,
      blackBeltSelectedOption: null,
      mbbSelectedOption: null,
      ldaSelectedOption: null,
      verticalList: [],
      accountList: [],
      regionList: [],
      subRegionList: [],
      countryList: [],
      subVerticalList: [],
      blackbeltList: [],
      mbbList: [],
      ldaList: [],
      campaignList: [],
      dataBridgeProjectThemeList: [],
      subCampaignList: [],
      serviceLineList: [],
      subServiceLineList: [],
      // Unit and Segment
      Unit: "",
      Segment: "",
      unitsAndSegmentsList: [],
                    
  


      // AI First states starts here
      DisplayAIFirst: false,
      subCampaignSelectedOption: null,
      blackBeltUserId: 111,
      blackBeltUserName: "",
      blackBeltUserEmail: "",
      mbbList: [],
      mbbName: "",
      mbbOHR: "",
      mbbSelectedOption: null,
      serviceLineId: 111,
      serviceLineText: "",
      ServiceLineSelectedOption: null,
      subServiceLineId: 0,
      subServiceLineText: "",
      subServiceLineSelectedOption: null,
      serviceLineList: [],
      subServiceLineList: [],
      replicationProjectId: "",
      replicationIDValidated: false,
      newOrReplicatedIdea: false,
      isIdeaDocUplApproved: false,
      isIdeaDUAOwner: false,
      // Code by TR end

      CodersTable: [],
      campaignSelectedOption: null,
      
      displaySubCampaign:false,
      campaignUnionQuery:null,
       dataBridgeProjectTheme:"",         


    };
  }

  async componentDidMount() {
    await this.fetchIdea();
    await this.fetchMetadata();
  }

  formatDateString(dateparam) {
    return dateparam.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
  }

  formatDateStringWithTime(dateparam) {
    return dateparam.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }

  

  

  // function to fetch gol file data
  showGolOffContent = async () => {
    try {
      Toast.loading("Fetching GOL Approval content...", () => { });
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        },
      };
      let golFileType = this.state.ideaItem.GOLFileType;
      const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&${PPT_CONTENT}=true&golcontent=true&case=doc`, requestOptions)
      if (response.ok) {
        const data = await response.json();
        if (data) {
          const golMetadata = data.golContent ? data.golContent : "";
          const golContent = "data:" + golFileType + ";base64," + golMetadata;
          if (golContent) {
            var fileData = golContent;
            var fileName = this.state.ideaItem.GOLFileName;
            var w = window.open("");
            const downloadLink = w.document.createElement("a");
            downloadLink.href = fileData;
            downloadLink.download = fileName;
            downloadLink.click();
            Toast.hide();
          }
        }
      }
    }
    catch (error) {
      console.log(error)
      Toast.hide()
      Toast.fail("Error while fetching GOL Approval content. Please try again!", 3000, () => { });
    }
  };

  // function to fetch fpna file data
  
  showFpnaContent = async () => {
    try {
      Toast.loading("Fetching FP&A Approval content...", () => { });
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        },
      };
      let fpnaFileType = this.state.ideaItem.FPnAFileType;
      const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&${PPT_CONTENT}=true&fpnacontent=true&case=doc`, requestOptions)
      if (response.ok) {
        const data = await response.json();
        if (data) {
          const golMetadata = data.fpnaContent ? data.fpnaContent : "";
          const golContent = "data:" + fpnaFileType + ";base64," + golMetadata;
          if (golContent) {
            var fileData = golContent;
            var fileName = this.state.ideaItem.FPnAFileName;
            var w = window.open("");
            const downloadLink = w.document.createElement("a");
            downloadLink.href = fileData;
            downloadLink.download = fileName;
            downloadLink.click();
            Toast.hide();
          }
        }
      }
    }
    catch (error) {
      Toast.hide()
      console.log(error)
      Toast.fail("Error while fetching FP&A Approval content. Please try again!", 3000, () => { });
    }
  };

  // function to fetch fpna file for monetization
  showMonetizationContent = async () => {
    try {
      Toast.loading("Fetching FP&A Sign-off for monetization content...", () => { });
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        },
      };
      let signoffFileType = this.state.ideaItem.FPnAFileTypeMonetization;
      const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&${PPT_CONTENT}=true&fpnacontent=true&fpnamonetizationcontent=true&case=doc`, requestOptions)
      if (response.ok) {
        const data = await response.json();
        if (data) {
          const signoffMetadata = data.fpnaContent ? data.fpnaContent : "";
          const signoffContent = "data:" + signoffFileType + ";base64," + signoffMetadata;
          if (signoffContent) {
            var fileData = signoffContent;
            var fileName = this.state.ideaItem.FPnAFileNameMonetization;
            var w = window.open("");
            const downloadLink = w.document.createElement("a");
            downloadLink.href = fileData;
            downloadLink.download = fileName;
            downloadLink.click();
            Toast.hide();
          }
        }
      }
    }
    catch (error) {
      Toast.hide()
      console.log(error)
      Toast.fail("Error while fetching FP&A Sign-off for monetization content. Please try again!", 3000, () => { });
    }
  };
  

  fetchIdea = async () => {
    try {
      Toast.loading("Fetching Idea & Metadata...", () => { });
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,

        },
      };
      const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&case=data&casetype=fetchIdeaDetails`, requestOptions)
      if (response.ok) {
        const data = await response.json()
        Toast.hide()
        console.log("fetch idea", data);
        if (data) {
          this.setState(
            {
              isIdeaDocUplApproved: data.ResultSets?.Table1[0].ApprovalStatus === "Documents Uploaded" && data.ResultSets?.Table1[0].WorkflowStatus === "Approve",
              isIdeaPending: data.ResultSets?.Table1[0].WorkflowStatus === "Pending", // Code by TR
              ideaItem: data.ResultSets.Table1[0],
              Comment: data.ResultSets.Table1[0].Comment,

              projectDeckFilename: data.ResultSets.Table1[0].ProjectPPTFileName,
              projectFileType: data.ResultSets.Table1[0].ProjectPPTType,
              signOffFilename: data.ResultSets.Table1[0].CustomerSignoffFileName,
              signOffFileType: data.ResultSets.Table1[0].CustomerSignoffType,

              reviewComments: data.ReviewComments,
              finalReviewComments: data.FinalReviewComments,
              campaignName: data.ResultSets.Table1[0].CampaignName,

              businessImpactValueArray: data.BIData ? data.BIData : [],
              qcComments: data.QcComments ? data.QcComments : [],
              qcCommentsWithVD: data.qcCommentsWithVD ? data.qcCommentsWithVD : [],

              IsVDType: data ? data.ResultSets.Table1[0].VDType : "",
              QCOHR: data.ResultSets.Table1[0].QCOHR,
              clusterData: data.ClusterData ? data.ClusterData : [],
              ideasAI: data.IdeasAI ? data.IdeasAI[0] ? data.IdeasAI[0] : [] : [],
         

              // LDT
              LDTLogs: data.LDTLogs ? data.LDTLogs : [],
              

              CodersTable: data.CodersTable ? data.CodersTable : [],
              campaignUnionQuery: data.CampaignDetails.ResultSets.Table1,
              vdForComponent: data.BIData ? data.BIData : [],
            },
            () => {

              if (this.state.campaignUnionQuery) {
                let filteredUnionQuery = this.state.campaignUnionQuery.filter((item) => {
                  return item.CampaignID === this.state.ideaItem.CampaignID
                })
                if (filteredUnionQuery) {
                  if (filteredUnionQuery[0]) {
                    this.setState({
                      campaignInsight: filteredUnionQuery[0].CampaignDescr,
                      campaignSelectedOption: {
                        value: filteredUnionQuery[0].CampaignID,
                        label: filteredUnionQuery[0].Campaign,
                      },
                    }, () => { }
                    );
                  }

                }
                if(this.state.ideaItem?.ApprovalStatus === "Awaiting Project Creation"){
                  this.setState({
                    isAwaitingProjCreation:true
                  },() =>{})
                }

                // from fetch idea if campaign is selected as genai then display genai sub campaign from genai local options or else choose from the union query
                if (this.state.ideaItem.CampaignName === "Gen AI") {
                  GENAIOPTIONS.map((item) => {
                    if (item.label === this.state.ideaItem.SubCampaignName) {
                      this.setState({
                        subCampaignSelectedOption: item,
                        displaySubCampaign: true
                      }, () => {

                      });
                    }
                  });
                } else {
                  // from union query - 
                  let options = [];
                  let result = [];
                  this.state.campaignUnionQuery.map((item) => {
                    if (this.state.ideaItem.CampaignID === item.CampaignID) {
                      if (item.SubCampaign) {
                        options.push({ value: item.SubCampaignID, label: item.SubCampaign });
                      }
                    }
                    return true;
                  });
                  result = options.reduce((unique, index) => {
                    if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
                      unique.push(index);
                    }
                    return unique;
                  }, []);
                  if (result.length > 0) {
                    this.setState({ displaySubCampaign: true }, () => { })
                    result.map((item) => {
                      if (this.state.ideaItem.SubCampaignID === item.value) {
                        this.setState({ subCampaignSelectedOption: item });
                      }
                    })
                  }
                }
              }

              if (this.state.ideaItem.MethodologyName) {
                let localMethodologies = this.state.ideaItem.MethodologyName.replace(/[|,]/g, ", ")
                localMethodologies = localMethodologies.split(",").join(", ");
                this.setState({ methodologies: localMethodologies }, () => { })
              }

              if (this.state.isIdeaDocUplApproved && (parseInt(this.state.ideaItem.OwnerOHR) === parseInt(this.sessionData.profile.oHRId))) {
                this.setState({
                  isIdeaDUAOwner: true
                }, () => {
                  this.setState({
                    blackBeltSelectedOption: {
                      label: this.state.ideaItem.BlackBeltUserName
                    },
                    blackBeltUserEmail: this.state.ideaItem.BlackBeltUserEmail,
                    blackBeltUserId: this.state.ideaItem.BlackBeltUserId,
                    blackBeltUserName: this.state.ideaItem.BlackBeltUserName,
                  })
                  this.fetchBlackBeltOptions()

                })
              } else {
                this.setState({
                  isIdeaDUAOwner: false
                })
              }
              


              if (this.state.ideasAI) {
                if (this.state.ideasAI.IsIdeaReplicable) {
                  this.setState({ isIdeaReplicable: "Yes" }, () => { })
                } else {
                  this.setState({ isIdeaReplicable: "No" }, () => { })
                }
              }
              // Code by TR start
              if (this.state.ideaItem.ModifiedDate) {
                this.setState({
                  onInitPageTime: this.state.ideaItem.ModifiedDate,
                })
              }
              if ((parseInt(this.state.ideaItem.OwnerOHR) === parseInt(this.sessionData.profile.oHRId)) && this.state.isIdeaPending) {
                if (this.state.ideaItem.ReplicationProjectId !== null && this.state.ideaItem.ReplicationProjectId !== undefined) {
                  this.setState({
                    replicationProjectId: this.state.ideaItem.ReplicationProjectId,
                    newOrReplicatedIdea: this.state.ideaItem.NewOrReplicatedIdea
                  });
                }
                this.setState({

                  IdeaOwnerCanEdit: true,
                  accountNameSelectedOption: {
                    label: this.state.ideaItem.AccountManual
                  },
                  accountName: this.state.ideaItem.AccountManual,
                  holdingAccount: this.state.ideaItem.HoldingAccount,
                  verticalSelectedOption: {
                    label: this.state.ideaItem.VerticalManual

                  },
                  verticalManual: this.state.ideaItem.VerticalManual,
                  Unit: this.state.ideaItem.Unit,
                  Segment: this.state.ideaItem.Segment,
                  subVerticalManual: this.state.ideaItem.SubVerticalName,
                  subVerticalSelectedOption: {
                    label: this.state.ideaItem.SubVerticalName
                  },


                  country: this.state.ideaItem.Country,
                  countrySelectedOption: {
                    label: this.state.ideaItem.Country
                  },
                  regionText: this.state.ideaItem.RegionManual,
                  regionManual: this.state.ideaItem.RegionManual,
                  regionSelectedOption: {
                    label: this.state.ideaItem.RegionManual
                  },
                  subRegion: this.state.ideaItem.SubRegion,
                  subRegionSelectedOption: {
                    label: this.state.ideaItem.SubRegion
                  },
                  blackBeltSelectedOption: {
                    label: this.state.ideaItem.BlackBeltUserName
                  },
                  blackBeltUserEmail: this.state.ideaItem.BlackBeltUserEmail,
                  blackBeltUserId: this.state.ideaItem.BlackBeltUserId,
                  blackBeltUserName: this.state.ideaItem.BlackBeltUserName,
                  mbbName: this.state.ideaItem.MBBName,
                  mbbOHR: this.state.ideaItem.MBBOHR,
                  mbbSelectedOption: {
                    label: this.state.ideaItem.MBBName
                  },
                  serviceLineText: this.state.ideaItem.ServiceLineName,
                  subServiceLineText: this.state.ideaItem.SubServiceLine,
                  ServiceLineSelectedOption: {
                    label: this.state.ideaItem.ServiceLineName
                  },
                  subServiceLineSelectedOption: {
                    label: this.state.ideaItem.SubServiceLine

                  },
                  problem: this.state.ideaItem.Problem,
                  solution: this.state.ideaItem.Solution
                }, () => {

                  this.fetchVerticalOptions()
                  this.fetchCountryOptions()
                  this.fetchRegionOptions()
                })
              }
              // Code by TR end

              if (this.state.LDTLogs) {
                var keys = Object.keys(this.state.LDTLogs);
                var last = keys[keys.length - 1];
                if (last) {
                  let varLDTLastComment = this.state.LDTLogs[last].LDTComments;
                  let varLDTLastQBRValue = this.state.LDTLogs[last].IsQBR;
                  let varLDTLastUserName = this.state.LDTLogs[last].UserName;
                  let varLDTLastUserOHR = this.state.LDTLogs[last].UserOHR;
                  let varLDTLastCreatedData = this.state.LDTLogs[last].QBRDate;
                  let formatDate = this.formatDateLatest(varLDTLastCreatedData);
                  let lastSubmittedDate = this.state.LDTLogs[last].CreatedDate
                  this.setState(
                    {
                      QBRDate: formatDate,
                      LDTApproverName: varLDTLastUserName,
                      LDTApproverOHR: varLDTLastUserOHR,
                      ldtApprovalComment: varLDTLastComment,
                      qbrLastSubmittedDate: lastSubmittedDate
                    },
                    () => {

                      if (varLDTLastQBRValue) {
                        if (varLDTLastQBRValue === "Yes") {
                          this.setState({ IsQBR: { value: 0, label: "Yes" } }, () => { })
                        }
                        if (varLDTLastQBRValue === "No") {
                          this.setState({ IsQBR: { value: 0, label: "No" } }, () => { })
                        }

                      }

                    }
                  );
                }

              }
              if (this.state.ideaItem.ReplicabilityIndex) {
                REPLICABILITYOPTIONS.map((item) => {
                  if (item.value === this.state.ideaItem.ReplicabilityIndex) {
                    this.setState({ replicabilityIndex: item }, () => { })
                  }
                })
              }


              if (this.state.clusterData && this.state.clusterData.length > 0) {
                const targetRecID = this.state.ideaItem.LeanID;
                const filteredData = this.state.clusterData.filter(
                  (item) => item.RecAlpha === targetRecID
                );

                let getParentAlpa = "";
                this.state.clusterData.map((item) => {
                  if (item.RecAlpha === targetRecID) {
                    getParentAlpa = item.ParentAlpha;
                  }
                });
                if (getParentAlpa) {
                  this.state.clusterData.map((item) => {
                    if (getParentAlpa === item.RecAlpha) {
                      const selectedOption = {
                        value: 0,
                        label: item.ProjectType,
                      };
                      this.state.projectTypeSelectedOption = selectedOption;
                      this.setState(
                        { projectTypeSelectedOption: selectedOption },
                        () => {
                          console.log(
                            "project type selected option is at callback=>",
                            this.state.projectTypeSelectedOption
                          );
                        }
                      );
                    }
                  });
                }
                console.log("filtered data", filteredData);

                if (
                  filteredData &&
                  filteredData.length > 0 &&
                  filteredData !== undefined &&
                  filteredData !== null
                ) {
                  this.setState(
                    { displayParentAlpha: filteredData[0].ParentAlpha },
                    () => { }
                  );

                  const selectedOption = {
                    value: 0,
                    label: filteredData[0].ParentAlpha,
                  };
                  this.setState(
                    { projectIDSelectedOption: selectedOption },
                    () => {
                      console.log(
                        "project type selected option is ",
                        this.state.projectTypeSelectedOption
                      );
                      if (
                        this.state.projectTypeSelectedOption &&
                        (this.state.projectTypeSelectedOption.label === null ||
                          this.state.projectTypeSelectedOption.label === "")
                      ) {
                        if (
                          this.state.projectIDSelectedOption.label.startsWith(
                            "GB"
                          )
                        ) {
                          const selectedOptionGB = {
                            value: 0,
                            label: "GB",
                          };
                          this.state.projectTypeSelectedOption =
                            selectedOptionGB;
                          this.setState(
                            { projectTypeSelectedOption: selectedOptionGB },
                            () => {
                              //console.log(this.state.projectTypeSelectedOption)
                            }
                          );
                        } else {
                          const selectedOptionBB = {
                            value: 0,
                            label: "BB",
                          };
                          this.state.projectTypeSelectedOption =
                            selectedOptionBB;
                          this.setState(
                            { projectTypeSelectedOption: selectedOptionBB },
                            () => {
                              //console.log(this.state.projectTypeSelectedOption)
                            }
                          );
                        }
                      }
                    }
                  );
                } else {
                  this.setState({ displayParentAlpha: "" }, () => { });
                }
              } else {
                this.setState({ displayParentAlpha: "" }, () => { });
              }

              if (
                parseInt(this.state.ideaItem.OwnerOHR) ===
                parseInt(this.sessionData.profile.oHRId) ||
                parseInt(this.state.ideaItem.BlackBeltUserId) ===
                parseInt(this.sessionData.profile.oHRId)
              ) {
                this.setState({ enableClusterAction: true }, () => { });
              }

              if (this.state.ideaItem.CreatedDate) {
                let created = new Date(this.state.ideaItem.CreatedDate);
                let abc = new Date(DISPLAYPROJECTTHEME);
                if (created.getTime() < abc.getTime()) {
                  this.setState({ displayProjectTheme: true });
                } else {
                  this.setState({ displayProjectTheme: false });
                }
              }

              if (this.state.finalReviewComments.length > 0) {
                var keys = Object.keys(this.state.finalReviewComments);
                var last = keys[keys.length - 1];
                let varFinalLastComment = this.state.finalReviewComments[last].Comment;
                let varLastStatus = this.state.finalReviewComments[last].ApprovalStatus;
                this.setState(
                  {
                    lastFinalComment: varFinalLastComment,
                    lastApprovalStatus: varLastStatus,
                  },
                  () => {
                    if (this.state.lastApprovalStatus === AWAITING_PROJECT_APPROVAL) {
                      this.setState({ lastApprovalStatus: "Approved" });
                    } else {
                      this.setState({ lastApprovalStatus: varLastStatus });
                    }

                  }
                );
              }
              if (this.state.qcComments.length > 0) {
                var keys = Object.keys(this.state.qcComments);
                var last = keys[keys.length - 1];
                let varFinalLastComment = this.state.qcComments[last].Comment;
                this.setState({ lastQCCOmment: varFinalLastComment }, () => { });
              }

              if (this.state.reviewComments.length > 0) {
                let logAction = this.state.reviewComments.slice(-1)[0].Action;
                this.setState({ logAction: logAction }, () => { });
              }

              if (this.state.IsVDType === "" || this.state.IsVDType === null || this.state.IsVDType === undefined) {
                this.setState({ showClientFields: false, showGOLFields: false }, () => { });
              }

            }
          );

        }
      }
    } catch (error) {
      Toast.hide()
      console.log(error)
      Toast.fail("Error while fetching idea. Please try again!", 5000, () => { });
    };
  };

  fetchMetadata = async () => {
    try {
      const param = {
        EntityType: "",
        EntityName: "",
      };
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        },
        body: JSON.stringify(param),
      };
      const response = await fetch(GET_METADATA, requestOptions)
      if (response.ok) {
        const data = await response.json();
        if (data) {
          this.setState(
            {
              adminUserList: data ? data.DataverseUserRole : [],
              businessImpactMasterList: data ? data.BIMasterDataVerseNew : [],
              campaignList: data ? data.Campaigns : [],
              subCampaignList: data ? data.SubCampaigns : [],
              databridgeThemeList: data ? data.DataBridgeThemes : [],

              // Code by TR start
              accountList: data ? data.Accounts.sort((a, b) => { return a.ACCOUNT > b.ACCOUNT ? 1 : -1; }) : [],
              serviceLineList: data ? data.ServiceLines : [],
              subServiceLineList: data ? data.ServiceLines : [],
              // Code by TR end
            },
            () => {
              this.state.adminUserList.map((item) => {
                if (parseInt(this.sessionData.profile.oHRId) === parseInt(item.pg_ohr)) {
                  console.log('item =>', item)
                  let userDataInfo = JSON.parse(item.pg_Role);
                  if (userDataInfo.pg_role === "Administrator") {
                    this.setState({
                      admin: true,
                      adminOHR: parseInt(item.pg_ohr),
                    }, () => { });
                  }
                  this.setState({
                    userRole: userDataInfo.pg_role,
                    userRoleId: userDataInfo.pg_pgroleid,
                  });
                  return false;
                }
                return false;
              });


              if (this.state.displayProjectTheme && this.state.campaignSelectedOption?.label === DATA_BRIDGE_CAMPAIGN) {
                this.state.databridgeThemeList && this.state.databridgeThemeList.map((item) => {
                  if (this.state.ideaItem.DataBridgeTheme === item.DBProjectThemeName) {
                    this.setState({
                      dataBridgeProjectTheme: item.DBProjectThemeName,
                      databridgeThemeSelectedOptions: {
                        value: item.ThemeId,
                        label: item.DBProjectThemeName,
                      },
                    });
                  }
                  return 1;
                });
              }
            }
          );

        }

      }
    } catch (error) {
      Toast.hide()
      console.log(JSON.stringify(error));
      Toast.fail("Error occured while getting metadata idea. Please try again!",3000, () => {});
    }
  };

  saveEvent = () => {
    let redirectURL = "/review-page";
    if (this.state.approvalPage) {
      if (this.state.isViewAllProject) {
        redirectURL = "/view-all-projects-page";
        this.props.history.push({
          pathname: redirectURL,
          propsList: this.state.propsData,
        });
      } else if (this.state.isViewAllIdea) {
        redirectURL = "/view-all-ideas-page";
        this.props.history.push({
          pathname: redirectURL,
          propsList: this.state.propsData,
        });
      } else if (this.state.approvalPage === PROJECT_VIEW) {
        redirectURL = "/list-projects-page";
        // this.props.history.push(redirectURL);
        this.props.history.push({
          pathname: redirectURL,
          propsList: this.state.propsData,
        });
      } else {
        // redirectURL = redirectURL +"?page=" +this.state.approvalPage;
        // this.props.history.push(redirectURL);
        this.props.history.push({
          pathname: redirectURL,
          search: "?page=" + this.state.approvalPage,
          propsList: this.state.propsData,
        });
      }
    } else {
      // this.props.history.push(redirectURL);
      this.props.history.push({
        pathname: redirectURL,
        propsList: this.state.propsData,
      });
    }
  };

  showPPTContent = async () => {
    try {
      Toast.loading("Fetching Project PPT Deck content...", () => { });
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        },
      };
      let projectFileType = this.state.projectFileType;
      const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&${PPT_CONTENT}=true&case=doc`, requestOptions)
      if (response.ok) {
        const data = await response.json();
        if (data) {
          const projectDeckMetadata = data.PPTContent ? data.PPTContent : "";
          const projectContent = "data:" + projectFileType + ";base64," + projectDeckMetadata;
          if (projectContent) {
            const fileData = projectContent;
            const fileName = this.state.projectDeckFilename;
            const newWindow = window.open("");
            const downloadLink = newWindow.document.createElement("a");
            downloadLink.href = fileData;
            downloadLink.download = fileName;
            downloadLink.click();
            Toast.hide();
          }
        }
      }
    } catch (error) {
      console.log(error)
      Toast.hide();
      Toast.fail("Error while fetching Project Deck content. Please try again!", 3000, () => { });
    }
  };

  showSignOffContent = async () => {
    try {
      Toast.loading("Fetching Customer Sign-off content...", () => { });
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        },
      };
      let signoffFileType = this.state.signOffFileType;
      const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&${SIGNOFF_CONTENT}=true&case=doc`, requestOptions)
      if (response.ok) {
        const data = await response.json();
        if (data) {
          const signoffMetadata = data.SignoffContent ? data.SignoffContent : "";
          const signoffContent = "data:" + signoffFileType + ";base64," + signoffMetadata;
          if (signoffContent) {
            var fileData = signoffContent;
            var fileName = this.state.signOffFilename;
            var w = window.open("");
            const downloadLink = w.document.createElement("a");
            downloadLink.href = fileData;
            downloadLink.download = fileName;
            downloadLink.click();
            Toast.hide();

          }
        }
      }
    }
    catch (error) {
      console.log(error)
      Toast.hide();
      Toast.fail("Error fetching Sign-off approval file. Please try again...", 5000, () => { })
    }
  };

  validate = () => {
    let isValid = true;
    let styleStateObj = this.state.selectStyle;
    // Code by TR start
    if (this.state.IdeaOwnerCanEdit) {
      if (this.state.ideaItem.MBBOHR !== null && this.state.ideaItem.MBBName !== null && this.state.mbbSelectedOption === null) {
        isValid = false;
        Toast.fail("Please select MBB.", 3000, () => { })

      }
      if (this.state.newOrReplicatedIdea) {
        if (this.state.replicationProjectId === null || this.state.replicationProjectId === undefined || !this.state.replicationProjectId) {
          isValid = false
          Toast.fail("Please enter replicated ID or switch the toggle", 3000, () => { })
        }
        if ((this.state.ideaItem.ReplicationProjectId !== null && this.state.ideaItem.ReplicationProjectId !== undefined && this.state.ideaItem.ReplicationProjectId !== "") && this.state.ideaItem.ReplicationProjectId !== this.state.replicationProjectId) {
          if (!this.state.replicationIDValidated) {
            isValid = false
            Toast.fail("Please validate the replicated Idea ID by clicking on icon", 3000, () => { })
          }
        }
        if ((this.state.ideaItem.ReplicationProjectId === null ||
          this.state.ideaItem.ReplicationProjectId === undefined ||
          this.state.ideaItem.ReplicationProjectId === "") && this.state.replicationProjectId && !this.state.replicationIDValidated) {
          isValid = false;
          Toast.fail("Please validate the replicated Idea ID by clicking on icon", 3000, () => { });
        }

      }
      if (!this.state.accountNameSelectedOption || this.state.accountNameSelectedOption.label === null ||
        this.state.accountNameSelectedOption.label === undefined || !this.state.accountName) {
        isValid = false;
        console.log("acount failed")

        Toast.fail("Please select account.", 3000, () => { })

      }
      if (!this.state.verticalSelectedOption || this.state.verticalSelectedOption.label === null ||
        this.state.verticalSelectedOption.label === undefined || !this.state.verticalManual) {
        isValid = false;
        console.log("vertical failed")

        Toast.fail("Please select vertical.", 3000, () => { })

      }
      if (!this.state.subVerticalSelectedOption || this.state.subVerticalSelectedOption.label === null ||
        this.state.subVerticalSelectedOption.label === undefined || !this.state.subVerticalManual) {
        isValid = false;
        console.log("subvert failed")

        Toast.fail("Please select sub-vertical.", 3000, () => { })


      }
      
      if (this.state.displaySubCampaign || this.state.campaignSelectedOption?.label === "Gen AI") {
        if (this.state.subCampaignSelectedOption === null || this.state.subCampaignSelectedOption === undefined || !this.state.subCampaignSelectedOption) {
          isValid = false;
          Toast.fail("Please select sub-campaign.", 3000, () => { })
        }
      }
      if (!this.state.campaignSelectedOption || this.state.campaignSelectedOption.label === null || this.state.campaignSelectedOption.label === undefined) {
        isValid = false;
        Toast.fail("Please select campaign.", 3000, () => { })
      }


      if (!this.state.countrySelectedOption || this.state.countrySelectedOption.label === null ||
        this.state.countrySelectedOption.label === undefined || !this.state.country) {
        isValid = false;
        console.log("Country failed")
        Toast.fail("Please select country.", 3000, () => { })

      }
      if (!this.state.regionSelectedOption || this.state.regionSelectedOption.label === null ||
        this.state.regionSelectedOption.label === undefined || !this.state.regionManual) {
        isValid = false;
        console.log("region failed")

        Toast.fail("Please select region.", 3000, () => { })

      }
      if (!this.state.subRegionSelectedOption || this.state.subRegionSelectedOption.label === null ||
        this.state.subRegionSelectedOption.label === undefined || !this.state.subRegion) {
        isValid = false;
        console.log("sub region failed")

        Toast.fail("Please select sub-region.", 3000, () => { })

      }
      if (!this.state.blackBeltSelectedOption || this.state.blackBeltSelectedOption.label === null ||
        this.state.blackBeltSelectedOption.label === undefined || !this.state.blackBeltUserName) {
        isValid = false;
        console.log("bb failed")

        Toast.fail("Please select black belt.", 3000, () => { })

      }
      if (!this.state.ServiceLineSelectedOption || this.state.ServiceLineSelectedOption.label === null ||
        this.state.ServiceLineSelectedOption.label === undefined || !this.state.serviceLineText) {
        isValid = false;
        console.log("service failed")

        Toast.fail("Please select service line.", 3000, () => { })


      }
      if (!this.state.subServiceLineSelectedOption || this.state.subServiceLineSelectedOption.label === null ||
        this.state.subServiceLineSelectedOption.label === undefined || !this.state.subServiceLineText) {
        isValid = false;
        console.log("sub service failed")

        Toast.fail("Please select sub service line.", 3000, () => { })

      }
      if (!this.state.solution) {
        isValid = false;
        console.log("sol failed")

        Toast.fail("Please insert text into solution.", 3000, () => { })


      }
      if (!this.state.problem) {
        isValid = false;
        console.log("prob failed")

        Toast.fail("Please insert text into problem.", 3000, () => { })

      }

      if (!this.state.Unit || this.state.Unit === null ||
        this.state.Unit === undefined) {
        isValid = false;
        console.log("unit failed")

        console.log("Empty Unit")
      }
      if (!this.state.Segment || this.state.Segment === null ||
        this.state.Segment === undefined) {
        isValid = false;
        console.log("segment failed")

        console.log("Empty Segment")

      }
    }

    return isValid;
  };

  handleCommentChange = (e) => {
    let commentChange = e;
    this.setState({
      Comment: commentChange,
    });
  };
  handleTranscriptCancelRequest = (e) => {
    console.log(e);
    let commentChange = e.trim();
    this.setState({
      Comment: commentChange,
    });
  };
  handleTranscriptReinitiateRequest = (e) => {
    let commentChange = e;
    this.setState({
      Comment: commentChange,
    });
  };

  submitEvent = () => {
    if (this.validate()) {
      let param = {};
      if (window.confirm("Are you sure you want to cancel this Idea?")) {
        Toast.loading("Cancellation is in process...", () => { });
        if (this.state.admin) {
          param = {
            OnInitPageTime: this.state.onInitPageTime,
            IdeaId: this.props.location.state,
            ApprovalStatus: this.state.isLeanIdea
              ? CANCEL
              : this.state.ideaItem.ApprovalStatus === "NA"
                ? this.state.ideaItem.ApprovalStatus
                : CANCEL,
            UpdaterOHR: this.sessionData.profile.oHRId,
            UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
            UpdaterName:
              this.sessionData.profile.lastName +
              ", " +
              this.sessionData.profile.firstName,
            comment: this.state.Comment,
            WorkflowStatus: this.state.isLeanIdea
              ? CANCEL
              : this.state.ideaItem.ApprovalStatus === "NA"
                ? CANCEL
                : this.state.ideaItem.WorkflowStatus,
            ProjectStatus: "Admin Cancel",
            Role: this.state.userRole,
            userRoleId: this.state.userRoleId,
            updaterAction: AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION,
            OwnerEmail:this.state.ideaItem.OwnerEmail,
          };
        } else {
          param = {
            OnInitPageTime: this.state.onInitPageTime,

            IdeaId: this.props.location.state,
            ApprovalStatus:
              this.state.ideaItem.ApprovalStatus === "NA"
                ? this.state.ideaItem.ApprovalStatus
                : AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION,
            UpdaterOHR: this.sessionData.profile.oHRId,
            UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
            UpdaterName:
              this.sessionData.profile.lastName +
              ", " +
              this.sessionData.profile.firstName,
            comment: this.state.Comment,
            WorkflowStatus:
              this.state.ideaItem.ApprovalStatus === "NA"
                ? AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION
                : this.state.ideaItem.WorkflowStatus,
            //userRole:"User",
            //userRoleId:this.state.userRoleId,
            Role: "Idea Owner",
            updaterAction: AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION,
            OwnerEmail:this.state.ideaItem.OwnerEmail,
          };
        }
        console.log(param);
        const requestOptions = {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + this.accessToken,
          },
          body: JSON.stringify(param),
        };
        fetch(`${REVIEW_IDEA_URL}`, requestOptions)
          .then((response) => {
            return response.json().then((data) => {
              if (response.status === 409) {
                Toast.fail("This Idea has been updated by another stakeholder. Please open the Idea again to view the latest details.", 5000);

                setTimeout(() => {
                  window.location.href = "/review-page";
                }, 5000);

                return null;
              }

              return data;
            });
          })
          .then((data) => {
            if (!data) {
              return;
            }
            Toast.hide();
            Toast.success(
              this.state.admin
                ? "Idea has been cancelled successfully."
                : "Cancel request sent successfully.",
              3000,
              () => {
                console.log(JSON.stringify(data));
                let redirectURL = "/review-page";
                if (this.state.approvalPage) {
                  redirectURL =
                    redirectURL + "?page=" + this.state.approvalPage;
                }
                window.location = this.state.admin
                  ? "/view-all-ideas-page"
                  : redirectURL;
              }
            );
          });
      }
    } else {
      Toast.fail("Please add reason for cancel request.", 3000, () => { });
    }
  };
  //only for await project creation cancel
  submitEventTwo = () => {
    if(
     ( parseInt(this.state.ideaItem.OwnerOHR) ===
      parseInt(this.sessionData.profile.oHRId)) && this.state.Comment && this.state.Comment !== null && this.state.Comment !== "" && this.state.Comment.length <= 500
    ){
      let param = {};
      if (window.confirm("Are you sure you want to cancel this Idea?")) {
        Toast.loading("Cancellation is in process...", () => { });
          param = {
            OnInitPageTime: this.state.onInitPageTime,
            ProjectStatus:this.state.ideaItem.ApprovalStatus,
            saveType:"Cancelling Project",
            IdeaName:this.state.ideaItem.IdeaName,
            IdeaId: this.props.location.state,
            IdeaIDAlpha :this.state.ideaItem.IdeaIDAlpha,
            OwnerName:this.state.ideaItem.OwnerName,
            OwnerEmail:this.state.ideaItem.OwnerEmail,
            BlackBeltUserEmail: this.state.ideaItem.BlackBeltUserEmail,
            BlackBeltUserName: this.state.ideaItem.BlackBeltUserName,
            IdeaId: this.props.location.state,
            ApprovalStatus: "Awaiting Mentor Approval for Cancellation",
            UpdaterOHR: this.sessionData.profile.oHRId,
            UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
            UpdaterName:
              this.sessionData.profile.lastName +
              ", " +
              this.sessionData.profile.firstName,
            isitalean:false,
            WorkflowStatus:this.state.ideaItem.WorkflowStatus,
        checkifBiContainsProductivityLineItems: false,
            Role: "Idea Owner",
            updaterAction: AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION,
            Comment: this.state.Comment ,      
            OwnerEmail:this.state.ideaItem.OwnerEmail,     
          };
        const requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + this.accessToken,
          },
          body: JSON.stringify(param),
        };
        fetch(`${IDEA_ADMIN_UPDATE}`, requestOptions)
          .then((response) => {
            return response.json().then((data) => {
              return data;
            });
          })
          .then((data) => {
            if (!data) {
              return;
            }
            Toast.hide();
            Toast.success(
                "Cancel request sent successfully.",
              3000,
              () => {
                console.log(JSON.stringify(data));
                let redirectURL = "/review-page";
                if (this.state.approvalPage) {
                  redirectURL =
                    redirectURL + "?page=" + this.state.approvalPage;
                }
                window.location = this.state.admin
                  ? "/view-all-ideas-page"
                  : redirectURL;
              }
            );
          });
      }
    } else {
      if (!this.state.Comment || this.state.Comment.trim() === "") {
        Toast.fail("Please add reason for cancel request.", 3000);
      } else if (this.state.Comment.length > 500) {
        Toast.fail("Comment should not exceed 500 characters.", 3000);
      }
    }
  };
  finalStatus = () => {
    let status = "Pending";
    return status;
  }

  submitIdea = async () => {
    if (this.validate()) {
      let param = {};
      if (window.confirm("Are you sure you want to update the idea ?")) {
        Toast.loading("Updating idea...", () => { });
        const mbbSaveConditon = ((this.state.mbbSelectedOption && this.state.mbbSelectedOption.label !== null) && this.state.ideaItem.MBBName !== null) // Code by TR
        if (this.state.IdeaOwnerCanEdit) {
          param = {
            IdeaId: this.props.location.state,
            IdeaName: this.state.ideaItem.IdeaName,
            Role: "Idea Owner",
            sowID: this.state.sowID,
            fpnaOHR: this.state.fpnaOhr,
            fpnaName: this.state.fpnaName,
            filename1: this.state.filename1,
            // Code by TR start
            ...(mbbSaveConditon && {
              MBBOHR: this.state.mbbSelectedOption.value,
              MBBName: this.state.mbbSelectedOption.label,
            }),
            OnInitPageTime: this.state.onInitPageTime,
            AccountManual: this.state.accountName,
            HoldingAccount: this.state.holdingAccount,
            BlackBeltUserId: Number(this.state.blackBeltUserId),
            BlackBeltUserName: this.state.blackBeltUserName,
            BlackBeltUserEmail: this.state.blackBeltUserEmail,

            CampaignName: this.state.campaignSelectedOption?.label ? this.state.campaignSelectedOption?.label : "",
            CampaignID: this.state.campaignSelectedOption?.value ? this.state.campaignSelectedOption?.value : "",

            ReplicationProjectId: this.state.replicationProjectId,
            NewOrReplicatedIdea: this.state.newOrReplicatedIdea,
            IsReplicationVerified: false,
            Problem: this.state.problem,
            RegionManual: this.state.regionManual,
            SubRegion: this.state.subRegion,
            Country: this.state.country,
            Servicelinetext1: this.state.ideaItem.ServiceLineName,
            Servicelinetext2: this.state.ideaItem.SubServiceLine,
            Solution: this.state.ideaItem.Solution,
            VerticalManual: this.state.verticalManual,
            DataBridgeTheme: this.state.dataBridgeProjectTheme ? this.state.dataBridgeProjectTheme : "",
            SubCampaignName: this.state.subCampaignSelectedOption?.label,
            SubCampaignID: this.state.subCampaignSelectedOption?.value,
            UpdaterOHR: this.sessionData.profile.oHRId,
            UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
            UpdaterName: this.sessionData.profile.lastName + ", " + this.sessionData.profile.firstName,
            PrevWorkflowStatus: this.finalStatus(),
            case: "new",
            WorkflowStatus: this.finalStatus(),
            Unit: this.state.Unit ? this.state.Unit : "",
            Segment: this.state.Segment ? this.state.Segment : "",
            UpdaterRole: "Idea Owner",
            UpdaterAction: "Update",
            casetype: "ideaOwnerCanUpdate",
            IdeaUpdatedUnderDocUploadedOwner: this.state.isIdeaDUAOwner,

            // Code by TR end
          };
        } else if (this.state.isIdeaDUAOwner) {
          param = {
            case: "new",
            IdeaUpdatedUnderDocUploadedOwner: this.state.isIdeaDUAOwner,
            OnInitPageTime: this.state.onInitPageTime,
            IdeaId: this.props.location.state,
            IdeaName: this.state.ideaItem.IdeaName,
            Role: "Idea Owner",
            UpdaterRole: "Idea Owner",
            UpdaterAction: "Update",
            BlackBeltUserId: Number(this.state.blackBeltUserId),
            BlackBeltUserName: this.state.blackBeltUserName,
            BlackBeltUserEmail: this.state.blackBeltUserEmail,
            casetype: "ideaOwnerCanUpdate",
            UpdaterOHR: this.sessionData.profile.oHRId,
            UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
            UpdaterName: this.sessionData.profile.lastName + ", " + this.sessionData.profile.firstName,
            WorkflowStatus: "Approve",
            ApprovalStatus: "Documents Uploaded"
          }
        }

        console.log(param);
        const requestOptions = {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + this.accessToken,
          },
          body: JSON.stringify(param),
        };
        fetch(`${REVIEW_IDEA_URL}`, requestOptions)
          .then((response) => {
            return response.json().then((data) => {
              if (response.status === 409) {
                Toast.fail("This Idea has been updated by another stakeholder. Please open the Idea again to view the latest details.", 5000);

                setTimeout(() => {
                  window.location.href = "/review-page";
                }, 5000);

                return null;
              }

              return data;
            });
          })
          .then((data) => {
            if (!data) {
              return;
            }

            // Code change bh TR
            let msgType = this.state.IdeaOwnerCanEdit ? "Idea" : "Project"   //bug fix stakeholder changes 1
            Toast.hide();
            Toast.success(`${msgType} updated successfully`, 3000, () => {   //bug fix stakeholder changes 1
              // Code change bh TR

              console.log(JSON.stringify(data));
              let redirectURL = "/review-page";
              if (this.state.approvalPage) {
                redirectURL = redirectURL + "?page=" + this.state.approvalPage;
              }
              window.location = redirectURL;
            });
          });
      }
    }
  };

  cancelRequest = () => {
    Toast.info(
      "Once cancelled you cannot have the project reinitiated. You will need to start the project from scratch.",
      5000,
      () => { }
    );
    this.setState({
      cancelRequest: !this.state.cancelRequest,
      Comment: "",
    });
  };

  handleIdeaAction = (ideaId) => {
    this.props.history.push({
      pathname: "/admin-data-edit",
      state: ideaId,
    });
  };

  handleActiveIdeaAction = () => {
    this.setState({
      activeIdea: !this.state.activeIdea,
      Comment: "",
    });
  };

  activeIdeaEvent = () => {
    if (window.confirm("Are you sure you want to reinitiate this Idea?")) {
      Toast.loading("Reinitiating Idea...", () => { });
      let param = {
        IdeaId: this.props.location.state,
        IdeaName: this.state.ideaItem.IdeaName,
        UpdaterOHR: this.sessionData.profile.oHRId,
        UpdaterEmail: this.sessionData.profile.oHRId + "@genpact.com",
        UpdaterName:
          this.sessionData.profile.lastName +
          ", " +
          this.sessionData.profile.firstName,
        WorkflowStatus: this.state.ideaItem.PrevWorkflowStatus,
        ApprovalStatus: this.state.ideaItem.PrevApprovalStatus,
        SaveType: "Update",
        Action: "Active",
        Comment: this.state.Comment,
        updaterAction: "Active",
      };
      console.log("Param", param);
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        },
        body: JSON.stringify(param),
      };
      fetch(`${SUBMIT_IDEA_URL}`, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          Toast.hide();
          Toast.success("Idea reinitiated successfully.", 3000, () => {
            console.log(JSON.stringify(data));
            window.location = "/view-all-ideas-page";
          });
        });
      return false;
    }
  };
  //Code by TR start
  fetchCountryOptions = async () => {
    try {
      Toast.loading("Fetching Account specific Countries. Please wait...", () => { });
      const param = {
        EntityType: "COUNTRY",
        EntityName: this.state.accountName
      }
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.accessToken
        },
        body: JSON.stringify(param)
      };
      const response = await fetch(GET_METADATA, requestOptions)
      if (response.ok) {
        const data = await response.json();
        if (data) {
          Toast.hide();
          let styleStateObj = this.state.selectStyle;
          styleStateObj.country = selectStyle(true);
          this.setState({
            selectStyle: styleStateObj,
            countryList: data.Countries.Table1 !== undefined ? data.Countries.Table1 : [],
            // countrySelectedOption: {
            //     label: data.Countries.Table1[0].Country,
            //     value: data.Countries.Table1[0].Country
            // },
            // country: data.Countries.Table1[0].Country,
          });
        }
      }
    } catch (error) {
      Toast.hide();
      console.log(JSON.stringify(error));
      Toast.fail('Error occured while getting Account specific Country details. Please try again!', 10000, () => {});
    }
  }
  handleProblemChange = (e) => {

    let styleStateObj = this.state.selectStyle;
    let nonWhiteSpace = e.replace(/^\s+|\s+$/gm, '');;
    if (nonWhiteSpace.length < 2000) {
      styleStateObj.problem = textBoxValidation(true);
      this.setState({
        problem: e,
        selectStyle: styleStateObj,
      }, () => {
        this.state.problem.replace(/'/g, "\\'");
      });
    } else {
      const trimmedValue = nonWhiteSpace.slice(0, 2000);
      this.setState({
        problem: trimmedValue,
        selectStyle: styleStateObj,
      }, () => {
        this.state.problem.replace(/'/g, "\\'");
      });
    }
  }
  handleSolutionChange = (e,) => {
    let styleStateObj = this.state.selectStyle;
    let nonWhiteSpace = e.replace(/^\s+|\s+$/gm, '');;
    if (nonWhiteSpace.length < 2000) {
      styleStateObj.solution = textBoxValidation(true);
      this.setState({
        solution: e,
        selectStyle: styleStateObj,
      }, () => {
        this.state.solution.replace(/'/g, "\\'");
      });
    } else {
      const trimmedValue = nonWhiteSpace.slice(0, 2000);
      this.setState({
        solution: trimmedValue,
        selectStyle: styleStateObj,
      }, () => {
        this.state.solution.replace(/'/g, "\\'");
      });
    }
  }

  renderSubServiceLineOptions = () => {
    let options = [];
    this.state.subServiceLineList.map((item) => {
      if (this.state.serviceLineText === item.ServiceLineName) {
        options.push({ value: item.SubServiceLineId, label: item.SubServiceLineName });
        return true;
      }
      return true;
    });
    return options;
  }
  handleSubServiceLineChange = (e) => {
    console.log(e)
    let styleStateObj = this.state.selectStyle;
    styleStateObj.subServiceLineText = selectStyle(true);
    this.setState({
      selectStyle: styleStateObj,
      subServiceLineId: e.value,
      subServiceLineText: e.label,
      subServiceLineSelectedOption: {
        label: e.label,
        value: e.value
      }
    });
  }

  handleServiceLineChange = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.serviceLineText = selectStyle(true);
    this.setState({
      selectStyle: styleStateObj,
      serviceLineId: e.value,
      serviceLineText: e.label,
      ServiceLineSelectedOption: {
        label: e.label,
        value: e.value
      },
      subServiceLineSelectedOption: null
    });
    this.renderSubServiceLineOptions();
  }

  renderServiceLineOptions = () => {
    let options = [];
    const uniqueServiceLineList = [...new Map(this.state.serviceLineList?.map(item =>
      [item.ServiceLineName, item])).values()];
    uniqueServiceLineList.map((item) => {
      options.push({ value: item.ServiceLineId, label: item.ServiceLineName });
      return true;
    });
    return options;
  }
  handleMBBChange = (e) => {
    if (
      parseInt(e.value) === parseInt(this.state.ideaItem.OwnerOHR) ||
      parseInt(e.value) === parseInt(this.state.ideaItem.CreatorOHR)
    ) {
      Toast.fail(
        "Master Black Belt user cannot be the same as Idea Owner/Requester. Please select a different Master Black Belt user.",
        3000,
        () => {
          return;
        }
      );
      return;
    }
    let styleStateObj = this.state.selectStyle;
    styleStateObj.mbbUserName = selectStyle(true);
    this.setState({
      selectStyle: styleStateObj,
      mbbName: e.label,
      mbbOHR: e.value,
      mbbSelectedOption: {
        value: e.value,
        label: e.label,
      },
    });
  };

  // Code change bh TR - sugg by AB
  renderMBBOptions = () => {
    let options = [];
    let result = [];
    this.state.mbbList.map((item) => {
      const userRole = JSON.parse(item.pg_Role).pg_role;
      if (userRole === "MBB") {
        if (this.state.ideaItem.OwnerOHR !== item.pg_ohr) {
          options.push({ value: item.pg_ohr, label: item.pg_username });
        }
      }
      return true;
    });
    result = options.reduce((unique, index) => {
      if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
        unique.push(index);
      }
      return unique;
    }, []);
    return result;
  };

  renderBlackBeltOptions = () => {
    let options = [];
    let result = [];
    this.state.blackbeltList.map((item) => {
      const userRole = JSON.parse(item.pg_Role).pg_role;
      if (userRole === "BB" || userRole === "QA") {
        if (this.state.ownerOHR !== item.pg_ohr) {
          options.push({ value: item.pg_ohr, label: item.pg_username });
        }
      }
      return true;
    });
    result = options.reduce((unique, index) => {
      if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
        unique.push(index);
      }
      return unique;
    }, []);
    return result
  }
  // Code change bh TR - sugg by AB

  handleBlackBeltNameChange = (e) => {
    //let testOHR = (parseInt(this.sessionData.profile.oHRId) === 850051497) ? 850051496 : 850051497;
    if (parseInt(e.value) === parseInt(this.state.creatorOHR)) {
      Toast.fail('Mentor user cannot be the same as Idea Owner/Requester. Please select a different Mentor user.', 3000, () => {
        return;
      });
      return;
    }
    let styleStateObj = this.state.selectStyle;
    styleStateObj.blackBeltUserName = selectStyle(true);
    this.setState({
      selectStyle: styleStateObj,
      blackBeltUserId: e.value,
      //TEST_MODE ? testOHR : e.value,
      blackBeltUserName: e.label,
      blackBeltUserEmail: e.value + "@genpact.com",
      //TEST_MODE ? testOHR + "@genpact.com" : e.value + "@genpact.com",
      blackBeltSelectedOption: {
        value: e.value,
        //TEST_MODE ? testOHR : e.value,
        label: e.label
      }
    });
  }

  fetchVerticalOptions = async () => {
    try {
      Toast.loading("Fetching Verticals. Please wait...", () => { });
      const param = {
        EntityType: "Vertical",
        EntityName: this.state.accountName
      }
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.accessToken
        },
        body: JSON.stringify(param)
      };

      const response = await fetch(GET_METADATA, requestOptions)
      if (response.ok) {
        const data = await response.json();
        if (data) {
          Toast.hide();
          let styleStateObj = this.state.selectStyle;
          styleStateObj.verticalManual = selectStyle(true);
          styleStateObj.subVerticalManual = selectStyle(true);
          this.setState({
            selectStyle: styleStateObj,
            verticalList: data.Table1 !== undefined ? data.Table1 : [],
            verticalSelectedOption: {
              label: data.Table1[0].VERTICAL,
              value: data.Table1[0].VERTICAL
            },
            verticalManual: data.Table1[0].VERTICAL,
            // subVerticalSelectedOption: {
            //     label: data.Table1[0].SUB_VERTICAL,
            //     value: data.Table1[0].SUB_VERTICAL
            // },
            subVerticalManual: data.Table1[0].SUB_VERTICAL,
            subVerticalSelectedOption: {
              label: data.Table1[0].SUB_VERTICAL
            },
            unitsAndSegmentsList: data.Table2 !== undefined ? data.Table2 : [],
          });

          if (this.state.unitsAndSegmentsList) {
            let localUnit = "";
            let localSegment = "";
            this.state.unitsAndSegmentsList.map((item) => {
              if (!(item.VERTICAL.toString().toLowerCase() === "ts")) {
                if (this.state.verticalSelectedOption && this.state.verticalSelectedOption.label === item.VERTICAL) {
                  if (item) {
                    localUnit = item.UNIT;
                    localSegment = item.SEGMENT;
                  }
                }
              }
            })
            this.setState({ Unit: localUnit, Segment: localSegment }, () => { })
          }

          this.renderVerticalOptions();
          this.renderSubVerticalOptions();
          this.setState({
            // subVerticalSelectedOption: {
            //     value: (this.state.subVerticalList.length > 0) ? this.state.subVerticalList[0] : "",
            //     label: (this.state.subVerticalList.length > 0) ? this.state.subVerticalList[0] : ""
            // },
            subVerticalManual: (this.state.subVerticalList.length > 0) ? this.state.subVerticalList[0] : ""
          });
        }
      }
    } catch (error) {
      Toast.hide();
      console.log(JSON.stringify(error));
      Toast.fail('Error occured while getting Vertical details. Please try again!', 5000, () => { });
    }
  }
  handleVerticalChange = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.verticalManual = selectStyle(true);
    this.setState({
      selectStyle: styleStateObj,
      subVerticalSelectedOption: null,
      verticalId: e.value,
      verticalManual: e.label,
      verticalManualId: e.value,
      verticalSelectedOption: {
        value: e.value,
        label: e.label
      }
    }, () => {

      if (this.state.unitsAndSegmentsList) {
        let localUnit = "";
        let localSegment = "";
        this.state.unitsAndSegmentsList.map((item) => {
          if (!(item.VERTICAL.toString().toLowerCase() === "ts")) {
            if (e && e.label === item.VERTICAL) {
              if (item) {
                localUnit = item.UNIT;
                localSegment = item.SEGMENT;
              }
            }
          }
        })
        this.setState({ Unit: localUnit, Segment: localSegment }, () => { })
      }

      this.setState({ subVerticalList: [] });
      this.renderSubVerticalOptions();
      this.setState({
        subVerticalManual: (this.state.subVerticalList.length > 0) ? this.state.subVerticalList[0] : "",
        subVerticalSelectedOption: {
          value: (this.state.subVerticalList.length > 0) ? this.state.subVerticalList[0] : "",
          label: (this.state.subVerticalList.length > 0) ? this.state.subVerticalList[0] : ""
        }
      });
      this.fetchBlackBeltOptions();
    });
  }

  fetchBlackBeltOptions = async() => {
    try {
      // Toast.loading("Fetching Blackbelts. Please wait...", () => { });
      let entityType = "BB";
      let entityName = "";
      if (this.state.isIdeaDUAOwner) {
        entityName = this.state.ideaItem.RegionManual
        if (this.state.ideaItem.RegionManual === "Other Regions") {
          entityType = "BBOTHER";
          entityName = this.state.ideaItem.VerticalManual.replace(" - ", "-")
        }
      } else {
        entityName = this.state.regionText;
        if (this.state.regionText === "Other Regions") {
          entityType = "BBOTHER";
          entityName = this.state.verticalManual.replace(" - ", "-");
        }
      }

      const param = {
        EntityType: entityType,
        EntityName: entityName
      }
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.accessToken
        },
        body: JSON.stringify(param)
      };

      const response = await fetch(`${GET_METADATA}`, requestOptions)
      if (response.ok) {
        const data = await response.json()
        if (data) {
          Toast.hide();
          this.setState({
            blackbeltList: data.DataverseUserRoles !== undefined ? data.DataverseUserRoles : [],
            mbbList: data.DataverseUserRoles !== undefined ? data.DataverseUserRoles : [],
            ldaList: data.DataverseUserRoles !== undefined ? data.DataverseUserRoles : [],
          }, () => {
            Toast.hide();
          });
        }
      }
    }catch(err){
      Toast.hide();
      console.log(JSON.stringify(err));
      Toast.fail('Error occured while fetching BlackBelt details. Please try again!', 15000, () => {});
      
    }
  }

  
  renderSubCampaignOptions = () => {
    if (this.state.campaignSelectedOption?.label === "Gen AI") {
      return GENAIOPTIONS;
    } else {
      let options = [];
      let result = [];
      this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
        if (this.state.campaignSelectedOption?.value === item.CampaignID) {
          options.push({ value: item.SubCampaignID, label: item.SubCampaign });
        }
        return true;
      });
      result = options.reduce((unique, index) => {
        if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
          unique.push(index);
        }
        return unique;
      }, []);
      return result
    }

  }
  handleSubCampaignChange = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.subCampaignSelectedOption = selectStyle(true);
    this.setState({
      selectStyle: styleStateObj,
      subCampaignSelectedOption: e
    });
  }

  renderDataBridgeThemeOptions = () => {
    let options = [];
    this.state.databridgeThemeList && this.state.databridgeThemeList.map((item) => {
      options.push({
        value: item.ThemeId,
        label: item.DBProjectThemeName,
      });
      return options;
    });
    return options;
  };
  handleDataBridgeProjectThemeChange = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.dataBridgeProjectTheme = selectStyle(true);
    this.setState({
      selectStyle: styleStateObj,
      dataBridgeProjectTheme: e.label,
      databridgeThemeSelectedOptions: {
        value: e.label,
        label: e.label,
      },
    });
  };

  renderVerticalOptions = () => {
    let options = [];
    const uniqueVerticals = [...new Map(this.state.verticalList.map(item => [item["VERTICAL"], item])).values()]
    uniqueVerticals.map((item) => {
      //[CR-UAT & CR-POD : 12 Apr 22 : Shweta] Vertical shoud filter out "TS"
      if (!(item.VERTICAL.toString().toLowerCase() === "ts")) {
        options.push({ value: item.VERTICAL, label: item.VERTICAL });
      }
      return true;
    });
    return options;
  }
  handleCampaignNameChange = (e) => {
    if (e.label === "AI First") {
      this.setState({ DisplayAIFirst: true }, () => { })
    } else {
      this.setState({ DisplayAIFirst: false }, () => { })
    }

    let styleStateObj = this.state.selectStyle;
    styleStateObj.campaignSelectedOption = selectStyle(true);

    this.setState({
      dataBridgeProjectTheme: "",
      subCampaignSelectedOption: null,
      selectStyle: styleStateObj,
      campaignSelectedOption: e
    }, () => { });


    // below code will check the union query and will set subcampaign to true if the union query contains the subcampaign query
    let options = [];
    let result = [];
    this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
      if (e.value === item.CampaignID) {
        this.setState({ campaignInsight: item.CampaignDescr }, () => { })
        if (item.SubCampaign) {
          options.push({ value: item.SubCampaignID, label: item.SubCampaign });
        }
      }
      return true;
    });
    result = options.reduce((unique, index) => {
      if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
        unique.push(index);
      }
      return unique;
    }, []);

    if (result.length > 0) {
      this.setState({ displaySubCampaign: true }, () => { })
    } else {
      this.setState({ displaySubCampaign: false }, () => { })
    }

  }
  renderCampaignOptions = () => {
    let options = [];
    let result = [];
    this.state.campaignUnionQuery && this.state.campaignUnionQuery.map((item) => {
      options.push({ value: item.CampaignID, label: item.Campaign });
      return true;
    });
    result = options.reduce((unique, index) => {
      if (!unique.some(obj => obj.label === index.label && obj.value === index.value)) {
        unique.push(index);
      }
      return unique;
    }, []);
    return result
  }
  handleSubVerticalChange = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.subVerticalManual = selectStyle(true);
    this.setState({
      selectStyle: styleStateObj,
      subVerticalManual: e.label,
      subVerticalSelectedOption: {
        value: e.value,
        label: e.label
      }
    });
  }

  renderSubVerticalOptions = () => {
    let options = [];
    this.state.subVerticalList = [];
    this.state.verticalList.map((item) => {
      if (this.state.verticalSelectedOption.label === item.VERTICAL) {
        //[CR-UAT & CR-POD : 12 Apr 22 : Shweta] Industry Vertical shoud filter out "Corporate"
        //[CR-UAT & CR-POD : 29 Apr 22 : Shweta] Industry Vertical shoud filter out "Corporate" except when support is ANYWHERE in account
        // if (item.SUB_VERTICAL.toString().toLowerCase() !== "corporate" || this.state.accountName.toLowerCase().includes("support") )   {
        //     options.push({ value: item.SUB_VERTICAL, label: item.SUB_VERTICAL });
        //     this.state.subVerticalList.push(item.SUB_VERTICAL);
        // }
        options.push({ value: item.SUB_VERTICAL, label: item.SUB_VERTICAL });
        this.state.subVerticalList.push(item.SUB_VERTICAL);
      }
      return true;
    });
    return options;
  }
  renderCountryOptions = () => {
    let options = [];
    this.state.countryList.map((item) => {
      options.push({ value: item.COUNTRY, label: item.COUNTRY });
      return true;
    });
    return options;
  }
  renderRegionOptions = () => {
    let options = [];
    if (this.state.regionList.length > 0) {
      this.state.regionList.map((item) => {
        options.push({ value: item.Region, label: item.Region });
        return true;
      });
    }
    return options;
  }
  renderSubRegionOptions = () => {
    let options = [];
    if (this.state.subRegionList.length > 0) {
      this.state.subRegionList.map((item) => {
        options.push({ value: item.Region, label: item.Region });
        return true;
      });
    }
    return options;
  }
  handleSubRegionChange = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.subRegion = selectStyle(true);
    this.setState({
      selectStyle: styleStateObj,
      subRegion: e.label,
      subRegionSelectedOption: {
        value: e.value,
        label: e.label
      }
    });
  }
  handleRegionChange = (e) => {
    if (e.label === OTHER_REGIONS && (!this.state.verticalManual || this.state.verticalManual === "")) {
      this.setState({
        regionSelectedOption: null
      });
      Toast.fail('Please select Account & Vertical to fetch BlackBelt users for Other Regions.', 3000, () => {
        return;
      });
    } else {
      let styleStateObj = this.state.selectStyle;
      styleStateObj.regionManual = selectStyle(true);
      this.setState({
        selectStyle: styleStateObj,
        regionId: e.value,
        regionManual: e.label,
        regionText: e.label,
        regionManualId: e.value,
        regionSelectedOption: {
          value: e.value,
          label: e.label
        },
        blackBeltSelectedOption: null,
        mbbSelectedOption: null,
      }, () => {
        this.fetchVerticalOptions();
        this.fetchBlackBeltOptions(e);
      });
    }
  }

  fetchRegionOptions = async() => {
    try {
      Toast.loading("Fetching Regions. Please wait...", () => { });
      let entityType = "REGION";
      let entityName = this.state.country + "::" + this.state.accountName;
      // if (this.state.regionText === OTHER_REGIONS) {
      //     entityType = "BBOTHER";
      //     //DNA table has vertical with space around dash (' - ') whereas User Role table has NO space around dash ('-')
      //     entityName = this.state.verticalManual.replace(" - ", "-");
      // }
      const param = {
        EntityType: entityType,
        EntityName: entityName
      }
      const requestOptions = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.accessToken,

        },
        body: JSON.stringify(param)
      };
      const response = await fetch(GET_METADATA, requestOptions)
      if (response.ok) {
        const data = await response.json();
        if (data) {

          Toast.hide();
          let styleStateObj = this.state.selectStyle;
          styleStateObj.regionManual = selectStyle(true);
          styleStateObj.subRegion = selectStyle(true);
          this.setState({
            selectStyle: styleStateObj,
            regionList: data.Region.Table1 !== undefined ? data.Region.Table1 : [],
            regionSelectedOption: {
              label: data.Region.Table1[0].Region,
              value: data.Region.Table1[0].Region
            },
            subRegionList: data.Region.Table1 !== undefined ? data.Region.Table1 : [],
            subRegionSelectedOption: {
              label: data.Region.Table1[0].SubRegion,
              value: data.Region.Table1[0].SubRegion
            },
            regionText: data.Region.Table1[0].Region,
            regionManual: data.Region.Table1[0].Region,
            subRegion: data.Region.Table1[0].SubRegion
          });
          this.fetchBlackBeltOptions();
        }
      }
    } catch (error) {
      console.log(JSON.stringify(error));
      Toast.hide();
      Toast.fail('Error occured while getting Region details. Please try again!', 15000, () => { });
    }
  }

  handleCountryChange = (e) => {
    let styleStateObj = this.state.selectStyle;
    styleStateObj.country = selectStyle(true);
    this.setState({
      selectStyle: styleStateObj,
      country: e.value,
      regionSelectedOption: null,
      subRegionSelectedOption: null,
      blackBeltSelectedOption: null,
      mbbSelectedOption: null,
      countrySelectedOption: {
        value: e.value,
        label: e.label
      }
    }, () => {
      //this.fetchVerticalOptions();
      this.fetchRegionOptions(e);
    });
  }
  renderAccountOptions = () => {
    let options = [];
    let accountName = "";
    this.state.accountList.map((item) => {
      accountName = item.ACCOUNT.toString().toLowerCase();
      //[CR-UAT & CR-POD : 12 Apr 22 : Shweta] Account list filter out starts with unidentified, unmapped, genpact
      if (!(accountName.startsWith("unidentified") || accountName.startsWith("unmapped") || accountName.startsWith("genpact"))) {
        options.push({
          value: item.ACCOUNT_L2,
          label: item.ACCOUNT
        })
      }
      return true;
    });
    return options;
  }

  handleAccountNameChange = (e) => {
    // this.state.verticalList = [];
    // this.state.verticalSelectedOption = null;
    // this.state.subVerticalSelectedOption = null;
    this.setState({
      verticalList: [],
      verticalSelectedOption: null,
      subVerticalSelectedOption: null,
      regionSelectedOption: null,
      subRegionSelectedOption: null,
      countrySelectedOption: null,
      blackBeltSelectedOption: null,
      mbbSelectedOption: null,
      ldaSelectedOption: null,
      accountId: e.value,
      accountName: e.label,
      accountNameSelectedOption: {
        label: e.label,
        value: e.value
      },
      holdingAccount: e.value
    },
      () => {
        let styleStateObj = this.state.selectStyle;
        styleStateObj.accountName = selectStyle(true);
        this.setState({
          selectStyle: styleStateObj
        });
        //console.log("Vertical:" + this.state.verticalSelectedOption.label);
        this.fetchVerticalOptions();
        this.fetchCountryOptions();
      }, () => {
        this.renderVerticalOptions();
        this.renderCountryOptions();
      });
  }
  // Code by TR end
  renderLeanIdeaOptions = () => {
    let options = [];
    this.state.leanIdeaSelectedOptionList.map((item) => {
      options.push({
        value: item.value,
        label: item.label,
      });
      return options;
    });
    return options;
  };

  handleLeanIdea = (e) => {
    this.setState(
      {
        leanIdea: e.label,
        leanIdeaSelectedOption: {
          value: e.value,
          label: e.label,
        },
      },
      () => {
        if (this.state.leanIdea === "Lean+Idea") {
          this.setState({ isLeanIdea: true });
        }
      }
    );
  };

  toggleTranscriptFunction = (id) => {
    this.setState({ speechModal: !this.state.speechModal, modalIndex: id });
    if (id === 3) {
      // On cancel request comment
      if (this.state.Comment) {
        this.setState({ previousTextForSpeech: this.state.Comment }, () =>
          console.log(this.state.previousTextForSpeech)
        );
      } else {
        this.setState({ previousTextForSpeech: "" }, () =>
          console.log(this.state.previousTextForSpeech)
        );
      }
    }

    if (id === 4) {
      // On Reinitiate idea
      if (this.state.Comment) {
        this.setState({ previousTextForSpeech: this.state.Comment }, () =>
          console.log(this.state.previousTextForSpeech)
        );
      } else {
        this.setState({ previousTextForSpeech: "" }, () =>
          console.log(this.state.previousTextForSpeech)
        );
      }
    }
  };

  closeModalFunction = () => {
    this.setState({ speechModal: false });
  };
  
  newBusinessImpactSummary() {
    let myArray = [...this.state.businessImpactValueArray];
    const groupedData = myArray.reduce((accumulator, currentValue) => {
      const impactType = currentValue.impactType;
      const monetizableType = currentValue.monetizableType;
      const fteValue = parseFloat(currentValue.fteValue) || 0.0;
      const dollarValue = parseFloat(currentValue.dollarValue) || 0.0;

      const existingRow = accumulator.find(
        (row) =>
          row.impactType === impactType &&
          row.monetizableType === monetizableType
      );
      if (existingRow) {
        existingRow.fteValue += fteValue;
        existingRow.dollarValue += dollarValue;
      } else {
        accumulator.push({
          impactType,
          monetizableType,
          fteValue,
          dollarValue,
        });
      }
      return accumulator;
    }, []);
    this.setState({ summaryArray: groupedData }, () => { });
    this.setState(
      { businessImpactValueArray: this.state.businessImpactValueArray },
      () => { }
    );
    this.setState({ isFpnaRequired: false }, () => { });
    this.state.businessImpactValueArray &&
      this.state.businessImpactValueArray.map((item) => {
        if (item.ImpactType === "Impact at Genpact") {
          if (
            item.MonetizableType === "Increase in Revenue" ||
            item.MonetizableType === "Reduction in Cost"
          ) {
            this.setState({ isFpnaRequired: true }, () => { });
          }
        }
      });
  }

  pull_data = ({ businessImpactValueArray, dollarTotal, fteTotal }) => {
    if (businessImpactValueArray) {
      this.setState(
        { businessImpactValueArray: businessImpactValueArray },
        () => {
          this.newBusinessImpactSummary();
        },
        () => { }
      );
    }
    if (dollarTotal) {
      this.setState({ finalImpactDollar: dollarTotal }, () => { });
    }
    if (fteTotal) {
      this.setState({ finalImpactFTE: fteTotal }, () => { });
    }
  };
  pull_data_for_delete = ({
    businessImpactValueArray,
    dollarTotal,
    fteValue,
  }) => {
    if (businessImpactValueArray) {
      this.setState(
        { businessImpactValueArray: businessImpactValueArray },
        () => {
          this.newBusinessImpactSummary();
        }
      );
    }
    if (dollarTotal) {
      this.setState({ finalImpactDollar: dollarTotal }, () => {
        console.log(
          "inside call back function $ total",
          this.state.finalImpactDollar
        );
      });
    }
    if (fteValue) {
      this.setState({ finalImpactFTE: fteValue }, () => {
        console.log(
          "inside call back function fte value",
          this.state.finalImpactFTE
        );
      });
    }
  };
  pull_file_data = ({
    fileName,
    fileType,
    fileContent,
    showClientApprovalFields,
    FPnAOHRMonetization,
  }) => {
    if (fileName) {
      this.setState({ FPnAFileNameMonetization: fileName }, () => { });
    }
    if (fileType) {
      this.setState({ FPnAFileTypeMonetization: fileType }, () => { });
    }
    if (fileContent) {
      this.setState({ FPnAFileMonetization: fileContent }, () => { });
    }
    this.setState(
      { showClientApprovalFields: showClientApprovalFields },
      () => { }
    );
    this.setState({ FPnAOHRMonetization: FPnAOHRMonetization }, () => {
      // console.log("ohr from pull_file_data function =>",this.state.FPnAOHRMonetization)
    });
  };
  remove_bi_data_after_delete = (filteredIdeaArray) => {
    //console.log("bi recieved in pull data for delete function",filteredIdeaArray)
    if (filteredIdeaArray) {
      this.setState({ businessImpactValueArray: filteredIdeaArray }, () => {
        this.newBusinessImpactSummary();
        let dollarTotal = 0.0;
        let fteValue = 0.0;
        this.state.businessImpactValueArray.map((item) => {
          if (item && item.DollarImpact) {
            dollarTotal += parseFloat(item.DollarImpact);
          }
          if (item && item.dollarValue) {
            dollarTotal += parseFloat(item.dollarValue);
          }
          if (item && item.FTEImpact) {
            fteValue += parseFloat(item.FTEImpact);
          }
          if (item && item.fteValue) {
            fteValue += parseFloat(item.fteValue);
          }
        });
        this.setState({ finalImpactDollar: dollarTotal }, () => {
          //console.log("inside call back function $ total",this.state.finalImpactDollar)
        });
        this.setState({ finalImpactFTE: fteValue }, () => {
          // console.log("inside call back function fte value",this.state.finalImpactFTE)
        });
      });
    }
  };

  pull_monetization_sowId = (localSowId) => {
    this.setState({ SowID: localSowId }, () => {
      //console.log("sow id from pull_monetization_sowId function =>",this.state.SowID)
    });
  };
  pull_monetization_fpna_name = (localFpnaName) => {
    //console.log("fpna name from pull file function => ",localFpnaName)
    this.setState({ FPnANameMonetization: localFpnaName }, () => {
      //console.log("fpna name from pull_file_function",this.state.FPnANameMonetization)
    });
  };
  pull_monetization_fpna_ohr = (localFpnaohr) => {
    //console.log("fpna ohr from pull function => ",localFpnaohr)
    this.setState({ FPnAOHRMonetization: localFpnaohr }, () => { });
  };
  pull_monetizedTotal = ({ fteValue, dollarValue }) => {
    if (fteValue) {
      this.setState({ totalMonetizedDollar: fteValue }, () => {
        //console.log(this.state.totalMonetizedDollar)
      });
    }
    if (dollarValue) {
      this.setState({ totalMonetizedFTE: dollarValue }, () => {
        //console.log(this.state.totalMonetizedFTE)
      });
    }
  };
  pull_monetizableProject = (e) => {
    if (e) {
      this.setState({ monetizableProjectSelectedOption: e }, () => {
        //console.log("monetization project Option =>",this.state.monetizableProjectSelectedOption)
      });
    }
  };
  pull_monetizableStatus = (e) => {
    
    this.setState({ monetizationStatusSelectedOption: e }, () => {
      
    });
  };

  handleVDTypeChange = (e) => {
    if (e) {
      this.setState({ impactOptionSelected: e }, () => {});
    }
  };
  fetchFPAOHRforIncreaseInRevenue = (e) => {
    if (e === true) {
      this.setState({ appropriateAttachment: true }, () => { });
    } else {
      this.setState({ appropriateAttachment: false }, () => { });
    }
  };

  pullMonetizationGOLName = (localGOLName) => {
    this.setState({ golMonetizationName: localGOLName }, () => {
      //console.log(this.state.golMonetizationName)
    });
  };
  pullMonetizationGOLOhr = (localGOLOhr) => {
    this.setState({ golMonetizationOhr: localGOLOhr }, () => {
      //console.log(this.state.golMonetizationOhr)
    });
  };
  // function for FPNAGOL component starts here

  // ppt deck file details
  pullPPTDeck = (fileName, fileType, fileContent) => {
    this.setState(
      { filename1: fileName, fileType1: fileType, base64File1: fileContent },
      () => {
        //console.log("filename ",this.state.filename1, "file type ",this.state.fileType1, "content ",this.state.base64File1)
      }
    );
  };
  pullClientDocName = (fileName) => {
    this.setState({ signOffFilename: fileName }, () => {
      //console.log("client approval name =>",this.state.signOffFilename)
    });
  };
  pullClientDocType = (fileType) => {
    if (fileType) {
      this.setState({ signOffFileType: fileType }, () => {
        //console.log("client approval type =>",this.state.signOffFileType)
      });
    }
  };
  pullClientDocContent = (fileContent) => {
    if (fileContent) {
      this.setState({ signOffContent: fileContent }, () => {
        //console.log("client approval contnet =>",this.state.signOffContent)
      });
    }
  };

  // gol file details
  pullgolFileName = (fileName) => {
    this.setState({ filename3: fileName }, () => {
      //console.log("gol approval doc name",this.state.filename3)
    });
  };
  pullgolFileType = (fileType) => {
    this.setState({ fileType3: fileType }, () => {
      //console.log("gol approval doc type",this.state.fileType3)
    });
  };
  pullgolContent = (fileContent) => {
    this.setState({ base64File3: fileContent }, () => {
      //console.log("gol approval doc content",this.state.base64File3)
    });
  };

  // fpna file details
  pullfpnafileName = (fileName) => {
    if (fileName) {
      this.setState({ filename4: fileName }, () => {
        //console.log("fpna doc name",this.state.filename4)
      });
    }
  };
  pullfpnafileType = (fileType) => {
    if (fileType) {
      this.setState({ fileType4: fileType }, () => {
        //console.log("fpna doc type",this.state.fileType4)
      });
    }
  };
  pullfpnafileContent = (fileContent) => {
    if (fileContent) {
      this.setState({ base64File4: fileContent }, () => {
        //console.log("fpna doc file content",this.state.base64File4)
      });
    }
  };

  pullClientName = (e) => {
    if (e) {
      this.setState({ clientName: e }, () => {
        //console.log(this.state.clientName)
      });
    }
  };
  pullClientRole = (e) => {
    if (e) {
      this.setState({ clientRole: e }, () => {
        //console.log(this.state.clientRole)
      });
    }
  };
  pullClientSignOff = (e) => {
    if (e) {
      this.setState({ clientSignOffDate: e }, () => {
        //console.log(this.state.clientSignOffDate)
      });
    }
  };
  pullFpnaName = (name) => {
    if (name) {
      this.setState({ fpnaName: name }, () => {
        //console.log(this.state.fpnaName)
      });
    }
  };
  pullGolName = (name) => {
    if (name) {
      this.setState({ golFullname: name }, () => {
        //console.log(this.state.golFullname)
      });
    }
  };
  pullFpnaOhr = (e) => {
    if (e) {
      this.setState({ fpnaOhr: e }, () => {
        //console.log(this.state.fpnaOhr)
      });
    }
  };
  pullGolOhr = (e) => {
    if (e) {
      this.setState({ golOhr: e }, () => {
        //console.log(this.state.golOhr)
      });
    }
  };
  pull_fileDetails = (obj) => {
    this.setState({ golFpnaFileDetails: obj }, () => {
      //console.log(this.state.golFpnaFileDetails)
    });
  };

  // function for FPNAGOL component ends here

  // clustering function starts here

  showClusterModal = () => {
    if (
      this.state.ideaItem.LeanID !== "" ||
      this.state.ideaItem.LeanID !== null ||
      this.state.ideaItem.LeanID !== undefined ||
      !this.state.ideaItem.LeanID
    ) {
      this.setState({
        clusterModal: !this.state.clusterModal,
      });
    }
  };
  changeProjectType = (e) => {
    this.setState({ projectIDSelectedOption: null }, () => { });
    if (e) {
      this.setState({ projectTypeSelectedOption: e }, () => {
        Toast.loading("Fetching Cluster Projects...", () => { });
        const requestOptions = {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "Bearer " + this.accessToken,
          },
        };
        let encodedAccount = encodeURIComponent(
          this.state.ideaItem.AccountManual
        );
        let encodedVertical = encodeURIComponent(
          this.state.ideaItem.VerticalManual
        );
        fetch(
          `${GET_IDEA_URL}Account=${encodedAccount}&Vertical=${encodedVertical}&ProjectType=${this.state.projectTypeSelectedOption.label}&IdeaId=${this.state.ideaItem.IdeaId}&case=data&casetype=fetchclusterprojects&mucid=muc001`,
          requestOptions
        )
          .then((response) => response.json())
          .then((data) => {
            console.log("fetch cluster data on project type change ", data);
            this.setState(
              {
                clustorProjects: data.ClusterProjects,
              },
              () => { }
            );
            Toast.hide();
          })
          .catch((error) => {
            Toast.fail(
              "Error while fetching cluster projects. Please try again!",
              3000,
              () => { }
            );
            Toast.hide();
            console.log(error);
          });
      });
    }
  };

  displayProjectID = () => {
    if (this.state.clustorProjects) {
      let options = [];
      if (this.state.clusterOptionSearched) {
        this.state.clustorProjects.map((item, index) => {
          options.push({
            value: index,
            Display: item.pg_projectid,
            label: item.pg_projectid + " - " + item.pg_projowner,
          });
        });
      } else {
        this.state.clustorProjects.map((item, index) => {
          if (index < 19) {
            options.push({
              value: index,
              Display: item.pg_projectid,
              label: item.pg_projectid + " - " + item.pg_projowner,
            });
          }
        });
      }
      return options;
    }
  };

  handleClusterProjectInputChange = (inputValue) => {
    if (inputValue && inputValue.length > 0) {
      this.setState({ clusterOptionSearched: true }, () => { });
    } else {
      this.setState({ clusterOptionSearched: false }, () => { });
    }
  };

  changeProjectID = (e) => {
    if (e) {
      // let splitingValue = e.label;
      // const [id, name] = splitingValue.split(' - ');
      // let options = [];
      // options.push({
      //     value: e.value,
      //     Display: id,
      //     label: e.label,
      // });
      this.setState(
        { projectIDSelectedOption: e, isClusterSaveDisabled: false },
        () => {
          console.log(
            "selected project type at change project ID",
            this.state.projectIDSelectedOption
          );
          this.state.clustorProjects.map((item, index) => {
            if (
              item.pg_projectid === this.state.projectIDSelectedOption.Display
            ) {
              console.log(
                "matched item at change project ID",
                item.pg_projectid
              );
              this.setState({ guid: item.msdyn_projectid }, () => { });
            }
          });
        }
      );
    }
  };

  saveParentLink = async () => {
    const createdDate = new Date(this.state.ideaItem.CompleteDate);
    const currentDate = new Date();
    const differenceInMilliseconds = currentDate - createdDate;
    const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
    if (
      differenceInDays > 90 &&
      this.state.ideaItem.ApprovalStatus &&
      this.state.ideaItem.ApprovalStatus === COMPLETE_STATUS
    ) {
      Toast.fail(
        "The parent project cannot be updated because it was completed more than three months ago",
        3000,
        () => { }
      );
      return false;
    } else {
      if (
        this.state.ideaItem.ApprovalStatus &&
        (this.state.ideaItem.ApprovalStatus !== "Rejected" ||
          this.state.ideaItem.ApprovalStatus !== CANCEL) &&
        this.state.projectTypeSelectedOption &&
        this.state.projectIDSelectedOption
      ) {
        if (
          window.confirm(
            "Are you sure you'd like to add Project ID: " +
            this.state.projectIDSelectedOption.Display +
            " as the Parent Project ID?"
          )
        ) {
          if (
            parseInt(this.state.ideaItem.OwnerOHR) ===
            parseInt(this.sessionData.profile.oHRId) ||
            parseInt(this.state.ideaItem.BlackBeltUserId) ===
            parseInt(this.sessionData.profile.oHRId)
          ) {
            if (
              this.state.projectTypeSelectedOption &&
              this.state.projectIDSelectedOption
            ) {
              Toast.loading("Linking...", () => { });
              let param = {
                case: "new",
                casetype: "updatecluster",
                ParentProjectType: this.state.projectTypeSelectedOption
                  ? this.state.projectTypeSelectedOption.label
                  : "",
                RecID: this.props.location.state,
                RecAlpha: this.state.ideaItem.LeanID,
                ParentRecID: this.state.guid,
                ParentAlpha: this.state.projectIDSelectedOption
                  ? this.state.projectIDSelectedOption.Display
                  : "",
                UpdatedByName: this.sessionData
                  ? this.sessionData.profile.lastName +
                  ", " +
                  this.sessionData.profile.firstName
                  : "",
                UpdatedByOHR: this.sessionData
                  ? this.sessionData.profile.oHRId
                  : " ",
                Vertical: this.state.ideaItem
                  ? this.state.ideaItem.VerticalManual
                  : "",
                Account: this.state.ideaItem
                  ? this.state.ideaItem.AccountManual
                  : "",
              };
              console.log(param);
              const requestOptions = {
                method: "PUT",
                headers: {
                  "Content-Type": "application/json",
                  "Authorization": "Bearer " + this.accessToken,
                },
                body: JSON.stringify(param),
              };
              fetch(
                `${DELEGATE_IDEA_URL}`,
                requestOptions
              )
                .then((response) => response.json())
                .then((data) => {
                  Toast.success("Parent linked successfully!", 5000, () => {
                    this.setState({
                      clusterModal: !this.state.clusterModal,
                    });
                    this.updateClusterData();
                  });
                  this.setState({ isClusterSaveDisabled: true }, () => { });
                })
                .catch((error) => {
                  console.log(error);
                  Toast.fail("Parent linked failed", 3000, () => { });
                });
            } else {
              Toast.fail(
                "Please select project type & project ID",
                3000,
                () => { }
              );
            }
          } else {
            Toast.fail(
              "Only idea owner & idea BB can link the ideas",
              3000,
              () => { }
            );
          }
        }
      } else {
        Toast.fail("Rejected ideas cannot be linked.", 3000, () => { });
      }
    }
  };
  removeParentFunc = () => {
    const createdDate = new Date(this.state.ideaItem.CompleteDate);
    const currentDate = new Date();
    const differenceInMilliseconds = currentDate - createdDate;
    const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
    if (
      differenceInDays > 90 &&
      this.state.ideaItem.ApprovalStatus &&
      this.state.ideaItem.ApprovalStatus === COMPLETE_STATUS
    ) {
      Toast.fail(
        "The parent project cannot be updated because it was completed more than three months ago",
        3000,
        () => { }
      );
      return false;
    } else {
      if (
        this.state.ideaItem.ApprovalStatus &&
        (this.state.ideaItem.ApprovalStatus !== "Rejected" ||
          this.state.ideaItem.ApprovalStatus !== CANCEL)
      ) {
        if (
          parseInt(this.state.ideaItem.OwnerOHR) ===
          parseInt(this.sessionData.profile.oHRId) ||
          parseInt(this.state.ideaItem.BlackBeltUserId) ===
          parseInt(this.sessionData.profile.oHRId)
        ) {
          if (!this.state.clusterData || this.state.clusterData.length === 0) {
            if (
              (this.state.projectTypeSelectedOption === null ||
                this.state.projectTypeSelectedOption === undefined ||
                !this.state.projectTypeSelectedOption) &&
              (this.state.projectIDSelectedOption === null ||
                this.state.projectIDSelectedOption === undefined ||
                !this.state.projectIDSelectedOption)
            ) {
              Toast.fail(
                "Only linked ideas can only be removed",
                3000,
                () => { }
              );
            }
          }
          if (this.state.clusterData && this.state.clusterData.length > 0) {
            if (
              this.state.projectTypeSelectedOption &&
              this.state.projectIDSelectedOption
            ) {
              if (
                window.confirm(
                  "Are you sure you'd like to remove Project ID: " +
                  this.state.projectIDSelectedOption.label +
                  " as the Parent Project ID?"
                )
              ) {
                Toast.loading("Removing parent link...", () => { });
                let param = {
                  case: "new",
                  casetype: "updatecluster",
                  RecID: this.props.location.state,
                  RecAlpha: this.state.ideaItem.LeanID,
                  ParentRecID: "",
                  ParentAlpha: "",
                  ParentProjectType: "",
                  UpdatedByName: this.sessionData
                    ? this.sessionData.profile.lastName +
                    ", " +
                    this.sessionData.profile.firstName
                    : "",
                  UpdatedByOHR: this.sessionData
                    ? this.sessionData.profile.oHRId
                    : " ",
                  Vertical: this.state.ideaItem
                    ? this.state.ideaItem.VerticalManual
                    : "",
                  Account: this.state.ideaItem
                    ? this.state.ideaItem.AccountManual
                    : "",
                };
                console.log(param);
                const requestOptions = {
                  method: "PUT",
                  headers: {
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + this.accessToken,
                  },
                  body: JSON.stringify(param),
                };
                fetch(
                  `${DELEGATE_IDEA_URL}`,
                  requestOptions
                )
                  .then((response) => response.json())
                  .then((data) => {
                    Toast.success("Parent unlinked successfully!", 3000, () => {
                      this.setState({
                        clusterModal: !this.state.clusterModal,
                      });
                    });
                    this.updateClusterData();
                    this.setState(
                      {
                        projectTypeSelectedOption: null,
                        projectIDSelectedOption: null,
                      },
                      () => { }
                    );
                  })
                  .catch((error) => {
                    console.log(error);
                    Toast.fail("Parent unlinked failed", 3000, () => { });
                  });
              }
            }
          }
        } else {
          Toast.fail(
            "Only idea owner & idea BB can unlink the ideas",
            3000,
            () => { }
          );
        }
      } else {
        Toast.fail(
          "Rejected ideas cannot be unlinked / removed.",
          3000,
          () => { }
        );
      }
    }
  };
  updateClusterData = async () => {
    try {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        },
      };
      const response = await fetch(`${GET_IDEA_URL}IdeaId=${this.props.location.state}&case=data&casetype=fetchIdeaDetails`, requestOptions)
      if (response.ok) {
        const data = await response.json();
        if (data) {
          this.setState(
            {
              ideaItem: data.ResultSets.Table1[0],
              clusterData: data.ClusterData ? data.ClusterData : [],
            },
            () => {
              if (this.state.clusterData && this.state.clusterData.length > 0) {
                const targetRecID = this.state.ideaItem.LeanID;
                const filteredData = this.state.clusterData.filter(
                  (item) => item.RecAlpha === targetRecID
                );

                let getParentAlpa = "";
                this.state.clusterData.map((item) => {
                  if (item.RecAlpha === targetRecID) {
                    getParentAlpa = item.ParentAlpha;
                  }
                });

                if (getParentAlpa) {
                  this.state.clusterData.map((item) => {
                    if (getParentAlpa === item.RecAlpha) {
                      const selectedOption = {
                        value: 0,
                        label: item.ProjectType,
                      };
                      this.state.projectTypeSelectedOption = selectedOption;
                      this.setState(
                        { projectTypeSelectedOption: selectedOption },
                        () => { }
                      );
                    }
                  });
                }
                if (
                  filteredData &&
                  filteredData.length > 0 &&
                  filteredData !== undefined &&
                  filteredData !== null &&
                  filteredData !== ""
                ) {
                  this.setState(
                    { displayParentAlpha: filteredData[0].ParentAlpha },
                    () => { }
                  );
                  const selectedOption = {
                    value: 0,
                    label: filteredData[0].ParentAlpha,
                  };
                  this.setState(
                    { projectIDSelectedOption: selectedOption },
                    () => {
                      if (
                        this.state.projectTypeSelectedOption &&
                        (this.state.projectTypeSelectedOption.label === null ||
                          this.state.projectTypeSelectedOption.label === "")
                      ) {
                        if (
                          this.state.projectIDSelectedOption.label.startsWith(
                            "GB"
                          )
                        ) {
                          const selectedOptionGB = {
                            value: 0,
                            label: "GB",
                          };
                          this.state.projectTypeSelectedOption = selectedOptionGB;
                          this.setState(
                            { projectTypeSelectedOption: selectedOptionGB },
                            () => { }
                          );
                        } else {
                          const selectedOptionBB = {
                            value: 0,
                            label: "BB",
                          };
                          this.state.projectTypeSelectedOption = selectedOptionBB;
                          this.setState(
                            { projectTypeSelectedOption: selectedOptionBB },
                            () => { }
                          );
                        }
                      }
                    }
                  );
                } else {
                  this.setState({ displayParentAlpha: "" }, () => { });
                }
              } else {
                this.setState({ displayParentAlpha: "" }, () => { });
              }
            }
          );

        }
      }


    }
    catch (error) {
      console.log(error)

      Toast.hide();
      Toast.fail("Error while fetching idea. Please try again!", 3000, () => { });

    }
  }
  // clustering function ends here

  getStatus = () => {
    if (this.state.ideaItem.WorkflowStatus) {
      let IDEA_APPROVED = this.state.ideaItem.WorkflowStatus === "Approve";
      let IDEA_REJECTED = this.state.ideaItem.WorkflowStatus === "Reject";
      let IDEA_SEND_BACK = this.state.ideaItem.WorkflowStatus === "Send Back";
      let IDEA_REQUEST_CANCELLATION =
        this.state.ideaItem.WorkflowStatus === AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION;
      let IDEA_REQUEST_CANCELLATION1 =
        this.state.ideaItem.ApprovalStatus === AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION;
      let IDEA_CANCELLED = this.state.ideaItem.WorkflowStatus === CANCEL;
      let IDEA_CANCELLED1 = this.state.ideaItem.ApprovalStatus === CANCEL;

      if (IDEA_APPROVED) return APPROVED;
      if (IDEA_REJECTED) return REJECTED;
      if (IDEA_SEND_BACK) return SENT_BACK;
      if (IDEA_REQUEST_CANCELLATION || IDEA_REQUEST_CANCELLATION1) {
        return AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION;
      }
      if (IDEA_CANCELLED || IDEA_CANCELLED1) return CANCEL;
      
      if (this.state.ideaItem.Comment !== null) {
        if (this.state.logAction === "Idea Reinitiated by Admin") {
          return "Idea Reinitiated";
        } else {
          if (this.state.logAction === "Idea was reviewed") {
            if (this.state.reviewComments) {
              let updaterActionStatus = this.state.reviewComments.slice(-1)[0].UpdaterAction;
              return updaterActionStatus;
            }
          }
          return this.state.ideaItem.WorkflowStatus
          // else {
          //   return "Discard Cancellation";
          // }
        }
      }

      return PENDING;
    }
  };

  handleAIDocumentClick = (link) => {
    window.open(link, "_blank");
  }

  // LDT lead function starts here
  handleIsQBRChange = (e) => {
    return new Promise((resolve, reject) => {
      let showWarningMessageForOthers = false;
      Toast.loading("Fetching LDT Details", () => { })
      let sessionData = localStorage.getItem(USER_DATA) ? JSON.parse(localStorage.getItem(USER_DATA)) : "";
      const param = {
        EntityType: "OHR",
        EntityName: sessionData ? sessionData.profile ? sessionData.profile.oHRId : "" : "",
      };
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": "Bearer " + this.accessToken,
        },
        body: JSON.stringify(param),
      };
      fetch(GET_METADATA, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          const filteredData = data.PowerAppUsers.filter((item) => {
            const userRole = JSON.parse(item.pg_Role).pg_role;
            return userRole === "LDT Lead" || this.state.admin;
          });
          if (filteredData.length === 0) {
            showWarningMessageForOthers = true
          }
          data.PowerAppUsers.filter((item) => {
            const userRole = JSON.parse(item.pg_Role).pg_role;
            if (userRole === "LDT Lead" || this.state.admin) {
              if (parseInt(sessionData.profile.oHRId) === parseInt(item.pg_ohr)) {
                this.setState({ QBRDate: "", LDTApproverName: "", LDTApproverOHR: "", LDTApproverEmail: "", ldtLeadApprovalSelectedOption: [], ldtApprovalComment: "", qbrChanged: true }, () => { })
                this.setState({ isLDTApprover: true, LDTApproverName: item.pg_username, LDTApproverOHR: item.pg_ohr }, () => {
                  let styleStateObj = this.state.selectStyle;
                  styleStateObj.IsQBR = selectStyle(true);
                  this.setState(
                    {
                      IsQBR: e,
                      selectStyle: styleStateObj,
                    },
                    () => {

                    }
                  );
                  resolve();
                })
              }
            }
          });
          if (showWarningMessageForOthers === true) {
            Toast.fail("User assigned with role of LDT Lead can only be allowed to change the Client QBR value.", 3000, () => { })
          }
          Toast.hide();
        })
        .catch((error) => {
          Toast.fail(
            "Error occured while getting LDT Details. Please try again!",
            3000,
            () => {
              console.log(JSON.stringify(error));
              this.setState(
                {

                },
                () => {
                  resolve();
                }
              );
            }
          );
        });
    });

  }
  handleQBRDateChange = (e) => {
    let styleStateObj = this.state.selectStyle;
    if (e !== null && e !== undefined) {
      if (new Date(e) > new Date()) {
        window.alert("QBR date cannot be greater than current date")
        this.setState({ QBRDate: "" }, () => { })
        styleStateObj.QBRDate = selectStyle(false);
      } else {
        this.setState({ QBRDate: e }, () => {

        })
        styleStateObj.QBRDate = selectStyle(true);
      }
    }
    this.setState({
      selectStyle: styleStateObj
    });

  }


  validateLDTApproval = () => {
    let isValid = true;
    let styleStateObj = this.state.selectStyle;

    if (this.state.ideaItem.ApprovalStatus && this.state.ideaItem.ApprovalStatus === COMPLETE_STATUS) {
      if (this.state.qbrChanged === false) {
        isValid = false;
        Toast.fail("Please make Client QBR Field changes to approve", 3000, () => { })
      }
      if (this.state.IsQBR && this.state.IsQBR.label === "Yes") {
        if (this.state.ldtApprovalComment && this.state.ldtApprovalComment.length > 500) {
          Toast.fail(
            "Project Lead Comment cannot be more than 500 characters, please change and resubmit.",
            3000
          );
          isValid = false;
        }

        if (this.state.isLDTApprover === false && !this.state.admin) {
          isValid = false;
          Toast.fail("Client QBR is permitted only for User with role of LDT Lead", 3000, () => { })
        }
        if (
          this.state.QBRDate === "" ||
          this.state.QBRDate === null ||
          this.state.QBRDate === undefined ||
          !this.state.QBRDate
        ) {
          isValid = false;
          styleStateObj.QBRDate = textBoxValidation(false);
          this.setState({
            selectStyle: styleStateObj,
          });
        } else {
          styleStateObj.QBRDate = textBoxValidation(true);
          this.setState({
            selectStyle: styleStateObj,
          });
        }

        if (
          this.state.LDTApproverName === "" ||
          this.state.LDTApproverName === null ||
          this.state.LDTApproverName === undefined ||
          !this.state.LDTApproverName || this.state.LDTApproverName.length === 0
        ) {
          isValid = false;
          styleStateObj.LDTApproverName = textBoxValidation(false);
          this.setState({
            selectStyle: styleStateObj,
          });
        } else {
          styleStateObj.LDTApproverName = textBoxValidation(true);
          this.setState({
            selectStyle: styleStateObj,
          });
        }
        if (
          this.state.LDTApproverOHR === "" ||
          this.state.LDTApproverOHR === null ||
          this.state.LDTApproverOHR === undefined ||
          !this.state.LDTApproverOHR || this.state.LDTApproverOHR.length === 0
        ) {
          isValid = false;
          styleStateObj.LDTApproverOHR = textBoxValidation(false);
          this.setState({
            selectStyle: styleStateObj,
          });
        } else {
          styleStateObj.LDTApproverOHR = textBoxValidation(true);
          this.setState({
            selectStyle: styleStateObj,
          });
        }


      }
    }
    return isValid;
  }

  saveLDTApprovalDetails = () => {
    if (this.validateLDTApproval()) {
      const createdDate = new Date(this.state.ideaItem.CompleteDate);
      const currentDate = new Date();
      const differenceInMilliseconds = currentDate - createdDate;
      const differenceInDays = differenceInMilliseconds / (1000 * 60 * 60 * 24);
      if (differenceInDays > 100 && this.state.ideaItem.ApprovalStatus && this.state.ideaItem.ApprovalStatus === COMPLETE_STATUS) {
        Toast.fail("The LDT Lead cannot approve because Idea was completed more than 100 days ago", 3000, () => { });
        return false;
      } else {
        if (window.confirm("Are you sure you want to save this entry")) {
          Toast.loading("Updating LDT Approval Details...", () => { });
          let param = {};
          param = {
            IdeaId: this.state.ideaItem.IdeaId,
            case: "new",
            casetype: "LDTApprovalForCompleted",
            UpdaterRole: this.state.admin ? "Admin" : "LDT Lead",
            UserOHR: this.state.LDTApproverOHR ? this.state.LDTApproverOHR : "",
            UserName: this.state.LDTApproverName ? this.state.LDTApproverName : "",
            IsQBR: this.state.IsQBR ? this.state.IsQBR.label : "",
            QBRDate: this.state.IsQBR && this.state.IsQBR.label === "Yes" ? (this.state.QBRDate ? this.state.QBRDate : "") : "",
            LDTComments: this.state.ldtApprovalComment ? this.state.ldtApprovalComment : "",
            updaterAction: this.state.ldtLeadApprovalSelectedOption
              ? this.state.ldtLeadApprovalSelectedOption.label === "Yes"
                ? "Approved"
                : ""
              : "",
            UpdaterEmail: this.state.LDTApproverOHR + "@genpact.com",
          }

          console.log(param)
          const requestOptions = {
            method: 'PUT',
            headers: {
              "Content-Type": "application/json",
              "Authorization": "Bearer " + this.accessToken,
            },
            body: JSON.stringify(param)
          };
          fetch(`${REVIEW_IDEA_URL}`, requestOptions)
            .then(response => response.json())
            .then(data => {
              Toast.hide();
              if (data.Message === "LDT Log updated succesfully") {
                Toast.success('Updated successfully.', 3000, () => {
                  window.location = "/view-all-ideas-page";
                });
              } else {
                Toast.fail("Failed to upload. Please try again.", 3000, () => { })
                window.location = "/view-all-ideas-page";
              }
            })
            .catch = (err) => {
              console.log('error =>', JSON.stringify(err))
            }
        }
      }
    } else {
      Toast.fail('Required fields are missing or have invalid values. Please correct and try again.', 3000, () => { });
    }
    return false;
  }
  cancelLDTApproval = () => {
    this.setState({
      IsQBR: [],
      QBRDate: "",
      LDTApproverName: "",
      LDTApproverOHR: ""
    })
  }

  toggleLDTApprovalCommentLogModal = () => {
    this.setState({ displayLDTCommentLog: true }, () => {
      console.log("ldt comment log", this.state.displayLDTCommentLog)
    })
  }

  handleLDTApprovalCommentChange = (e) => {
    this.setState({ ldtApprovalComment: e }, () => { })
  }

  formatDateLatest = (e) => {
    let localClientSignOffDate = new Date(e).toLocaleDateString('en-CA').split('/').reverse().join('-');
    return localClientSignOffDate
  }

  

  

  // Code by TR start
  handleReplicationIdChange = (text) => {
    this.state.replicationProjectId = text;
    this.state.replicationIDValidated = false;
    this.setState({
      replicationIDValidated: false,
      replicationProjectId: text
    });
  }
  fetchReplicationIdeaDetails = async (IdeaId) => {
    try {
      let replicaID = IdeaId;
      if (IdeaId.length > 7) {
        replicaID = IdeaId.slice(2, 11)
      }
      Toast.loading("Fetching Replication Idea Details. Please wait...", () => { });
      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.accessToken
        }
      };
      const response = await fetch(`${GET_IDEA_URL}IdeaId=${replicaID}&case=data&casetype=fetchIdeaDetails`, requestOptions)
      if (response.ok) {
        const data = await response.json();
        if (data) {
          if (data.ResultSets.Table1 === undefined) {
            Toast.fail("We could not find the Idea based on the entered replication Idea ID. Please check and reenter.", 5000, () => { });
            this.setState({
              replicationProjectId: "",
              replicationIDValidated: false
            });
            return false;
          } else {
            Toast.hide();
            this.setState({
              replicationProjectId: this.state.replicationProjectId,
              replicationIDValidated: true,
            });
            Toast.success('Replication Idea ID validated successfully!', 3000, () => { });
            return true;
          }
        }
      }
    }
    catch (error) {
      Toast.hide();
      Toast.fail("We could not find the Idea based on the entered replication Idea ID. Please check and reenter.", 5000, () => { });
      this.setState({
        replicationProjectId: "",
        replicationIDValidated: false,
      });
      return false;
    }
  }

  validateReplicationId = (e) => {
    if (this.state.replicationProjectId !== "") {
      if (!this.fetchReplicationIdeaDetails(this.state.replicationProjectId)) {


        this.setState({
          replicationProjectId: "",
          replicationIDValidated: false

        });
        return false;
      } else {

        let styleStateObj = this.state.selectStyle;
        styleStateObj.replicationProjectId = textBoxValidation(true);
        this.setState({
          replicationProjectId: this.state.replicationProjectId,
          replicationIDValidated: true,
          selectStyle: styleStateObj
        })
        return true;
      }
    }
  }
  showHideDiv = () => {
    const newOr = !this.state.newOrReplicatedIdea;
    console.log("CHLA")
    this.setState({
      newOrReplicatedIdea: newOr,
      replicationProjectId: newOr ? this.state.replicationProjectId : ""
    });
  }
  //Code by TR end
  render() {
    let IDEA_APPROVED = this.state.ideaItem.WorkflowStatus === "Approve";
    let IDEA_REJECTED = this.state.ideaItem.WorkflowStatus === "Reject";
    let IDEA_SEND_BACK = this.state.ideaItem.WorkflowStatus === "Send Back";
    let IDEA_REQUEST_CANCELLATION =
      this.state.ideaItem.WorkflowStatus === AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION;
    let IDEA_REQUEST_CANCELLATION1 =
      this.state.ideaItem.ApprovalStatus === AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION;
    let IDEA_CANCELLED = this.state.ideaItem.WorkflowStatus === CANCEL;
    let IDEA_CANCELLED1 = this.state.ideaItem.ApprovalStatus === CANCEL;
    let redirectURL = "/review-page";
    if (this.state.approvalPage) {
      redirectURL = redirectURL + "?page=approval";
    }

    let IsSolnFeasibleValue = "";
    if (this.state.ideasAI) {
      if (this.state.ideasAI.IsSolnFeasible === false || this.state.ideasAI.IsSolnFeasible === 0 || this.state.ideasAI.IsSolnFeasible === "0") {
        IsSolnFeasibleValue = "No"
      }
      if (this.state.ideasAI.IsSolnFeasible === true || this.state.ideasAI.IsSolnFeasible === 1 || this.state.ideasAI.IsSolnFeasible === "1") {
        IsSolnFeasibleValue = "Yes"
      }
    }
    

    
    const status = this.getStatus();

    return (
      <section className="u-clearfix u-section-1" id="sec-0f7f">
        <div
          className="u-clearfix u-sheet u-sheet-1"
          style={{ marginBottom: 20 }}
        >
          <div className="u-align-left u-border-3 u-border-white u-container-style u-expanded-width u-group u-radius-10 u-shape-round u-white u-group-1">
            <div className="u-container-layout u-container-layout-1">
              <div className="view_idea_top_header_btn_block">
                {this.state.ideaItem.LeanID &&
                  (this.state.ideaItem.LeanID !== null ||
                    this.state.ideaItem.LeanID !== undefined) ? (
                  <>
                    <button
                      style={{ marginRight: "15px" }}
                      className="u-active-custom-color-6 u-border-2 u-btn u-btn-round u-radius-6 update_parent_btn"
                      onClick={this.showClusterModal}
                    >
                      Update Parent
                    </button>
                  </>
                ) : null}
                {(((this.state.ideaItem.WorkflowStatus === PENDING || this.state.isAwaitingProjCreation) &&
                  parseInt(this.sessionData.profile.oHRId) ===
                  parseInt(this.state.ideaItem.OwnerOHR)) ||
                  this.state.admin) && (
                    <>
                      <div className="" style={{ display: "flex" }}>
                        {this.state.admin && (
                          <>
                            {this.state.ideaItem.WorkflowStatus !== CANCEL &&
                              this.state.ideaItem.ApprovalStatus !== CANCEL &&
                              this.state.ideaItem.ApprovalStatus !==
                              "Awaiting Project Creation" ? (
                              <div className="">
                                <button
                                  tabIndex={21}
                                  className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                                  onClick={this.cancelRequest}
                                >
                                  Cancel Idea
                                </button>
                              </div>
                            ) : this.state.ideaItem.WorkflowStatus ===
                              CANCEL ||
                              this.state.ideaItem.ApprovalStatus ===
                              CANCEL ? (
                              <div className="">
                                <button
                                  tabIndex={21}
                                  className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                                  onClick={this.handleActiveIdeaAction}
                                >
                                  Active Idea
                                </button>
                              </div>
                            ) : (
                              <div className="">&nbsp;</div>
                            )}

                            <div className="">
                              <button
                                tabIndex={21}
                                className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                                onClick={() =>
                                  this.handleIdeaAction(
                                    this.state.ideaItem.IdeaId
                                  )
                                }
                              >
                                Edit Idea
                              </button>
                            </div>
                          </>
                        )}
                      </div>

                      {/* || (this.state.ideaItem.ApprovalStatus ===
                              "Awaiting Project Creation" && (parseInt(this.state.ideaItem.OwnerOHR) === parseInt(this.sessionData.profile.oHRId))) */}
                      {(this.state.ideaItem.WorkflowStatus === PENDING || this.state.isAwaitingProjCreation) &&
                        !this.state.admin ? (
                        <>
                          <div className="">
                            <div className="">
                              <button
                                tabIndex={21}
                                className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                                onClick={this.cancelRequest}
                              >
                                Cancel Request
                              </button>
                            </div>
                          </div>
                        </>
                      ) : null}
                    </>
                  )}
              </div>

              <div className="text-left mt-4">
                {this.state.cancelRequest ? (
                  <>
                    <div className="custom_modal">
                      <div
                        className="modal_body"
                        style={{ width: "700px", overflow: "hidden" }}
                      >
                        <div className="row">
                          <div className="col-md-8">
                            <h3 className="modal_title">
                              {this.state.admin
                                ? "Cancel Idea"
                                : "Cancel Request"}
                            </h3>
                          </div>
                          <div className="col-md-4">
                            <button
                              type="button"
                              className="close text-right"
                              onClick={(e) =>
                                this.setState({ cancelRequest: false })
                              }
                            >
                              &times;
                            </button>
                          </div>
                        </div>

                        <div className="cancellation_alert_msg">
                          <div className="">
                            <label style={{ color: "red" }}>Note: Once cancelled you cannot have the project reinitiated. You will need to start the project from scratch.</label>
                          </div>
                        </div>


                        {this.state.admin &&
                          this.state.ideaItem.CertificationLevelName ===
                          "Lean" &&
                          (this.state.ideaItem.TransformationLeverName ===
                            "Continuous Improvement") && (
                            <>
                              <div className="row">
                                <div className="col-md-2">
                                  <span className="form-attribute">
                                    <span style={{ color: "red" }}>*&nbsp;</span>
                                    Select Type
                                  </span>{" "}
                                </div>
                                <div className="col-md-3">
                                  <Select
                                    isSearchable={false}
                                    options={this.renderLeanIdeaOptions()}
                                    value={this.state.leanIdeaSelectedOption}
                                    placeholder="Select"
                                    onChange={this.handleLeanIdea}
                                    styles={
                                      this.state.selectStyle
                                        .leanIdeaSelectedOption
                                    }
                                  />
                                </div>
                              </div>
                            </>
                          )}

                        <div className="row">
                          <div className="col-md-10">
                            <p className="u-align-left u-text u-text-custom-color-4 u-text-25">
                              <span className="u-text-black form-attribute">
                                <span style={{ color: "red" }}>*</span>
                                &nbsp;Comments
                                <span
                                  style={{
                                    fontWeight: "normal",
                                    fontSize: 12,
                                    fontStyle: "italic",
                                    color: "grey",
                                  }}
                                >
                                  {" "}
                                  (max. 500 chars)
                                </span>
                              </span>
                            </p>
                          </div>
                          <div
                            className="col-md-2"
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                            }}
                          >
                            <img
                              onClick={(e) => this.toggleTranscriptFunction(3)}
                              src={require("../assets/images/voice.png")}
                              className="w100"
                              alt=""
                              style={{ width: "24px", cursor: "pointer" }}
                            />
                          </div>
                        </div>
                        <div className="row" style={{ marginTop: 5 }}>
                          <div className="col-md-12">
                            <textarea
                              className="textarea-css form-attribute"
                              style={{
                                maxWidth: "100%",
                                border: "1px solid lightgrey",
                                ...this.state.selectStyle.comment,
                              }}
                              rows={3}
                              cols={88}
                              placeholder="Please provide your comments on reason for cancellation."
                              onChange={(e) =>
                                this.handleCommentChange(e.target.value)
                              }
                              value={this.state.Comment}
                            />
                          </div>
                        </div>
                        <div className="btn-group" style={{ marginTop: 10 }}>
                          <button
                            className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                            onClick={this.state.isAwaitingProjCreation ? this.submitEventTwo : this.submitEvent}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}
                {this.state.activeIdea ? (
                  <>
                    <div className="custom_modal">
                      <div
                        className="modal_body"
                        style={{ width: "700px", overflow: "hidden" }}
                      >
                        <div className="row">
                          <div className="col-md-8">
                            <h3 className="modal_title">Reinitiate Idea</h3>
                          </div>
                          <div className="col-md-4">
                            <button
                              type="button"
                              className="close text-right"
                              onClick={(e) =>
                                this.setState({ activeIdea: false })
                              }
                            >
                              &times;
                            </button>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-md-10">
                            <p className="u-align-left u-text u-text-custom-color-4 u-text-25">
                              <span className="u-text-black form-attribute">
                                <span style={{ color: "red" }}>*</span>
                                &nbsp;Comments
                                <span
                                  style={{
                                    fontWeight: "normal",
                                    fontSize: 12,
                                    fontStyle: "italic",
                                    color: "grey",
                                  }}
                                >
                                  {" "}
                                  (max. 500 chars)
                                </span>
                              </span>
                            </p>
                          </div>
                          <div
                            className="col-md-2"
                            style={{
                              display: "flex",
                              justifyContent: "flex-end",
                              alignItems: "center",
                            }}
                          >
                            <img
                              onClick={(e) => this.toggleTranscriptFunction(4)}
                              src={require("../assets/images/voice.png")}
                              className="w100"
                              alt=""
                              style={{ width: "24px", cursor: "pointer" }}
                            />
                          </div>
                        </div>
                        <div className="row" style={{ marginTop: 5 }}>
                          <div className="col-md-12">
                            <textarea
                              className="textarea-css form-attribute"
                              style={{
                                maxWidth: "100%",
                                border: "1px solid lightgrey",
                                ...this.state.selectStyle.comment,
                              }}
                              placeholder="Please provide your comments on reason for reinitiate idea."
                              onChange={(e) =>
                                this.handleCommentChange(e.target.value)
                              }
                              rows={3}
                              cols={88}
                              value={this.state.Comment}
                            />
                          </div>
                        </div>
                        <div className="btn-group" style={{ marginTop: 10 }}>
                          <button
                            className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                            onClick={this.activeIdeaEvent}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}
                {this.state.speechModal ? (
                  <UpdatedSpeech
                    modalOpen={true}
                    onCancelRequest={this.handleTranscriptCancelRequest}
                    modalId={this.state.modalIndex}
                    closeModalFunction={this.closeModalFunction}
                    onReinitiateRequest={this.handleTranscriptReinitiateRequest}
                    previousText={this.state.previousTextForSpeech}
                  />
                ) : null}
              </div>

              <div className="text-left mt-4">
                {this.state.clusterModal ? (
                  <>
                    <div className="cluster_modal_main_block">
                      <div className="custom_modal cluster_modal_block">
                        <div className="modal_body" style={{ width: "400px" }}>
                          <div className="row">
                            <div className="col-md-11">
                              <h3 className="modal_title text-center">
                                Update Parent
                              </h3>
                            </div>
                            <div className="col-md-1">
                              <button
                                type="button"
                                className="close text-right"
                                onClick={(e) =>
                                  this.setState({ clusterModal: false })
                                }
                              >
                                &times;
                              </button>
                            </div>
                          </div>
                          <div className="clustor_modal_fields_block">
                            <div className="clustor_modal_field">
                              <label className="form-attribute">
                                <span style={{ color: "red" }}>*</span> Project
                                Type:
                              </label>
                              {this.state.displayParentAlpha ? (
                                <>
                                  <input
                                    disabled={true}
                                    value={
                                      this.state.projectTypeSelectedOption
                                        ? this.state.projectTypeSelectedOption
                                          .label
                                        : ""
                                    }
                                    className="form-input"
                                    placeholder="Choose project type"
                                  />
                                </>
                              ) : (
                                <Select
                                  isDisabled={
                                    this.state.enableClusterAction
                                      ? false
                                      : true
                                  }
                                  isSearchable={false}
                                  options={projectType}
                                  value={this.state.projectTypeSelectedOption}
                                  styles={this.state.selectStyle.projectType}
                                  placeholder="Choose project type"
                                  onChange={this.changeProjectType}
                                />
                              )}
                            </div>
                            <div className="clustor_modal_field">
                              <label className="form-attribute">
                                <span style={{ color: "red" }}>*</span> Project
                                ID:
                              </label>

                              {this.state.displayParentAlpha ? (
                                <>
                                  <input
                                    value={
                                      this.state.projectIDSelectedOption &&
                                        this.state.projectIDSelectedOption.label
                                        ? this.state.projectIDSelectedOption
                                          .label
                                        : ""
                                    }
                                    disabled={true}
                                    className="form-input"
                                    placeholder="Choose project ID"
                                  />
                                </>
                              ) : (
                                <Select
                                  isSearchable
                                  onInputChange={
                                    this.handleClusterProjectInputChange
                                  }
                                  options={this.displayProjectID()}
                                  value={this.state.projectIDSelectedOption}
                                  styles={
                                    this.state.selectStyle
                                      .projectIDSelectedOption
                                  }
                                  isDisabled={
                                    this.state.enableClusterAction
                                      ? false
                                      : true
                                  }
                                  placeholder="Choose project ID"
                                  onChange={this.changeProjectID}
                                />
                              )}
                            </div>
                          </div>
                          <div className="cluster_modal_btn_group">
                            <button
                              className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                              disabled={
                                this.state.isClusterSaveDisabled ? true : false
                              }
                              onClick={this.saveParentLink}
                            >
                              Save
                            </button>
                            <button
                              className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6"
                              onClick={this.removeParentFunc}
                              style={{ marginRight: "15px" }}
                              disabled={
                                this.state.enableClusterAction ? false : true
                              }
                            >
                              Remove Parent
                            </button>
                            {this.state.displayParentAlpha ? (
                              <>
                                <button className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6 show_hierarchy_link_btn">
                                  <Link
                                    className="show_hierarchy_link_btn_anchor"
                                    to={`/showTree?ID=${this.state.ideaItem.IdeaId}`}
                                    target="_blank"
                                  >
                                    Show Hierarchy
                                  </Link>
                                </button>
                              </>
                            ) : (
                              <button className="u-border-2 u-border-active-black u-border-blue u-btn-cancel u-btn-round u-button-style u-radius-6 show_hierarchy_link_btn">
                                Show Hierarchy
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : null}
              </div>

              <h4
                style={{
                  textAlign: "center",
                  color: "#00AECF",
                  fontFamily: "Arial",
                  fontSize: 22,
                }}
              >
                View idea :{" "}
                {this.state.ideaItem.IdeaIDAlpha
                  ? this.state.ideaItem.IdeaIDAlpha
                  : this.state.ideaItem.IdeaId}{" "}
              </h4>
              <div className="u-align-left u-container-style u-expanded-width u-group u-shape-rectangle u-group-2">
                <div
                  className="u-container-layout u-container-layout-2"
                  style={{ textAlign: "center" }}
                >
                  <div className="u-border-1 u-border-palette-5-base u-container-style u-group u-radius-6 u-shape-round u-group-3">
                    <div className="u-container-layout u-container-layout-3">
                      <p
                        className="u-align-left u-text u-text-2"
                        style={{ marginBottom: 15 }}
                      >
                        Owner details{" "}
                      </p>
                      <div className="row">
                        <div className="col-md-5">
                          <label
                            style={{
                              verticalAlign: "bottom",
                              marginBottom: -5,
                            }}
                          >
                            Owner OHR
                          </label>{" "}
                        </div>
                        <div className="col-md-6">
                          <input
                            className="form-input"
                            disabled
                            type="text"
                            value={this.state.ideaItem.OwnerOHR}
                          />
                        </div>
                      </div>
                      <div style={{ marginBottom: 15 }} />
                      <div className="row">
                        <div className="col-md-5">
                          <label
                            style={{
                              verticalAlign: "bottom",
                              marginBottom: -5,
                            }}
                          >
                            Owner Name
                          </label>{" "}
                        </div>
                        <div className="col-md-6">
                          <input
                            className="form-input"
                            disabled
                            type="text"
                            value={this.state.ideaItem.OwnerName}
                          />
                        </div>
                      </div>
                      <div style={{ marginBottom: -10 }} />
                      <p
                        className="u-align-left u-text u-text-7 u-text-custom-color-3"
                        style={{ fontSize: 11, marginBottom: 10 }}
                      >
                        (If Idea was raised for someone else, their OHR ID is
                        below)
                      </p>
                      <div className="row">
                        <div className="col-md-5">
                          <label
                            style={{
                              verticalAlign: "bottom",
                              marginBottom: -5,
                            }}
                          >
                            Request For OHR
                          </label>{" "}
                        </div>
                        <div className="col-md-6">
                          <input
                            className="form-input"
                            disabled
                            type="text"
                            defaultValue={this.state.ideaItem.CreatorOHR}
                            onChange={this.handleCreatorOHRChange}
                          />
                        </div>
                      </div>
                      <div style={{ marginBottom: 10 }} />
                      <div className="row">
                        <div className="col-md-5">
                          <label
                            style={{
                              verticalAlign: "bottom",
                              marginBottom: -5,
                            }}
                          >
                            Name
                          </label>{" "}
                        </div>
                        <div className="col-md-6">
                          <input
                            className="form-input"
                            disabled
                            type="text"
                            defaultValue={this.state.ideaItem.CreatorName}
                            onChange={this.handleCreatorNameChange}
                          />
                        </div>
                      </div>
                      <div style={{ marginBottom: 10 }} />
                      {this.state.ideaItem.LeanID !== null &&
                        (this.state.ideaItem.CertificationLevelName === "Lean" ||
                          this.state.ideaItem.CertificationLevelName === "YB") ? (
                        <div className="row">
                          <div className="col-md-5">
                            <label
                              style={{
                                verticalAlign: "bottom",
                                marginBottom: -5,
                              }}
                            >
                              Project ID
                            </label>{" "}
                          </div>
                          <div className="col-md-6">
                            <input
                              className="form-input"
                              disabled
                              type="text"
                              defaultValue={this.state.ideaItem.LeanID}
                            />
                          </div>
                        </div>
                      ) : (
                        <div className="row">
                          <div className="col-md-5">
                            <label
                              style={{
                                verticalAlign: "bottom",
                                marginBottom: 12,
                              }}
                            >
                              &nbsp;
                            </label>{" "}
                          </div>
                        </div>
                      )}
                      <div style={{ marginBottom: 10 }} />
                    </div>
                  </div>

                  <p
                    className="visible-md-block visible-sm-block visible-xs-block"
                    style={{ marginTop: 255, marginLeft: -20 }}
                  >
                    &nbsp;
                  </p>

                  <div
                    className="u-border-1 u-border-palette-5-base u-container-style u-group u-radius-6 u-shape-round u-group-4"
                    style={{ marginTop: "-305px" }}
                  >
                    <div
                      className=""
                      style={{ display: "flex", marginTop: "30px" }}
                    >
                      <div className="u-container-style u-group u-shape-rectangle u-group-5">
                        <div className="u-container-layout u-container-layout-5" style={{ padding: "20px 20px 0px 20px" }}>
                          <p
                            className="u-align-left u-text u-text-8"
                            style={{ marginBottom: 15 }}
                          >
                            Account Details
                          </p>
                          <div className="row">
                            <div className="col-md-5">
                              <label
                                style={{
                                  verticalAlign: "bottom",
                                  marginBottom: -5,
                                }}
                              >
                                Account&nbsp;Name
                              </label>
                            </div>
                            <div className="col-md-7">
                              {this.state.IdeaOwnerCanEdit
                                ?
                                <Select tabIndex={1} isSearchable={true} options={this.renderAccountOptions()} styles={this.state.selectStyle.accountName}
                                  value={this.state.accountNameSelectedOption}
                                  placeholder="Choose Account" onChange={this.handleAccountNameChange} />
                                :
                                <input
                                  className="form-input"
                                  disabled
                                  list="accounts"
                                  name="accounts"
                                  placeholder="Choose Account"
                                  value={this.state.ideaItem.AccountManual}
                                />
                              }
                            </div>
                          </div>
                          <div style={{ marginBottom: 15 }} />
                          <div className="row">
                            <div className="col-md-5">
                              <label
                                style={{
                                  verticalAlign: "bottom",
                                  marginBottom: -5,
                                }}
                              >
                                Holding&nbsp;Account
                              </label>
                            </div>
                            <div className="col-md-7">
                              <input
                                className="form-input"
                                disabled
                                type="text"
                                value={
                                  this.state.IdeaOwnerCanEdit ?
                                    this.state.holdingAccount
                                    :
                                    this.state.ideaItem.HoldingAccount

                                }
                              />
                            </div>
                          </div>
                          <div style={{ marginBottom: 15 }} />
                          <div className="row">
                            <div className="col-md-5">
                              <label
                                style={{
                                  verticalAlign: "bottom",
                                  marginBottom: -5,
                                }}
                              >
                                Vertical
                              </label>
                            </div>
                            <div className="col-md-7">
                              {this.state.IdeaOwnerCanEdit
                                ?
                                <Select tabIndex={2} isSearchable={true} value={this.state.verticalSelectedOption} options={this.renderVerticalOptions()} styles={this.state.selectStyle.verticalManual} placeholder="Choose Vertical" onChange={this.handleVerticalChange} />
                                :

                                <input
                                  className="form-input"
                                  disabled
                                  name="vertical"
                                  placeholder="Choose Vertical"
                                  value={this.state.ideaItem.VerticalManual}
                                />
                              }
                            </div>
                          </div>
                          <div style={{ marginBottom: 15 }} />
                          <div className="row">
                            <div className="col-md-5">
                              <label
                                style={{
                                  verticalAlign: "bottom",
                                  marginBottom: -5,
                                }}
                              >
                                Industry&nbsp;Vertical
                              </label>
                            </div>
                            <div className="col-md-7">
                              {
                                this.state.IdeaOwnerCanEdit ?
                                  <Select tabIndex={3} isSearchable={true} value={this.state.subVerticalSelectedOption} options={this.renderSubVerticalOptions()} styles={this.state.selectStyle.subVerticalManual} placeholder="Choose Industry&nbsp;Vertical" onChange={this.handleSubVerticalChange} />
                                  :
                                  <input
                                    className="form-input"
                                    disabled
                                    name="subverticallist"
                                    placeholder="Choose Industry&nbsp;Vertical"
                                    value={this.state.ideaItem.SubVerticalName}
                                  />
                              }
                            </div>
                          </div>
                          <div style={{ marginBottom: 15 }} />

                          {/* units and segments starts here */}
                          <div className="row">
                            <div className="col-md-5">
                              <label className="form-attribute" style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Segment</label>
                            </div>
                            <div className="col-md-7">
                              <input className="form-input" disabled name="segment" value=
                                {this.state.IdeaOwnerCanEdit ? this.state.Segment : this.state.ideaItem.Segment ? this.state.ideaItem.Segment : ""}
                                style={{ fontWeight: 'normal !important' }} />
                            </div>
                          </div>
                          <div style={{ marginBottom: 15 }} />
                          <div className="row">
                            <div className="col-md-5">
                              <label className="form-attribute" style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Unit</label>
                            </div>
                            <div className="col-md-7">
                              <input className="form-input" disabled name="unit"
                                value={this.state.IdeaOwnerCanEdit ? this.state.Unit : this.state.ideaItem.Unit ? this.state.ideaItem.Unit : ""} style={{ fontWeight: 'normal !important' }} />
                            </div>
                          </div>
                          <div style={{ marginBottom: 15 }} />
                          {/* units and segments ends here */}


                          <div className="row">
                            <div className="col-md-5">
                              <label
                                style={{
                                  verticalAlign: "bottom",
                                  marginBottom: -5,
                                }}
                              >
                                Campaign&nbsp;Name
                              </label>
                            </div>
                            <div className="col-md-7">
                              {
                                this.state.IdeaOwnerCanEdit ?
                                  <Select
                                    tabIndex={4}
                                    isSearchable={true}
                                    value={this.state.campaignSelectedOption}
                                    isDisabled={this.state.ideaItem.CampaignName === "AI First"}
                                    options={this.renderCampaignOptions()}
                                    styles={this.state.selectStyle.campaignSelectedOption}
                                    placeholder="Choose Campaign"
                                    onChange={(e) => this.handleCampaignNameChange(e)}
                                  />
                                  :
                                  <input
                                    className="form-input"
                                    disabled
                                    name="ideationtype"
                                    placeholder="Choose Campaign Name"
                                    value={this.state.ideaItem.CampaignName}
                                  />
                              }
                            </div>
                            <div className="">
                              <div className="campaign_modal_bulb campaign_tool_tip">
                                <img
                                  src={require("../assets/images/question_mark_2.png")}
                                  alt=""
                                  className=""
                                />
                                {
                                  this.state.campaignInsight
                                    ?
                                    <>
                                      <span className="my_tooltiptext">{this.state.campaignInsight}</span>
                                    </>
                                    :
                                    null
                                }
                              </div>
                            </div>

                          </div>
                          <div style={{ marginBottom: 15 }} />


                          {
                            (this.state.displaySubCampaign || this.state.campaignSelectedOption?.label === "Gen AI") && (
                              <div className="row" style={{ marginBottom: 15 }}>
                                <div className="col-md-5">
                                  <label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>
                                    {
                                      this.state.campaignSelectedOption?.label === "Gen AI"
                                        ?
                                        "Gen AI Theme"
                                        :
                                        "Sub Campaign"
                                    }
                                  </label>
                                </div>
                                <div className="col-md-7">
                                  {
                                    this.state.IdeaOwnerCanEdit
                                      ?
                                      <Select
                                        tabIndex={5}
                                        isSearchable={true}
                                        value={this.state.subCampaignSelectedOption}
                                        options={this.renderSubCampaignOptions()}
                                        styles={this.state.selectStyle.subCampaignSelectedOption}
                                        placeholder="Choose sub campaign"
                                        onChange={this.handleSubCampaignChange}
                                      />
                                      :
                                      <input
                                        className="form-input"
                                        disabled
                                        list="subcampaign"
                                        name="subcampaign"
                                        placeholder="Choose sub campaign"
                                        value={this.state.ideaItem.SubCampaignName}
                                      />
                                  }
                                </div>
                              </div>
                            )

                          }

                          {
                            this.state.displayProjectTheme && this.state.campaignSelectedOption?.label === DATA_BRIDGE_CAMPAIGN && (
                              <>
                                <div className="row">
                                  <div className="col-md-5" >
                                    <label style={{ verticalAlign: "bottom", marginBottom: -5, }}>
                                      DataBridge Project Theme
                                    </label>
                                  </div>
                                  <div className="col-md-7">
                                    <Select
                                      isSearchable={true}
                                      options={this.renderDataBridgeThemeOptions()}
                                      styles={this.state.selectStyle.dataBridgeProjectTheme}
                                      placeholder="Choose Project Theme"
                                      value={this.state.databridgeThemeSelectedOptions}
                                      onChange={this.handleDataBridgeProjectThemeChange}
                                    />
                                  </div>
                                </div>
                                <div style={{ marginBottom: 15 }} />
                              </>
                            )}

                            


                          {this.state.displayParentAlpha &&
                            this.state.displayParentAlpha.length > 0 &&
                            this.state.displayParentAlpha !== null &&
                            this.state.displayParentAlpha !== undefined &&
                            this.state.displayParentAlpha !== "" ? (
                            <>
                              <div className="row">
                                <div className="col-md-5">
                                  <label
                                    style={{
                                      verticalAlign: "bottom",
                                      marginBottom: -5,
                                    }}
                                  >
                                    Parent ID
                                  </label>
                                </div>
                                <div className="col-md-7">
                                  <input
                                    className="form-input"
                                    disabled
                                    placeholder="Choose Parent ID"
                                    value={this.state.displayParentAlpha}
                                  />
                                </div>
                              </div>
                            </>
                          ) : null}


                          {
                            (this.state.ideaItem.CampaignName && this.state.ideaItem.CampaignName === AIFIRST)
                              ||
                              (this.state.DisplayAIFirst)
                              ?
                              <>
                                <div className="row" style={{ marginTop: "20px" }}>
                                  <div className="col-md-5">
                                    <label
                                      style={{
                                        verticalAlign: "bottom",
                                        marginBottom: -5,
                                      }}
                                    >
                                      <i>AI First Sample Ideas</i>
                                    </label>
                                  </div>
                                  <div className="col-md-7">
                                    <div className="ai_first_doc_link ai_first_doc_red_highlight">
                                      <a
                                        className="ldt-list1"
                                        href={AI_DOC_LINK}
                                        target="_blank"
                                        rel="noreferrer"
                                        style={{ textAlign: "left", fontSize: 16, color: "red" }}
                                      >Document Link </a>
                                    </div>

                                  </div>
                                </div>

                                {
                                  this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                                    ?
                                    <>
                                      <div style={{ marginBottom: 20 }} />
                                      <div className="row d_flex_align_items_center">
                                        <div className="col-md-5">
                                          <span className="form-attribute">
                                            AI Recommendation
                                          </span>
                                        </div>
                                        <div className="col-md-7">
                                          <input
                                            className="form-input"
                                            disabled
                                            name="methodology"
                                            value={this.state.ideaItem.isAI}
                                          />
                                        </div>
                                      </div>
                                    </>
                                    :
                                    null

                                }


                                {
                                  this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                                    ?
                                    <>
                                      <div style={{ marginBottom: 20 }} />
                                      <div className="row">
                                        <div className="col-md-5">
                                          <span className="form-attribute">
                                            AI First BRD
                                          </span>
                                        </div>
                                        <div className="col-md-7">
                                          <div className="ai_first_doc_link">
                                            <textarea className="ai_first_brd_textarea" onClick={(e) => this.handleAIDocumentClick(this.state.ideasAI.LinkBRD)} value={this.state.ideasAI.LinkBRD} ></textarea>
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                    :
                                    null
                                }

                              </>
                              :
                              null
                          }




                          <div style={{ marginBottom: 18 }}>&nbsp;</div>
                        </div>
                      </div>
                      <div className="u-container-layout u-container-layout-6">
                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-md-5">
                            <label
                              style={{
                                verticalAlign: "bottom",
                                marginBottom: -5,
                              }}
                            >
                              Country
                            </label>
                          </div>
                          <div className="col-md-7">
                            {
                              this.state.IdeaOwnerCanEdit ?
                                <Select tabIndex={6} isSearchable={true} value={this.state.countrySelectedOption} options={this.renderCountryOptions()} styles={this.state.selectStyle.country} placeholder="Choose Country" onChange={this.handleCountryChange} />

                                :
                                <input
                                  className="form-input"
                                  disabled
                                  name="regions"
                                  placeholder="Choose Country"
                                  value={this.state.ideaItem.Country}
                                />
                            }
                          </div>
                        </div>
                        <div style={{ marginBottom: 15 }} />
                        <div className="row">
                          <div className="col-md-5">
                            <label
                              style={{
                                verticalAlign: "bottom",
                                marginBottom: -5,
                              }}
                            >
                              Region
                            </label>
                          </div>
                          <div className="col-md-7">
                            {this.state.IdeaOwnerCanEdit ?
                              <Select tabIndex={7} isSearchable={true} value={this.state.regionSelectedOption} options={this.renderRegionOptions()} styles={this.state.selectStyle.regionManual} placeholder="Choose Region"
                                onChange={this.handleRegionChange}
                              />

                              :
                              <input
                                className="form-input"
                                disabled
                                name="regions"
                                placeholder="Choose Region"
                                value={this.state.ideaItem.RegionManual}
                              />
                            }
                          </div>
                        </div>
                        <div style={{ marginBottom: 15 }} />
                        <div className="row">
                          <div className="col-md-5">
                            <label
                              style={{
                                verticalAlign: "bottom",
                                marginBottom: -5,
                              }}
                            >
                              Sub-Region
                            </label>
                          </div>
                          <div className="col-md-7">
                            {this.state.IdeaOwnerCanEdit
                              ?
                              <Select tabIndex={8} isSearchable={true} value={this.state.subRegionSelectedOption} options={this.renderSubRegionOptions()} styles={this.state.selectStyle.subRegion} placeholder="Choose Sub-Region"
                                onChange={this.handleSubRegionChange}
                              />
                              :
                              <input
                                className="form-input"
                                disabled
                                name="regions"
                                placeholder="Choose Sub-Region"
                                value={this.state.ideaItem.SubRegion}
                              />
                            }
                          </div>
                        </div>
                        <div style={{ marginBottom: 15 }} />
                        <div className="row">
                          <div className="col-md-5">
                            <label
                              style={{
                                verticalAlign: "bottom",
                                marginBottom: -5,
                              }}
                            >
                              Blackbelt&nbsp;Name
                            </label>
                          </div>
                          <div className="col-md-7">
                            {this.state.IdeaOwnerCanEdit || this.state.isIdeaDUAOwner ?
                              <Select tabIndex={9} isSearchable={true} value={this.state.blackBeltSelectedOption} options={this.renderBlackBeltOptions()} styles={this.state.selectStyle.blackBeltUserName} placeholder="Choose Blackbelt" onChange={this.handleBlackBeltNameChange} />
                              :
                              <input
                                className="form-input"
                                disabled
                                name="blackbelt"
                                placeholder="Choose Blackbelt"
                                title={
                                  "OHR ID: " + this.state.ideaItem.BlackBeltUserId
                                }
                                value={this.state.ideaItem.BlackBeltUserName}
                              />
                            }
                          </div>
                        </div>
                        {this.state.ideaItem.MBBOHR !== null && (
                          // (this.state.ideaItem.WorkflowStatus !== "Pending") && (
                          <>
                            <div style={{ marginBottom: 15 }} />
                            <div className="row">
                              <div className="col-md-5">
                                <label
                                  style={{
                                    verticalAlign: "bottom",
                                    marginBottom: -5,
                                  }}
                                >
                                  MBB
                                </label>
                              </div>
                              <div className="col-md-7">
                                {
                                  this.state.IdeaOwnerCanEdit
                                    ?
                                    <Select
                                      tabIndex={10}
                                      isSearchable={true}
                                      value={this.state.mbbSelectedOption}
                                      options={this.renderMBBOptions()}
                                      styles={this.state.selectStyle.mbbUserName}
                                      placeholder="Choose MBB"
                                      onChange={this.handleMBBChange}
                                    />
                                    :
                                    <input
                                      className="form-input"
                                      disabled
                                      name="blackbelt"
                                      placeholder="Choose MBB"
                                      title={
                                        "OHR ID: " + this.state.ideaItem.MBBOHR
                                      }
                                      value={this.state.ideaItem.MBBName}
                                    />
                                }
                              </div>
                            </div>
                          </>
                        )}

                        {
                          this.state.ideaItem.CampaignName && this.state.ideaItem.CampaignName === AIFIRST &&
                            this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                            ?
                            <>
                              <div style={{ marginBottom: 20 }} />
                              <div className="row">
                                <div className="col-md-12">
                                  <span className="form-attribute">
                                    AI First Reason
                                  </span>
                                </div>
                                <div className="col-md-12">
                                  <textarea
                                    disabled
                                    value={this.state.ideasAI.AIReason}
                                    placeholder="Please provide value"
                                    className="form-input"
                                    rows={4}
                                    cols={80}
                                    style={{
                                      width: "100%",
                                      border: "1px solid lightgrey",
                                      resize: "none"
                                    }}
                                  />
                                </div>
                              </div>
                              <div style={{ marginBottom: 20 }} />
                            </>
                            :
                            null
                        }






                        <div style={{ marginBottom: 15 }} />
                        {/* <div className="row">
                                                    <div className="col-md-5"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>LDA</label></div>
                                                    <div className="col-md-7">
                                                        <input className ="form-input" disabled name="blackbelt" placeholder="Choose LDA" title={"OHR ID: " +  this.state.ideaItem.LDAOHR} value={this.state.ideaItem.LDA} />
                                                    </div>
                                                </div> */}
                        <div style={{ marginBottom: 15 }} />
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      borderBottom: "1px solid lightgrey",
                      marginBottom: 15,
                    }}
                  />

                  <p
                    className="visible-md-block visible-sm-block visible-xs-block"
                    style={{ marginTop: -30 }}
                  >
                    &nbsp;
                  </p>

                  <div
                    id="idea1"
                    className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                    style={{ marginTop: 15 }}
                  >
                    <div className="u-container-layout u-container-layout-7">
                      <div className="u-container-style u-group u-shape-rectangle u-group-8">
                        <div className="u-container-layout u-container-layout-8">
                          <p
                            id="idea1title"
                            className="u-align-left u-text u-text-2"
                            style={{ marginBottom: 10 }}
                          >
                            Idea details
                          </p>
                          <div className="row">
                            <div className="col-md-4">
                              <label
                                style={{
                                  verticalAlign: "bottom",
                                  marginBottom: -5,
                                }}
                              >
                                Service Line
                              </label>{" "}
                            </div>
                            <div className="col-md-8">
                              {
                                this.state.IdeaOwnerCanEdit ?
                                  <Select isSearchable={true}
                                    value={this.state.ServiceLineSelectedOption}
                                    options={this.renderServiceLineOptions()} styles={this.state.selectStyle.serviceLineText} placeholder="Choose Service Line" onChange={(e) => this.handleServiceLineChange(e)} />
                                  :
                                  <input
                                    className="form-input"
                                    disabled
                                    name="serviceline"
                                    placeholder="Choose Service Line"
                                    value={this.state.ideaItem.ServiceLineName}
                                  />
                              }
                            </div>
                          </div>
                          <div style={{ marginBottom: 15 }} />
                          <div className="row">
                            <div className="col-md-4">
                              <label
                                style={{
                                  verticalAlign: "bottom",
                                  marginBottom: -5,
                                }}
                              >
                                Sub Service Line
                              </label>{" "}
                            </div>
                            <div className="col-md-8">
                              {
                                this.state.IdeaOwnerCanEdit ?
                                  <Select
                                    isSearchable={true}
                                    value={this.state.subServiceLineSelectedOption}
                                    options={this.renderSubServiceLineOptions()}
                                    styles={this.state.selectStyle.subServiceLineText}
                                    placeholder="Choose Sub Service Line"
                                    onChange={(e) => this.handleSubServiceLineChange(e)} />
                                  :
                                  <input
                                    className="form-input"
                                    disabled
                                    name="serviceline"
                                    placeholder="Choose Sub Service Line"
                                    value={this.state.ideaItem.SubServiceLine}
                                  />
                              }
                            </div>
                          </div>
                          <div style={{ marginBottom: 15 }} />
                          <div className="row">
                            <div className="col-md-7">
                              <p className="u-align-left u-text u-text-custom-color-4 u-text-8">
                                <span className="u-text-black form-attribute" style={{ fontWeight: 'normal' }}><span style={{ color: 'red' }}>* </span>What is the Problem ?<span style={{ fontWeight: 'normal', fontSize: 12, fontStyle: 'italic', color: 'grey' }}>(max. 2000 chars)</span></span>
                              </p>
                            </div>
                            {this.state.IdeaOwnerCanEdit ?
                              <div className="col-md-5">
                                <div className="" style={{ display: 'flex', justifyContent: "flex-end" }}>
                                  <img onClick={(e) => this.toggleTranscriptFunction(0)} src={require("../assets/images/voice.png")} className="w100" alt="" style={{ width: "24px", cursor: "pointer" }} />
                                </div>
                              </div>
                              :
                              null
                            }

                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              {this.state.IdeaOwnerCanEdit ?
                                <textarea className="textarea-css form-attribute" rows={6} cols={80} style={{ padding: 10, maxWidth: '100%', ...this.state.selectStyle.problem }}
                                  placeholder={this.state.DisplayAIFirst ? "Share your problem statement briefly, set clear goals, and give some background. Explain why the problem matters and how it affects things. Tell us what you hope to achieve. Make sure your input is clear and helps us understand your problem statement better." : "Eg:- Increased manual interventions in the equipment finance business leading to manual processing of ~70% payments by Genpact - Higher wire/automated clearing house (ACH) cycle time due to delay in solving the cases under suspense bucket - $16MM existing in different risk & suspense buckets, where we did not have a resolution and depended on client for further action"}
                                  value={this.state.problem} onChange={(event) => this.handleProblemChange(event.target.value)} />
                                :
                                <textarea
                                  className="form-input"
                                  disabled
                                  rows={6}
                                  cols={80}
                                  style={{
                                    maxWidth: "100%",
                                    border: "1px solid lightgrey",
                                  }}
                                  value={this.state.ideaItem.Problem}
                                />
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <p
                        className="visible-md-block visible-sm-block visible-xs-block"
                        style={{ marginTop: 10 }}
                      >
                        &nbsp;
                      </p>
                      <div className="u-container-style u-group u-shape-rectangle u-group-9">
                        <div
                          className="u-container-layout u-container-layout-9"
                          style={{ marginTop: 4 }}
                        >
                          <div className="row">
                            <div className="col-md-3">
                              <label
                                style={{
                                  verticalAlign: "bottom",
                                  marginBottom: -5,
                                }}
                              >
                                Idea Name
                              </label>{" "}
                            </div>
                            <div
                              className="col-md-9"
                              style={{ alignItems: "flex-start" }}
                            >
                              <input
                                className="form-input"
                                disabled
                                type="text"
                                value={this.state.ideaItem.IdeaName}
                                placeholder="Eg: Cash flow improvement through process restructuring"
                              />
                            </div>
                          </div>
                          <div style={{ marginBottom: 66 }} />
                          <div className="row">
                            <div className="col-md-7">
                              <p
                                className="u-align-left u-text u-text-custom-color-4 u-text-25"
                                style={{ width: "177px" }}
                              >
                                <span className="u-text-black form-attribute">
                                  {" "}
                                  How to resolve the problem
                                </span>
                                &nbsp;
                              </p>
                            </div>
                            <div className="col-md-5">
                              <div className="" style={{ display: 'flex', justifyContent: "flex-end" }}>
                                <img onClick={(e) => this.toggleTranscriptFunction(1)} src={require("../assets/images/voice.png")} className="w100" alt="" style={{ width: "24px", cursor: "pointer" }} />
                              </div>
                            </div>
                          </div>



                          <div className="row" style={{ marginBottom: 15 }}>
                            <div className="col-md-12">
                              {
                                this.state.IdeaOwnerCanEdit ?
                                  <div className="row">
                                    <div className="col-md-12">
                                      <textarea className="textarea-css form-attribute" rows={6} cols={80} style={{ padding: 10, maxWidth: '100%', ...this.state.selectStyle.solution }}
                                        placeholder={this.state.DisplayAIFirst ? "Please provide a clear and concise outline of the automated process, detailing the steps, technologies, and differences compared to the current process. Highlight the expected improvements and efficiencies to ensure a thorough understanding of the proposed changes." : "Eg:- Deployed data analysis, value stream mapping, and process restructuring for AML cases (anti money laundering) - Set up a proactive 'end customer' education program through detailed data analysis to reduce suspense bucket - Reduced touch time at various steps in the cash application process through quick automation leading to improvement in cycle time for wire payments"}
                                        value={this.state.solution} onChange={(event) => this.handleSolutionChange(event.target.value)} />
                                    </div>
                                  </div>
                                  :
                                  <textarea
                                    className="form-input"
                                    disabled
                                    rows={6}
                                    cols={80}
                                    style={{
                                      maxWidth: "100%",
                                      border: "1px solid lightgrey",
                                    }}
                                    value={this.state.ideaItem.Solution}
                                  />
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row" style={{ marginTop: 15 }}>
                        <div className="col-md-5">
                          <span className="form-attribute">
                            Are you trying to replicate an existing Idea?
                          </span>
                        </div>
                        {
                          this.state.IdeaOwnerCanEdit ?

                            <div className="col-md-4" style={{ textAlign: 'left !important' }}>
                              <label className="switch">
                                <input type="checkbox" id="isReplicationIdeaBtn"
                                  checked={this.state.ideaItem.NewOrReplicatedIdea === null ? false : this.state.newOrReplicatedIdea}

                                  onChange={this.showHideDiv} />
                                <span className="slider round" />
                              </label>
                            </div>
                            :
                            <div className="col-md-4">
                              <label className="switch">
                                <input
                                  disabled
                                  type="checkbox"
                                  checked={
                                    this.state.ideaItem.NewOrReplicatedIdea === null
                                      ? false
                                      : this.state.ideaItem.NewOrReplicatedIdea
                                  }
                                />
                                <span className="slider round" />
                              </label>
                            </div>
                        }
                      </div>
                      {(this.state.IdeaOwnerCanEdit ? this.state.newOrReplicatedIdea : this.state.ideaItem.NewOrReplicatedIdea) && (
                        <>
                          <div
                            className="col-md-8"
                            style={{ marginBottom: 15, width: "100%" }}
                          />
                          <div className="row">
                            <div className="col-md-5">
                              <span className="form-attribute">
                                Provide the ID of the executed Idea which you
                                want to replicate?
                              </span>
                            </div>
                            {this.state.IdeaOwnerCanEdit ?
                              <>
                                <div className="col-md-2">
                                  <input className="form-input textarea-css" type="text" value={this.state.replicationProjectId} style={this.state.selectStyle.replicationProjectId}
                                    onChange={event => { this.handleReplicationIdChange(event.target.value) }}
                                    // onBlur={event => { this.validateReplicationId(index) }} 
                                    onKeyPress={event => {
                                      if (event.key === 'Enter') {
                                        this.validateReplicationId(event);
                                      }
                                    }} />
                                </div>
                                <div className="col-md-1" style={{ marginLeft: -20 }}><i className="fa fa-check-square-o" style={{ marginTop: 7, color: '#FF555F', fontSize: 24 }} onClick={event => { this.validateReplicationId() }} /></div>
                                <div className="col-md-8" style={{ marginBottom: 15 }} />
                              </>
                              :
                              <div className="col-md-2">
                                <input
                                  className="form-input"
                                  disabled
                                  type="text"
                                  value={this.state.ideaItem.ReplicationProjectId}
                                />
                              </div>
                            }
                          </div>
                        </>
                      )}

                      <div className="col-md-8" style={{ marginBottom: 15 }} />
                    </div>
                  </div>













                  {this.state.ideaItem.WorkflowStatus &&
                    this.state.ideaItem.Comment !== null && (
                      <>
                        <div
                          style={{
                            borderBottom: "1px solid lightgrey",
                            marginBottom: 15,
                          }}
                        />
                        <div
                          id="Approval Status"
                          className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                        >
                          <div className="u-container-layout u-container-layout-7">
                            <p
                              className="u-align-left u-text u-text-2"
                              style={{ marginBottom: 10 }}
                            >
                              Idea Approval details
                            </p>
                            <div className="row">
                              <div className="col-md-2">
                                <label
                                  style={{
                                    verticalAlign: "bottom",
                                    marginBottom: -5,
                                  }}
                                >
                                  Approval Status
                                </label>
                              </div>
                              <div className="col-md-2">
                                {/* <input className="form-input" disabled name="Status" value={IDEA_APPROVED ? APPROVED : (IDEA_REJECTED ? REJECTED : (IDEA_SEND_BACK ? SENT_BACK : ((IDEA_REQUEST_CANCELLATION || IDEA_REQUEST_CANCELLATION1) ? "Cancellation Requested" :( (IDEA_CANCELLED || IDEA_CANCELLED1) ? "Cancelled" :(this.state.ideaItem.Comment !== null ? (this.state.logAction ==='Idea Reinitiated by Admin' ? 'Idea Reinitiated' : 'Discard Cancellation') :PENDING)))))}  /> */}
                                <input
                                  title = {status}
                                  className="form-input"
                                  disabled
                                  name="Status"
                                  value={status}
                                />
                              </div>
                              {/* <div className="col-md-3"><label style={{ verticalAlign: 'bottom', marginBottom: -5 }}>Expected timeline for execution</label></div>
                                                        <div className="col-md-2">
                                                            <input disabled name="ExpectedDate" value={this.state.ideaItem.ExpectedFinishDate ? this.formatDateString(new Date(this.state.ideaItem.ExpectedFinishDate)): ""} />
                                                        </div> */}
                            </div>
                            {/* <div className="col-md-9" style={{ marginBottom: 5 }} /> */}

                            <div className="row" style={{ marginTop: 15 }}>
                              <div className="col-md-5">
                                <label
                                  style={{
                                    verticalAlign: "bottom",
                                    marginBottom: -5,
                                  }}
                                >
                                  Comments
                                </label>
                              </div>
                              <div
                                className="col-md-2"
                                style={{ marginLeft: 20 }}
                              >
                                <button
                                  className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                                  onClick={(e) =>
                                    this.setState({
                                      commentLog: !this.state.commentLog,
                                    })
                                  }
                                >
                                  Comment Log
                                </button>
                              </div>
                            </div>
                            <div className="row" style={{ marginTop: 5 }}>
                              <div className="col-md-12">
                                <textarea
                                  className="form-input"
                                  disabled
                                  rows={3}
                                  cols={88}
                                  style={{
                                    maxWidth: "100%",
                                    border: "1px solid lightgrey",
                                  }}
                                  name="Comments"
                                  value={this.state.ideaItem.Comment}
                                />
                              </div>
                            </div>
                            <div className="text-left mt-4">
                              {this.state.commentLog &&
                                this.state.reviewComments ? (
                                <>
                                  <div className="custom_modal">
                                    <div className="modal_body">
                                      <div className="row">
                                        <div className="col-md-8">
                                          <h3 className="modal_title">
                                            Idea Approval Comment Log
                                          </h3>
                                        </div>
                                        <div className="col-md-4">
                                          <button
                                            type="button"
                                            className="close text-right"
                                            onClick={(e) =>
                                              this.setState({
                                                commentLog: false,
                                              })
                                            }
                                          >
                                            &times;
                                          </button>
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div
                                          className="col-md-2 text-center"
                                          style={{
                                            border: "1px solid lightgrey",
                                            backgroundColor: "gainsboro",
                                          }}
                                        >
                                          <label
                                            style={{
                                              fontWeight: 100,
                                              verticalAlign: "bottom",
                                            }}
                                          >
                                            Date & Time
                                          </label>
                                        </div>
                                        <div
                                          className="col-md-2 text-center"
                                          style={{
                                            border: "1px solid lightgrey",
                                            backgroundColor: "gainsboro",
                                          }}
                                        >
                                          <label
                                            style={{
                                              fontWeight: 100,
                                              verticalAlign: "bottom",
                                            }}
                                          >
                                            OHR
                                          </label>
                                        </div>
                                        <div
                                          className="col-md-2 text-center"
                                          style={{
                                            border: "1px solid lightgrey",
                                            backgroundColor: "gainsboro",
                                          }}
                                        >
                                          <label
                                            style={{
                                              fontWeight: 100,
                                              verticalAlign: "bottom",
                                            }}
                                          >
                                            Name
                                          </label>
                                        </div>
                                        <div
                                          className="col-md-1 text-center"
                                          style={{
                                            border: "1px solid lightgrey",
                                            backgroundColor: "gainsboro",
                                          }}
                                        >
                                          <label
                                            style={{
                                              fontWeight: 100,
                                              verticalAlign: "bottom",
                                            }}
                                          >
                                            Role
                                          </label>
                                        </div>
                                        <div
                                          className="col-md-2 text-center"
                                          style={{
                                            border: "1px solid lightgrey",
                                            backgroundColor: "gainsboro",
                                          }}
                                        >
                                          <label
                                            style={{
                                              fontWeight: 100,
                                              verticalAlign: "bottom",
                                            }}
                                          >
                                            Action
                                          </label>
                                        </div>
                                        <div
                                          className="col-md-3 text-center"
                                          style={{
                                            border: "1px solid lightgrey",
                                            backgroundColor: "gainsboro",
                                          }}
                                        >
                                          <label
                                            style={{
                                              fontWeight: 100,
                                              verticalAlign: "bottom",
                                            }}
                                          >
                                            Comment
                                          </label>
                                        </div>
                                      </div>
                                      {this.state.reviewComments.map(
                                        (item, index) => {
                                          console.log(item);
                                          return (
                                            <div className="row" key={index}>
                                              <div
                                                className="col-md-2 text-center"
                                                style={{
                                                  border: "1px solid lightgrey",
                                                }}
                                              >
                                                <label
                                                  style={{
                                                    lineheight: 2,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  {this.formatDateStringWithTime(
                                                    new Date(item.CreatedDate)
                                                  )}
                                                </label>
                                              </div>
                                              <div
                                                className="col-md-2 text-center"
                                                style={{
                                                  border: "1px solid lightgrey",
                                                }}
                                              >
                                                <label
                                                  style={{
                                                    lineheight: 2,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  {item.UpdaterOHR}
                                                </label>
                                              </div>
                                              <div
                                                className="col-md-2 text-center"
                                                style={{
                                                  border: "1px solid lightgrey",
                                                }}
                                              >
                                                <label
                                                  style={{
                                                    lineheight: 2,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  {item.UpdaterName}
                                                </label>
                                              </div>
                                              {/* <div className="col-md-1 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                <label style={{ lineheight: 2, verticalAlign: "bottom" }}>
                                                                                                    {(item.Action === 'Idea Updated by Admin' || item.Action === 'Idea Reinitiated by Admin' ) ? 'Admin' : (item.Action === 'Delegate Action' ? 'BB' : (item.UpdaterOHR === this.state.ideaItem.BlackBeltUserId ? "BB" : (item.UpdaterOHR === this.state.ideaItem.MBBOHR ? "MBB" : (item.UpdaterOHR === this.state.ideaItem.OwnerOHR ? "Idea Owner" : "LDT"))))}
                                                                                                </label>
                                                                                            </div> */}
                                              <div
                                                className="col-md-1 text-center role_over_flow_class"
                                                style={{
                                                  border: "1px solid lightgrey",
                                                }}
                                              >
                                                {/* <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterRole}</label> */}
                                                <label
                                                  style={{
                                                    lineheight: 2,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  {item.UpdaterRole
                                                    ? item.UpdaterRole
                                                    : item.Action ===
                                                      "Idea Updated by Admin" ||
                                                      item.Action ===
                                                      "Idea Reinitiated by Admin"
                                                      ? "Admin"
                                                      : item.Action ===
                                                        "Delegate Action"
                                                        ? "BB"
                                                        : item.UpdaterOHR ===
                                                          this.state.MBBOHR
                                                          ? "MBB"
                                                          : item.UpdaterOHR ===
                                                            this.state.ideaItem
                                                              .OwnerOHR
                                                            ? "Idea Owner"
                                                            : item.ApprovalStatus ===
                                                              "Pending Documents" &&
                                                              item.WorkflowStatus ===
                                                              "Approved"
                                                              ? "BB"
                                                              : item.ApprovalStatus ===
                                                                "NA" &&
                                                                item.WorkflowStatus ===
                                                                "Pending"
                                                                ? "BB"
                                                                : item.UpdaterRole}
                                                </label>
                                              </div>
                                              <div
                                                className="col-md-2 text-center"
                                                style={{
                                                  border: "1px solid lightgrey",
                                                }}
                                              >
                                                <label
                                                  style={{
                                                    lineheight: 2,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  {item.UpdaterAction
                                                    ? item.UpdaterAction
                                                    : item.Action ===
                                                      "Idea Reinitiated by Admin"
                                                      ? "Idea Reinitiated"
                                                      : item.Action ===
                                                        "Idea Updated by Admin"
                                                        ? item.WorkflowStatus !==
                                                          "Pending"
                                                          ? item.WorkflowStatus
                                                          : "Idea Updated"
                                                        : item.Action ===
                                                          "Delegate Action"
                                                          ? "Delegated"
                                                          : item.WorkflowStatus ===
                                                            "Pending"
                                                            ? "Discard Cancellation"
                                                            : item.WorkflowStatus}
                                                </label>
                                              </div>
                                              <div
                                                className="col-md-3 text-center"
                                                style={{
                                                  border: "1px solid lightgrey",
                                                }}
                                              >
                                                <label
                                                  style={{
                                                    lineheight: 2,
                                                    verticalAlign: "bottom",
                                                  }}
                                                >
                                                  {item.Comment
                                                    ? item.Comment
                                                    : "-"}
                                                </label>
                                              </div>
                                            </div>
                                          );
                                        }
                                      )}
                                    </div>
                                  </div>
                                </>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            borderBottom: "1px solid lightgrey",
                            marginBottom: 15,
                            marginTop: 15,
                          }}
                        />

                        {this.state.ideaItem.WorkflowStatus &&
                          (this.state.ideaItem.WorkflowStatus === "Approve" ||
                            this.state.ideaItem.WorkflowStatus ===
                            "Approved") && (
                            <div
                              id="Potential Impact"
                              className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                              style={{
                                borderBottom: "1px solid lightgray",
                                marginBottom: "10px",
                              }}
                            >
                              <div className="u-container-layout u-container-layout-7" style={{ display: 'flex' }}>
                                <div className="u-container-style u-group u-shape-rectangle u-group-8">
                                  <div className="u-container-layout u-container-layout-8">
                                    <p
                                      id="Potential Impact"
                                      className="u-align-left u-text u-text-2"
                                      style={{ marginBottom: 10 }}
                                    >
                                      Additional details
                                    </p>
                                    <div className="row d_flex_align_items_center">
                                      <div className="col-md-6">
                                        <span className="form-attribute">
                                          LDT Lead Name
                                        </span>
                                      </div>
                                      <div className="col-md-6">
                                        <input
                                          className="form-input"
                                          disabled
                                          list="ldtName"
                                          name="ldtName"
                                          placeholder="Choose LDT Lead"
                                          title={
                                            "OHR ID: " +
                                            this.state.ideaItem.LDTId
                                          }
                                          value={
                                            this.state.ideaItem.LDTLeadName
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div style={{ marginBottom: 5 }} />



                                    {
                                      this.state.ideaItem.CampaignName && this.state.ideaItem.CampaignName === AIFIRST
                                        && this.state.ideaItem.isAI && (this.state.ideaItem.isAI === "Yes" || this.state.ideaItem.isAI === "No")
                                        ?
                                        <>
                                          <div style={{ marginBottom: 15 }} />
                                          <div className="row d_flex_align_items_center">
                                            <div className="col-md-6">
                                              <span className="form-attribute">
                                                Is the solution feasible ?
                                              </span>
                                            </div>
                                            <div className="col-md-6">
                                              <input
                                                className="form-input"
                                                disabled
                                                value={IsSolnFeasibleValue}
                                              />
                                            </div>
                                          </div>
                                          <div style={{ marginBottom: 15 }} />
                                          <div className="row d_flex_align_items_center">
                                            <div className="col-md-6">
                                              <span className="form-attribute">
                                                Solution Complexity
                                              </span>
                                            </div>
                                            <div className="col-md-6">
                                              <input
                                                className="form-input"
                                                disabled
                                                name="methodology"
                                                value={
                                                  this.state.ideasAI.SolnComplexity
                                                }
                                              />
                                            </div>
                                          </div>


                                          <div style={{ marginBottom: 15 }} />
                                          <div className="row d_flex_align_items_center">
                                            <div className="col-md-6">
                                              <span className="form-attribute">
                                                Is the Idea replicable
                                              </span>
                                            </div>
                                            <div className="col-md-6">
                                              <input
                                                className="form-input"
                                                disabled
                                                value={this.state.isIdeaReplicable}
                                              />
                                            </div>
                                          </div>
                                          <div style={{ marginBottom: 15 }} />
                                        </>
                                        :
                                        null
                                    }
                                    {this.state.ideaItem.NewOrReplicatedIdea && (
                                      <div className="row">
                                        <div className="col-md-10" style={{
                                          marginTop: 10,
                                          marginBottom: 14,
                                        }}>
                                          <label
                                            style={{
                                              verticalAlign: "bottom",
                                              marginBottom: -5,
                                            }}
                                          >
                                            Have you verified the replication id
                                            and confirm this to be replication
                                            project?
                                          </label>
                                        </div>
                                        <div className="col-md-2">
                                          <label className="switch">
                                            <input
                                              disabled
                                              type="checkbox"
                                              checked={
                                                this.state.ideaItem
                                                  .IsReplicationVerified
                                              }
                                            />
                                            <span className="slider round" />
                                          </label>
                                        </div>
                                        <div style={{ marginBottom: 45 }} />
                                      </div>
                                    )}
                                    {!this.state.ideaItem
                                      .NewOrReplicatedIdea && (
                                        <div className="row">
                                          <div className="col-md-10">
                                            <label
                                              style={{
                                                verticalAlign: "bottom",
                                                marginBottom: 17,
                                              }}
                                            >
                                              &nbsp;
                                            </label>
                                          </div>
                                        </div>
                                      )}



                                    {
                                      this.state.CodersTable && this.state.CodersTable.length > 0
                                        ?
                                        <div className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7">
                                          <div className="u-container-layout u-container-layout-7" style={{ paddingTop: "0px" }}>
                                            <p className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }}>Coder Section</p>
                                            <div className="VD_Summary" >
                                              <div className="row mt-3">
                                                <div className="col-md-7 col-xs-4 VD_Summary_table_header">
                                                  <div className=""><label>Coder Name</label></div>
                                                </div>
                                                <div className="col-md-3 col-xs-4 VD_Summary_table_header">
                                                  <div><label>Coder OHR</label></div>
                                                </div>
                                              </div>
                                              {this.state.CodersTable && this.state.CodersTable.map((item, index) => {
                                                return (
                                                  <>
                                                    <div className="" key={index}>
                                                      <div className="row">
                                                        <div className="col-md-7 col-xs-4 VD_Summary_table_row">
                                                          <div style={{ marginTop: '2.5px' }}>
                                                            <label>{item.OHRName}</label>
                                                          </div>
                                                        </div>
                                                        <div className="col-md-3   col-xs-4 VD_Summary_table_row">
                                                          <div style={{ marginTop: '2.5px' }}>
                                                            <label>{item.OHR}</label>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </>
                                                )
                                              })}
                                            </div>
                                            <div className="col-md-12" style={{ marginBottom: "15px" }} />
                                          </div>
                                        </div>
                                        :
                                        null
                                    }


                                  </div>
                                </div>

                                <div className="u-container-style u-group u-shape-rectangle u-group-9" style={{ marginTop: "0px" }}>
                                  <div className="u-container-layout u-container-layout-9" style={{ paddingTop: "20px" }}>
                                    <div className="row d_flex_align_items_center">
                                      <div className="col-md-5">
                                        <span className="form-attribute">
                                          Certification Level
                                        </span>{" "}
                                      </div>
                                      <div className="col-md-7">
                                        <input
                                          className="form-input"
                                          disabled
                                          name="certlevel"
                                          value={this.state.ideaItem.CertificationLevelName}
                                        />
                                      </div>
                                    </div>
                                    <div style={{ marginBottom: 15 }} />
                                    <div className="row d_flex_align_items_center">
                                      <div className="col-md-5">
                                        <span className="form-attribute">
                                          Transformation Lever
                                        </span>{" "}
                                      </div>
                                      <div className="col-md-7">
                                        <input
                                          className="form-input"
                                          disabled
                                          name="translever"
                                          value={this.state.ideaItem.TransformationLeverName}
                                        />
                                      </div>
                                    </div>

                                    <div style={{ marginBottom: 15 }} />
                                    {this.state.ideaItem.CertificationLevelName && this.state.ideaItem.TransformationLeverName === "Digital" && (
                                      <>
                                        <div className="row d_flex_align_items_center">
                                          <div className="col-md-5">
                                            <span className="form-attribute">
                                              Digital Project Type
                                            </span>{" "}
                                          </div>
                                          <div className="col-md-7">
                                            <input
                                              className="form-input"
                                              disabled
                                              title={this.state.ideaItem.DigitalProjectType}
                                              name="translever"
                                              value={this.state.ideaItem.DigitalProjectType}
                                            />
                                          </div>
                                        </div>
                                        <div style={{ marginBottom: 15 }} />
                                      </>
                                    )}
                                    {this.state.ideaItem
                                      .CertificationWorkTypeName !== null &&
                                      this.state.ideaItem
                                        .CertificationWorkTypeName !== "" ? (
                                      <>
                                        <div className="row">
                                          <div className="col-md-5">
                                            <span className="form-attribute">
                                              Work Type
                                            </span>{" "}
                                          </div>
                                          <div className="col-md-7">
                                            <input
                                              className="form-input"
                                              disabled
                                              name="worktype"
                                              title={this.state.ideaItem.CertificationWorkTypeName}
                                              value={this.state.ideaItem.CertificationWorkTypeName}
                                            />
                                          </div>
                                        </div>
                                      </>
                                    ) : null}
                                    <div style={{ marginBottom: 15 }} />


                                    {this.state.ideaItem.AIClassification
                                      ?
                                      <>
                                        <div className="row">
                                          <div className="col-md-5">
                                            <span className="form-attribute">
                                              AI Classification
                                            </span>
                                          </div>
                                          <div className="col-md-7">
                                            <input
                                              placeholder="AI Classification"
                                              title={this.state.ideaItem.AIClassification}
                                              className="form-input"
                                              disabled
                                              name="ai classification"
                                              value={this.state.ideaItem.AIClassification}
                                            />
                                          </div>
                                        </div>
                                        <div style={{ marginBottom: 15 }} />
                                      </>
                                      :
                                      null
                                    }

                                    <div className="row">
                                      <div className="col-md-5">
                                        <span className="form-attribute">
                                          Tools/Methodology Used
                                        </span>
                                      </div>
                                      <div className="col-md-7">
                                        <textarea
                                          placeholder="Tools/Methodologies"
                                          title={this.state.methodologies}
                                          className="form-input"
                                          disabled
                                          name="methodology"
                                          value={this.state.methodologies}
                                          style={{ width: "100%" }}
                                        />
                                      </div>
                                    </div>
                                    <div style={{ marginBottom: 10 }} />
                                    {
                                      this.state.ideaItem.OtherTools
                                        ?
                                        <>
                                          <div className="row">
                                            <div className="col-md-5">
                                              <span className="form-attribute">Other tools</span>
                                            </div>
                                            <div className="col-md-7">
                                              <textarea
                                                title={this.state.ideaItem.OtherTools}
                                                className="form-input"
                                                disabled
                                                placeholder="Other tools value"
                                                name="othertools"
                                                value={this.state.ideaItem.OtherTools}
                                                style={{ width: "100%", overflowY: "scroll" }}
                                              />
                                            </div>
                                          </div>
                                        </>
                                        :
                                        null
                                    }
                                    <div style={{ marginBottom: 25 }} />
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                      </>
                    )}



                  {/* {
                                        this.state.ideaItem.VDType
                                        ?
                                        <>
                                            <div className="gol_fields_block" style={{borderBottom: "0px",borderTop: "1px solid lightgray",paddingBottom:"0px"}}>
                                                <p className="u-align-left u-text u-text-2" style={{margin: "17px 0px 20px"}}>Impact Type</p>
                                                <div className="row u-align-left">
                                                    <div className="col-md-7">
                                                        <div className="row">
                                                            <div className="col-md-6 gol_field_div">
                                                                <span className="form-attribute">What is the type of Value Delivery on this project</span> 
                                                            </div>
                                                            <div className="col-md-5">
                                                                <input disabled value={this.state.ideaItem.VDType}  className="textarea-css form-attribute disabled_input" type="text" />
                                                            </div>
                                                        </div>
                                                        <div style={{ marginBottom: 15 }} />
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                        :
                                        null

                                    } */}

                  {/* ....latest changes to GOL starts here.... */}

                  {/* ....latest changes to GOL ends here.... */}

                  {/* Final Approval Section  */}
                  {this.state.ideaItem.ApprovalStatus &&
                    this.state.ideaItem.ApprovalStatus !== "NA" &&
                    // && (this.state.ideaItem.ApprovalStatus === "Pending Documents" && this.state.ideaItem.FinalComments !== null)
                    // && this.state.ideaItem.FinalComments !== null
                    // && this.state.ideaItem.ApprovalStatus !=="Documents Uploaded"
                    this.state.ideaItem.ApprovalStatus !==
                    "Awaiting Project Creation" && this.state.ideaItem.ApprovalStatus !==
                    "Awaiting Mentor Approval for Cancellation" && (
                      <>
                        {this.state.finalReviewComments ? (
                          <>
                            <div
                              id="Approval Status"
                              className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                            >
                              <div className="u-container-layout" style={{ paddingTop: "15px" }}>
                                <p className="u-align-left u-text u-text-2" style={{ marginBottom: 10 }} >
                                  Project Approval details
                                </p>
                                <div className="row">
                                  <div className="col-md-2">
                                    <span className="form-attribute">
                                      Approval Status
                                    </span>{" "}
                                  </div>
                                  <div className="col-md-2">
                                    <input
                                      data-toggle="tooltip"
                                      title={this.state.ideaItem.ApprovalStatus ? this.state.ideaItem.ApprovalStatus : this.state.lastApprovalStatus}
                                      className="form-input"
                                      disabled
                                      name="finalapprovalstatus"
                                      value={
                                        this.state.ideaItem.ApprovalStatus
                                          ? this.state.ideaItem.ApprovalStatus
                                          : this.state.lastApprovalStatus
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="row" style={{ marginTop: 15 }}>
                                  <div className="col-md-5">
                                    <label
                                      style={{
                                        verticalAlign: "bottom",
                                        marginBottom: -5,
                                      }}
                                    >
                                      Approval Comments
                                    </label>
                                  </div>
                                  <div
                                    className="col-md-2"
                                    style={{ marginLeft: 20 }}
                                  >
                                    <button
                                      className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                                      onClick={(e) =>
                                        this.setState({
                                          finalCommentLog:
                                            !this.state.finalCommentLog,
                                        })
                                      }
                                    >
                                      Comment Log
                                    </button>
                                  </div>
                                </div>
                                <div className="row" style={{ marginTop: 5 }}>
                                  <div className="col-md-12">
                                    {/* <textarea className="form-input" disabled rows={3} cols={88} style={{ maxWidth: '100%', border: '1px solid lightgrey' }} name="Comments" value={this.state.ideaItem.FinalComments} /> */}
                                    <textarea
                                      className="form-input"
                                      disabled
                                      rows={3}
                                      cols={88}
                                      style={{
                                        maxWidth: "100%",
                                        border: "1px solid lightgrey",
                                      }}
                                      name="Comments"
                                      value={this.state.lastFinalComment}
                                    />
                                  </div>
                                </div>

                                <div className="text-left mt-4">
                                  {this.state.finalCommentLog &&
                                    this.state.finalReviewComments ? (
                                    <>
                                      <div className="custom_modal">
                                        <div className="modal_body">
                                          <div className="row">
                                            <div className="col-md-8">
                                              <h3 className="modal_title">
                                                Lean Approval Comment Log
                                              </h3>
                                            </div>
                                            <div className="col-md-4">
                                              <button
                                                type="button"
                                                className="close text-right"
                                                onClick={(e) =>
                                                  this.setState({
                                                    finalCommentLog: false,
                                                  })
                                                }
                                              >
                                                &times;
                                              </button>
                                            </div>
                                          </div>
                                          <div className="row">
                                            <div
                                              className="col-md-2 text-center"
                                              style={{
                                                border: "1px solid lightgrey",
                                                backgroundColor: "gainsboro",
                                              }}
                                            >
                                              <label
                                                style={{
                                                  fontWeight: 100,
                                                  verticalAlign: "bottom",
                                                }}
                                              >
                                                Date & Time
                                              </label>
                                            </div>
                                            <div
                                              className="col-md-2 text-center"
                                              style={{
                                                border: "1px solid lightgrey",
                                                backgroundColor: "gainsboro",
                                              }}
                                            >
                                              <label
                                                style={{
                                                  fontWeight: 100,
                                                  verticalAlign: "bottom",
                                                }}
                                              >
                                                OHR
                                              </label>
                                            </div>
                                            <div
                                              className="col-md-2 text-center"
                                              style={{
                                                border: "1px solid lightgrey",
                                                backgroundColor: "gainsboro",
                                              }}
                                            >
                                              <label
                                                style={{
                                                  fontWeight: 100,
                                                  verticalAlign: "bottom",
                                                }}
                                              >
                                                Name
                                              </label>
                                            </div>
                                            <div
                                              className="col-md-1 text-center"
                                              style={{
                                                border: "1px solid lightgrey",
                                                backgroundColor: "gainsboro",
                                              }}
                                            >
                                              <label
                                                style={{
                                                  fontWeight: 100,
                                                  verticalAlign: "bottom",
                                                }}
                                              >
                                                Role
                                              </label>
                                            </div>
                                            <div
                                              className="col-md-2 text-center"
                                              style={{
                                                border: "1px solid lightgrey",
                                                backgroundColor: "gainsboro",
                                              }}
                                            >
                                              <label
                                                style={{
                                                  fontWeight: 100,
                                                  verticalAlign: "bottom",
                                                }}
                                              >
                                                Action
                                              </label>
                                            </div>
                                            <div
                                              className="col-md-3 text-center"
                                              style={{
                                                border: "1px solid lightgrey",
                                                backgroundColor: "gainsboro",
                                              }}
                                            >
                                              <label
                                                style={{
                                                  fontWeight: 100,
                                                  verticalAlign: "bottom",
                                                }}
                                              >
                                                Comment
                                              </label>
                                            </div>
                                          </div>
                                          {this.state.finalReviewComments.map(
                                            (item, index) => {
                                              return (
                                                <div
                                                  className="row"
                                                  key={index}
                                                >
                                                  <div
                                                    className="col-md-2 text-center"
                                                    style={{
                                                      border:
                                                        "1px solid lightgrey",
                                                    }}
                                                  >
                                                    <label
                                                      style={{
                                                        lineheight: 2,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      {this.formatDateStringWithTime(
                                                        new Date(
                                                          item.CreatedDate
                                                        )
                                                      )}
                                                    </label>
                                                  </div>
                                                  <div
                                                    className="col-md-2 text-center"
                                                    style={{
                                                      border:
                                                        "1px solid lightgrey",
                                                    }}
                                                  >
                                                    <label
                                                      style={{
                                                        lineheight: 2,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      {item.UpdaterOHR}
                                                    </label>
                                                  </div>
                                                  <div
                                                    className="col-md-2 text-center"
                                                    style={{
                                                      border:
                                                        "1px solid lightgrey",
                                                    }}
                                                  >
                                                    <label
                                                      style={{
                                                        lineheight: 2,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      {item.UpdaterName}
                                                    </label>
                                                  </div>
                                                  {/* <div className="col-md-1 text-center" style={{ border: "1px solid lightgrey" }}>
                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{(item.Action === 'Idea Updated by Admin' || item.Action === 'Idea Reinitiated by Admin') ? 'Admin' : (item.Action === 'Idea was reviewed by MBB' ? "MBB" : (item.Action === 'Idea was reviewed by LDT' ? "LDT" : (item.UpdaterOHR === this.state.ideaItem.OwnerOHR ? "Owner" : "BB")))}</label>
                                                    </div> */}
                                                  <div
                                                    className="col-md-1 text-center"
                                                    style={{
                                                      border:
                                                        "1px solid lightgrey",
                                                    }}
                                                  >
                                                    {/* <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterRole}</label> */}
                                                    <label
                                                      style={{
                                                        lineheight: 2,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      {item.UpdaterRole
                                                        ? item.UpdaterRole
                                                        : item.Action ===
                                                          "Idea Updated by Admin" ||
                                                          item.Action ===
                                                          "Idea Reinitiated by Admin"
                                                          ? "Admin"
                                                          : item.UpdaterRole}
                                                    </label>
                                                  </div>
                                                  <div
                                                    className="col-md-2 text-center"
                                                    style={{
                                                      border:
                                                        "1px solid lightgrey",
                                                    }}
                                                  >
                                                    <label>
                                                      {item.UpdaterAction
                                                        ? item.UpdaterAction
                                                        : item.Action ===
                                                          "Idea Reinitiated by Admin"
                                                          ? "Idea Reinitiated"
                                                          : item.Action ===
                                                            "Idea Updated by Admin"
                                                            ? item.ApprovalStatus
                                                            : item.WorkflowStatus ===
                                                              COMPLETE_STATUS ||
                                                              item.WorkflowStatus ===
                                                              "Approve" ||
                                                              item.WorkflowStatus ===
                                                              "Approved" ||
                                                              item.ApprovalStatus ===
                                                              AWAITING_QAULITY_CHECK_REVIEW ||
                                                              item.ApprovalStatus ===
                                                              AWAITING_PROJECT_APPROVAL ||
                                                              item.ApprovalStatus ===
                                                              COMPLETE_STATUS
                                                              ? "Approved"
                                                              : item.WorkflowStatus ===
                                                                "Rejected" ||
                                                                item.WorkflowStatus ===
                                                                "Reject" ||
                                                                item.ApprovalStatus ===
                                                                "Rejected" ||
                                                                item.ApprovalStatus ===
                                                                "Reject"
                                                                ? "Rejected"
                                                                : item.WorkflowStatus ===
                                                                  AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION
                                                                  ? AWAITING_MENTOR_APPROVAL_FOR_CANCELLATION
                                                                  : item.WorkflowStatus ===
                                                                    "Pending Documents"
                                                                    ? "Discard Cancellation"
                                                                    : item.WorkflowStatus ===
                                                                      CANCEL
                                                                      ? CANCEL
                                                                      : "Sent Back"}
                                                    </label>

                                                    {/* <label>{item.UpdaterAction}</label> */}
                                                  </div>
                                                  <div
                                                    className="col-md-3 text-center"
                                                    style={{
                                                      border:
                                                        "1px solid lightgrey",
                                                    }}
                                                  >
                                                    <label
                                                      style={{
                                                        lineheight: 2,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      {item.Comment
                                                        ? item.Comment
                                                        : "-"}
                                                    </label>
                                                  </div>
                                                </div>
                                              );
                                            }
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </>
                        ) : null}

                        {
                          this.state.ideaItem.IsFPnAApprovalAttached === "Yes" || this.state.ideaItem.IsMBBValueDely === "Yes"
                            ?
                            <>
                              <div className="">
                                <div className="gol_fields_block text-left" style={{ borderTop: "1px solid lightgrey", marginTop: "20px", padding: "10px 0px 20px 0px" }}>
                                  <p className="u-align-left u-text u-text-2" style={{ margin: "10px 30px 20px 0px" }}>Value Delivery Approval</p>
                                  <div className="row">
                                    <div className="col-md-8 gol_field_div text-left">
                                      <span className="form-attribute">
                                        I acknowledge that I have reviewed the value delivery and I agree with the value apportioning between Client/Genpact, categorization and computation along with the necessary approvals recorded on this project ?
                                      </span>
                                    </div>
                                    <div className="col-md-2">
                                      {
                                        this.state.ideaItem.IsFPnAApprovalAttached
                                          ?
                                          <>
                                            <label className="form-attribute" style={{ verticalAlign: 'bottom', marginBottom: "5px" }}>BlackBelt Approval</label>
                                            <input disabled value={this.state.ideaItem.IsFPnAApprovalAttached} className="form-input disabled_input" />
                                          </>
                                          :
                                          null
                                      }

                                    </div>
                                    <div className="col-md-2">
                                      {
                                        this.state.ideaItem.IsMBBValueDely
                                          ?
                                          <>
                                            <label className="form-attribute" style={{ verticalAlign: 'bottom', marginBottom: "5px" }}>MBB Approval</label>
                                            <input disabled value={this.state.ideaItem.IsMBBValueDely} className="form-input disabled_input" />
                                          </>
                                          :
                                          null
                                      }
                                    </div>
                                  </div>
                                </div>
                              </div>

                            </>
                            :
                            null
                        }




                        {this.state.ideaItem.ApprovalStatus &&
                          (this.state.ideaItem.ApprovalStatus ===
                            COMPLETE_STATUS ||
                            this.state.ideaItem.ApprovalStatus ===
                            AWAITING_MASTER_BLACKBELT_APPROVAL ||
                            this.state.ideaItem.ApprovalStatus ===
                            AWAITING_QAULITY_CHECK_REVIEW ||
                            this.state.ideaItem.ApprovalStatus ===
                            "Documents Uploaded" ||
                            this.state.ideaItem.ApprovalStatus ===
                            AWAITING_PROJECT_APPROVAL) && (
                            <>
                              {/* {
                                                                this.state.ideaItem.IsFPnAApprovalAttached === "Yes" && this.state.IsVDType !== "No Value Delivery"
                                                                ?
                                                                <>
                                                                    <div style={{ marginBottom: 15,borderTop:"1px solid lightgray" }} />
                                                                    <div className="text-left" style={{borderTop:"1px solid ligthgray",padding:"0px 0px 30px 0px"}}>
                                                                        <p className="u-align-left u-text u-text-2" style={{margin: "10px 0px 20px"}}>Approval Section</p>
                                                                        <div className="row">
                                                                            <div className="col-md-8">
                                                                                <div className="row">
                                                                                    <div className="col-md-7 gol_field_div text-left">
                                                                                        <span className="form-attribute">The Owner has marked the project as {this.state.IsVDType}. Do you agree with it?</span> 
                                                                                    </div>
                                                                                    <div className="col-md-3">
                                                                                        <input disabled value={this.state.ideaItem.IsFPnAApprovalAttached === "Yes" ? "Yes" : "No"} className="form-input disabled_input" />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="gol_fields_block text-left" style={{paddingTop: "10px",borderTop: "1px solid lightgray",borderBottom:"0px",paddingBottom:"0px"}}>
                                                                        <p className="u-align-left u-text u-text-2" style={{margin: "10px 0px 20px"}}>Project Document Review</p>
                                                                        <div className="row">
                                                                            <div className="col-md-8">
                                                                                <div className="row">
                                                                                    <div className="col-md-7 gol_field_div text-left">
                                                                                        <span className="form-attribute">I have reviewed the Value Delivery supporting documents and confirm that they have the correct stakeholder signoff</span> 
                                                                                    </div>
                                                                                    <div className="col-md-5">
                                                                                        <input type="checkbox" id="signOffCheckbox" checked={true} name="signOffCheckbox" value={this.state.signOffCheckbox} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                                :
                                                                null
                                                            } */}
                              {this.state.businessImpactValueArray.length > 0 ? (
                                <>
                                  <div
                                    id="Potential Impact"
                                    className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                                  >
                                    <div
                                      className="u-container-layout u-container-layout-7"
                                      style={{
                                        // padding: "34px 0px 5px 0px",
                                        // borderTop: "1px solid lightgrey",
                                        // borderBottom: "1px solid lightgrey",
                                        // marginBottom: "30px",

                                        padding: "15px 30px 5px 0px"
                                      }}
                                    >
                                      <p
                                        id="Potential Impact"
                                        className="u-align-left u-text u-text-2"
                                        style={{ marginBottom: "20px" }}
                                      >
                                        Final additional details
                                      </p>
                                      <div className="row pb-4">
                                        <div className="col-md-5">
                                          <div className="row d_flex_align_items_center">
                                            <div className="col-md-6">
                                              <span className="form-attribute">
                                                Best in Class
                                              </span>
                                            </div>
                                            <div className="col-md-6">
                                              <label className="switch">
                                                <input
                                                  disabled
                                                  type="checkbox"
                                                  checked={
                                                    this.state.ideaItem
                                                      .IsBestInClass === null
                                                      ? false
                                                      : this.state.ideaItem
                                                        .IsBestInClass
                                                  }
                                                />
                                                <span className="slider round" />
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                        <div className="col-md-2"></div>
                                        <div className="col-md-5">
                                          {this.state.ideaItem
                                            .ReplicabilityIndex !== null && (
                                              <div className="row d_flex_align_items_center">
                                                <div className="col-md-6">
                                                  <span className="form-attribute">
                                                    Replicability Index
                                                  </span>
                                                </div>
                                                <div className="col-md-6">
                                                  <input
                                                    className="form-input"
                                                    disabled
                                                    value={this.state.replicabilityIndex && this.state.replicabilityIndex.label}
                                                  />
                                                </div>
                                              </div>
                                            )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ) : null}
                            </>
                          )}

                        {this.state.ideaItem.VDType && this.state.ideaItem.VDType === "No Value Delivery" ? (
                          <></>
                        ) : <div className="" style={{ borderTop: "1px solid lightgray", marginBottom: "30px" }}></div>}
                        {this.state.ideaItem.IdeaId && this.state.ideaItem.VDType && this.state.businessImpactMasterList ? (
                          <>
                            <ValueDelivery
                              IdeaData = {this.state.ideaItem}
                              vdForComponent={this.state.vdForComponent}
                              BIMasterDataVerseNew={this.state.businessImpactMasterList}
                              func={this.pull_data}
                              viewIdea={true}
                              vdType={this.handleVDTypeChange}
                              IdeaId={this.state.ideaItem.IdeaId}
                              fetchMonetizationFileDetails={this.pull_file_data}
                              fetchMonetizationFpnaOhr={
                                this.pull_monetization_fpna_ohr
                              }
                              fetchMonetizationFpnaName={
                                this.pull_monetization_fpna_name
                              }
                              fetchMonetizationSowID={
                                this.pull_monetization_sowId
                              }
                              bbMonetizationTotal={this.pull_monetizedTotal}
                              monetizableProject={this.pull_monetizableProject}
                              monetizableStatus={this.pull_monetizableStatus}
                              fetchFPAOHRforIncreaseInRevenue={
                                this.fetchFPAOHRforIncreaseInRevenue
                              }
                              bbMonetizationApproval={false}
                              postFpnaValid={
                                this.state.ideaItem.MonetizationState ===
                                  null ||
                                  this.state.ideaItem.MonetizationState ===
                                  undefined
                                  ? false
                                  : this.state.ideaItem.MonetizationState.trim() ===
                                    "" ||
                                    this.state.ideaItem.MonetizationState ===
                                    null
                                    ? false
                                    : true
                              }
                              fetchDeletedBIRows={
                                this.remove_bi_data_after_delete
                              }
                              fetchMonetizationGOLName={
                                this.pullMonetizationGOLName
                              }
                              fetchMonetizationGOLOhr={
                                this.pullMonetizationGOLOhr
                              }


                              fetchPPTDeck={this.pullPPTDeck}
                              fetchClientDocName={this.pullClientDocName}
                              fetchClientDocType={this.pullClientDocType}
                              fetchClientDocContent={this.pullClientDocContent}
                              fetchGolDocName={this.pullgolFileName}
                              fetchGolDocType={this.pullgolFileType}
                              fetchGolDocContent={this.pullgolContent}
                              fetchfpnaDocName={this.pullfpnafileName}
                              fetchfpnaDocType={this.pullfpnafileType}
                              fetchfpnaDocContent={this.pullfpnafileContent}
                              fetchClientName={this.pullClientName}
                              fetchClientRole={this.pullClientRole}
                              fetchClientSignOffDate={this.pullClientSignOff}
                              fetchFpnaName={this.pullFpnaName}
                              fetchGolName={this.pullGolName}
                              fetchFpnaOhr={this.pullFpnaOhr}
                              fetchGolOhr={this.pullGolOhr}
                              fetchFileDetails={this.pull_fileDetails}

                            />

                          </>
                        ) : null}

                        {/* ...............qc approval detail start here.......... */}
                        {this.state.QCOHR ? (
                          <>
                            <div
                              id="Approval Status"
                              className="u-border-1 u-border-palette-5-base u-container-style u-expanded-width u-group u-radius-6 u-shape-round u-group-7"
                            >
                              <div
                                className="u-container-layout u-container-layout-7"
                                style={{
                                  margin: "10px 0px",
                                  borderBottom: "1px solid lightgray",
                                  borderTop: "1px solid lightgray",
                                  paddingTop: "35px",
                                }}
                              >
                                <p
                                  className="u-align-left u-text u-text-2"
                                  style={{ marginBottom: 10 }}
                                >
                                  QC Approval details
                                </p>
                                <div className="row">
                                  <div className="col-md-2">
                                    <span className="form-attribute">
                                      Approval Status
                                    </span>{" "}
                                  </div>
                                  <div className="col-md-3">
                                    <input
                                      className="form-input"
                                      disabled
                                      name="finalapprovalstatus"
                                      value={this.state.ideaItem.ApprovalStatus}
                                    />
                                  </div>
                                </div>

                                {
                                  this.state.ideaItem.QCName ?
                                    <>
                                      <div className="row" style={{ marginTop: 15 }}>
                                        <div className="col-md-2">
                                          <span className="form-attribute">
                                            QC Approver
                                          </span>{" "}
                                        </div>
                                        <div className="col-md-3">
                                          <input
                                            className="form-input disabled_input"
                                            disabled
                                            value={this.state.ideaItem.QCName ? this.state.ideaItem.QCName : ""}
                                          />
                                        </div>
                                      </div>
                                    </>
                                    :
                                    null
                                }




                                <div className="row" style={{ marginTop: 15 }}>
                                  <div className="col-md-5">
                                    <label
                                      style={{
                                        verticalAlign: "bottom",
                                        marginBottom: -5,
                                      }}
                                    >
                                      Approval Comments
                                    </label>
                                  </div>
                                  <div
                                    className="col-md-2"
                                    style={{ marginLeft: 20 }}
                                  >
                                    <button
                                      className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                                      onClick={(e) =>
                                        this.setState({
                                          qcCommentLog:
                                            !this.state.qcCommentLog,
                                        })
                                      }
                                    >
                                      Comment Log
                                    </button>
                                  </div>
                                </div>
                                <div className="row" style={{ marginTop: 5 }}>
                                  <div className="col-md-12">
                                    <textarea
                                      className="form-input"
                                      disabled
                                      rows={3}
                                      cols={88}
                                      style={{
                                        maxWidth: "100%",
                                        border: "1px solid lightgrey",
                                      }}
                                      name="Comments"
                                      value={this.state.lastQCCOmment}
                                    />
                                  </div>
                                </div>
                                <div className="text-left mt-4">
                                  {this.state.qcCommentLog &&
                                    this.state.qcComments ? (
                                    <>
                                      <div className="custom_modal">
                                        <div className="modal_body">
                                          <div className="row">
                                            <div className="col-md-8">
                                              <h3 className="modal_title">
                                                QC Comment Log
                                              </h3>
                                            </div>
                                            <div className="col-md-4">
                                              <button
                                                type="button"
                                                className="close text-right"
                                                onClick={(e) =>
                                                  this.setState({
                                                    qcCommentLog: false,
                                                  })
                                                }
                                              >
                                                &times;
                                              </button>
                                            </div>
                                          </div>

                                          <div className="qc_responsive_comment_log">
                                            <div className="table table-responsive table-bordered">
                                              <thead className="text-center">
                                                <tr>
                                                  <th className="qcHeaderbg qcVDHeader">
                                                    <label
                                                      style={{
                                                        fontWeight: 100,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      Date & Time
                                                    </label>
                                                  </th>
                                                  <th className="qcHeaderbg qcVDHeader">
                                                    <label
                                                      style={{
                                                        fontWeight: 100,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      OHR
                                                    </label>
                                                  </th>
                                                  <th className="qcHeaderbg qcVDHeader">
                                                    <label
                                                      style={{
                                                        fontWeight: 100,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      Name
                                                    </label>
                                                  </th>
                                                  <th className="qcHeaderbg qcVDHeader">
                                                    <label
                                                      style={{
                                                        fontWeight: 100,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      Role
                                                    </label>
                                                  </th>
                                                  <th className="qcHeaderbg qcVDHeader">
                                                    <label
                                                      style={{
                                                        fontWeight: 100,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      Action
                                                    </label>
                                                  </th>
                                                  <th
                                                    className="qcHeaderbg"
                                                    style={{
                                                      minWidth: "250px",
                                                    }}
                                                  >
                                                    <label
                                                      style={{
                                                        fontWeight: 100,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      Comment
                                                    </label>
                                                  </th>
                                                  <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthOne">
                                                    <label
                                                      style={{
                                                        fontWeight: 100,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      Is the impact correctly
                                                      tagged to Genpact or
                                                      Client ?
                                                    </label>
                                                  </th>
                                                  <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthTwo">
                                                    <label
                                                      style={{
                                                        fontWeight: 100,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      Has the Value Delivery
                                                      been correctly categorized
                                                      ?
                                                    </label>
                                                  </th>
                                                  <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthThree">
                                                    <label
                                                      style={{
                                                        fontWeight: 100,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      Has the Value Delivery
                                                      been computed correctly ?
                                                    </label>
                                                  </th>
                                                  <th className="qcHeaderbg qcVDHeader qcHeaderFullWidthFour">
                                                    <label
                                                      style={{
                                                        fontWeight: 100,
                                                        verticalAlign: "bottom",
                                                      }}
                                                    >
                                                      Do the value delivery approvals (applicable as per the value playbook) clearly articulate what improved and for which time-period ?
                                                    </label>
                                                  </th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                {this.state.qcComments.map(
                                                  (item, index) => {
                                                    return (
                                                      <tr key={index}>
                                                        <td>
                                                          <label
                                                            style={{
                                                              lineheight: 2,
                                                              verticalAlign:
                                                                "bottom",
                                                            }}
                                                          >
                                                            {this.formatDateStringWithTime(
                                                              new Date(
                                                                item.CreatedDate
                                                              )
                                                            )}
                                                          </label>
                                                        </td>
                                                        <td>
                                                          <label
                                                            style={{
                                                              lineheight: 2,
                                                              verticalAlign:
                                                                "bottom",
                                                            }}
                                                          >
                                                            {item.UpdaterOHR}
                                                          </label>
                                                        </td>
                                                        <td>
                                                          <label
                                                            style={{
                                                              lineheight: 2,
                                                              verticalAlign:
                                                                "bottom",
                                                            }}
                                                          >
                                                            {item.UpdaterName}
                                                          </label>
                                                        </td>
                                                        <td>
                                                          <label
                                                            style={{
                                                              lineheight: 2,
                                                              verticalAlign:
                                                                "bottom",
                                                            }}
                                                          >
                                                            {item.UpdaterRole
                                                              ? item.UpdaterRole
                                                              : item.Action ===
                                                                "Idea Updated by Admin" ||
                                                                item.Action ===
                                                                "Idea Reinitiated by Admin"
                                                                ? "Admin"
                                                                : item.Action ===
                                                                  "Delegate Action"
                                                                  ? "BB"
                                                                  : item.UpdaterOHR ===
                                                                    this.state
                                                                      .MBBOHR
                                                                    ? "MBB"
                                                                    : item.UpdaterOHR ===
                                                                      this.state
                                                                        .ideaItem
                                                                        .OwnerOHR
                                                                      ? "Idea Owner"
                                                                      : item.ApprovalStatus ===
                                                                        "Pending Documents" &&
                                                                        item.WorkflowStatus ===
                                                                        "Approved"
                                                                        ? "BB"
                                                                        : item.ApprovalStatus ===
                                                                          "NA" &&
                                                                          item.WorkflowStatus ===
                                                                          "Pending"
                                                                          ? "BB"
                                                                          : item.UpdaterRole}
                                                          </label>
                                                        </td>
                                                        <td>
                                                          {/* <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.ApprovalStatus==="Documents Uploaded" ? "Send Back" : ((item.WorkflowStatus==="Rejected" || item.WorkflowStatus==="Reject" || item.ApprovalStatus==="Reject" || item.ApprovalStatus==="Rejected" )? "Rejected ":"Approved")}</label> */}
                                                          {/* <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.ApprovalStatus==="Documents Uploaded" ? "Send Back" : ((item.WorkflowStatus==="Rejected" || item.WorkflowStatus==="Reject" || item.ApprovalStatus==="Reject" || item.ApprovalStatus==="Rejected" )? "Rejected ":(item.Action === "Idea was Rework - QC" ? "Rework" : "Approved"))}</label> */}

                                                          <label
                                                            style={{
                                                              lineheight: 2,
                                                              verticalAlign:
                                                                "bottom",
                                                            }}
                                                          >
                                                            {item.UpdaterAction
                                                              ? item.UpdaterAction
                                                              : item.ApprovalStatus ===
                                                                "Documents Uploaded"
                                                                ? "Send Back"
                                                                : item.WorkflowStatus ===
                                                                  "Rejected" ||
                                                                  item.WorkflowStatus ===
                                                                  "Reject" ||
                                                                  item.ApprovalStatus ===
                                                                  "Reject" ||
                                                                  item.ApprovalStatus ===
                                                                  "Rejected"
                                                                  ? "Rejected "
                                                                  : item.Action ===
                                                                    "Idea was Rework - QC"
                                                                    ? "Rework"
                                                                    : "Approved"}
                                                          </label>
                                                        </td>
                                                        <td>
                                                          <label
                                                            style={{
                                                              lineheight: 2,
                                                              verticalAlign:
                                                                "bottom",
                                                            }}
                                                          >
                                                            {item.Comment !== ""
                                                              ? item.Comment
                                                              : "-"}
                                                          </label>
                                                        </td>
                                                        {this.state
                                                          .qcCommentsWithVD &&
                                                          this.state
                                                            .qcCommentsWithVD
                                                            .length > 0 ? (
                                                          <>
                                                            {this.state.qcCommentsWithVD.map(
                                                              (pg_item) => {
                                                                if (
                                                                  Number(
                                                                    pg_item.ProjectTeamID
                                                                  ) ===
                                                                  item.TrackId
                                                                ) {
                                                                  const replacedJSONString = pg_item.AuditDataJSON ? pg_item.AuditDataJSON.replace(/'/g, '"') : "";
                                                                  console.log(replacedJSONString)
                                                                  const auditData = JSON.parse(replacedJSONString)
                                                                  return (
                                                                    <>
                                                                      <td>
                                                                        <label
                                                                          style={{
                                                                            lineheight: 2,
                                                                            verticalAlign:
                                                                              "bottom",
                                                                          }}
                                                                        >{auditData.pg_isvdimpacttagged ? auditData.pg_isvdimpacttagged : "-"}
                                                                        </label>
                                                                      </td>
                                                                      <td>
                                                                        <label
                                                                          style={{
                                                                            lineheight: 2,
                                                                            verticalAlign:
                                                                              "bottom",
                                                                          }}
                                                                        >
                                                                          {auditData.pg_isvdcategorized ? auditData.pg_isvdcategorized : "-"}
                                                                        </label>
                                                                      </td>
                                                                      <td>
                                                                        <label
                                                                          style={{
                                                                            lineheight: 2,
                                                                            verticalAlign:
                                                                              "bottom",
                                                                          }}
                                                                        >
                                                                          {auditData.pg_isvdcomputed ? auditData.pg_isvdcomputed : "-"}
                                                                        </label>
                                                                      </td>
                                                                      <td>
                                                                        <label
                                                                          style={{
                                                                            lineheight: 2,
                                                                            verticalAlign:
                                                                              "bottom",
                                                                          }}
                                                                        >
                                                                          {auditData.pg_isvdclientsignoff ? auditData.pg_isvdclientsignoff : "-"}
                                                                        </label>
                                                                      </td>
                                                                    </>
                                                                  );
                                                                }
                                                              }
                                                            )}
                                                          </>
                                                        ) : (
                                                          <>
                                                            <td>
                                                              <label
                                                                style={{
                                                                  lineheight: 2,
                                                                  verticalAlign:
                                                                    "bottom",
                                                                }}
                                                              >
                                                                -
                                                              </label>
                                                            </td>
                                                            <td>
                                                              <label
                                                                style={{
                                                                  lineheight: 2,
                                                                  verticalAlign:
                                                                    "bottom",
                                                                }}
                                                              >
                                                                -
                                                              </label>
                                                            </td>
                                                            <td>
                                                              <label
                                                                style={{
                                                                  lineheight: 2,
                                                                  verticalAlign:
                                                                    "bottom",
                                                                }}
                                                              >
                                                                -
                                                              </label>
                                                            </td>
                                                            <td>
                                                              <label
                                                                style={{
                                                                  lineheight: 2,
                                                                  verticalAlign:
                                                                    "bottom",
                                                                }}
                                                              >
                                                                -
                                                              </label>
                                                            </td>
                                                          </>
                                                        )}
                                                      </tr>
                                                    );
                                                  }
                                                )}
                                              </tbody>
                                            </div>
                                          </div>

                                          {/* <div className="row">
                                                                                        <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                            <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Date & Time</label>
                                                                                        </div>
                                                                                        <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                            <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>OHR</label>
                                                                                        </div>
                                                                                        <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                            <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Name</label>
                                                                                        </div>
                                                                                        <div className="col-md-1 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                            <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Role</label>
                                                                                        </div>
                                                                                        <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                            <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Action</label>
                                                                                        </div>
                                                                                        <div className="col-md-3 text-center" style={{ border: "1px solid lightgrey", backgroundColor: "gainsboro" }}>
                                                                                            <label style={{ fontWeight: 100, verticalAlign: "bottom" }}>Comment</label>
                                                                                        </div>
                                                                                    </div>
                                                                                    {
                                                                                        this.state.qcComments.map((item, index) => {
                                                                                            return (
                                                                                                <div className="row" key={index}>
                                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{this.formatDateStringWithTime(new Date(item.CreatedDate))}</label>
                                                                                                    </div>
                                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterOHR}</label>
                                                                                                    </div>
                                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.UpdaterName}</label>
                                                                                                    </div>
                                                                                                    <div className="col-md-1 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{(item.Action === 'Idea Updated by Admin' || item.Action === 'Idea Reinitiated by Admin') ? 'Admin' : (item.Action === "Delegate Action" ? 'BB' : (item.UpdaterOHR === this.state.MBBOHR ? 'MBB' : (item.UpdaterOHR === this.state.ideaItem.OwnerOHR ? "Idea Owner" : (item.ApprovalStatus ===  "Pending Documents" && item.WorkflowStatus === "Approved") ? "BB" : (item.ApprovalStatus ===  "NA" && item.WorkflowStatus === "Pending") ? "BB" : item.UpdaterRole )))}</label>
                                                                                                    </div>
                                                                                                    <div className="col-md-2 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.ApprovalStatus==="Documents Uploaded" ? "Send Back" : ((item.WorkflowStatus==="Rejected" || item.WorkflowStatus==="Reject" || item.ApprovalStatus==="Reject" || item.ApprovalStatus==="Rejected" )? "Rejected ":"Approved")}</label>
                                                                                                    </div>
                                                                                                    <div className="col-md-3 text-center" style={{ border: "1px solid lightgrey" }}>
                                                                                                        <label style={{ lineheight: 2, verticalAlign: "bottom" }}>{item.Comment !== '' ? item.Comment:'-'}</label>
                                                                                                    </div>
                                                                                                </div>
                                                                                            )
                                                                                        })
                                                                                    } */}
                                        </div>
                                      </div>
                                    </>
                                  ) : null}
                                </div>
                              </div>
                            </div>

                            <div
                              className="gol_fields_block"
                              style={{ borderBottom: "0px",paddingRight:"30px" }}
                            >
                              <p
                                className="u-align-left u-text u-text-2"
                                style={{ margin: "10px 0px 20px" }}
                              >
                                Quality Check Details
                              </p>
                              <div className="row u-align-left">
                                <div className="col-md-5">
                                  <div className="row">
                                    <div className="col-md-9 gol_field_div">
                                      <span className="form-attribute">
                                        Is the impact correctly tagged to
                                        Genpact or Client ?
                                      </span>
                                    </div>
                                    <div className="col-md-3">
                                      <input
                                        className="form-input disabled_input"
                                        disabled
                                        value={
                                          this.state.ideaItem.IsVDImpactTagged
                                        }
                                      />
                                    </div>
                                  </div>
                                  <div style={{ marginBottom: 15 }} />

                                  <div className="row">
                                    <div className="col-md-9 gol_field_div">
                                      <span className="form-attribute">
                                        Has the value delivered been correctly
                                        categorized ?
                                      </span>
                                    </div>
                                    <div className="col-md-3">
                                      <input
                                        className="form-input disabled_input"
                                        disabled
                                        value={
                                          this.state.ideaItem.IsVDCategorized
                                        }
                                      />
                                    </div>
                                  </div>

                                  <div style={{ marginBottom: 15 }} />

                                  <div className="row">
                                    <div className="col-md-5 gol_field_div">
                                      <span className="form-attribute">
                                        Project Reviewed By
                                      </span>
                                    </div>
                                    <div className="col-md-7">
                                      <input
                                        className="form-input disabled_input"
                                        disabled
                                        value={this.state.ideaItem.QCName}
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-2"></div>
                                <div className="col-md-5">
                                  <div className="row">
                                    <div className="col-md-9 gol_field_div">
                                      <span className="form-attribute">
                                        Has the value delivered been computed
                                        correctly ?
                                      </span>
                                    </div>
                                    <div className="col-md-3">
                                      <input
                                        disabled
                                        value={this.state.ideaItem.IsVDComputed}
                                        className="form-input disabled_input"
                                        type="text"
                                      />
                                    </div>
                                  </div>
                                  <div style={{ marginBottom: 15 }} />

                                  <div className="row">
                                    <div className="col-md-9 gol_field_div">
                                      <span className="form-attribute">
                                        Do the value delivery approvals (applicable as per the value playbook) clearly articulate what improved and for which time-period?
                                      </span>
                                    </div>
                                    <div className="col-md-3">
                                      <input
                                        disabled
                                        className="form-input disabled_input"
                                        type="text"
                                        value={
                                          this.state.ideaItem.IsVDClientSignOff
                                        }
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        ) : null}
                        {/* ..................qc approval details end here.......... */}
                      </>
                    )}

                  {
                    this.state.ideaItem.ApprovalStatus !== "Awaiting Project Creation" &&
                    this.state.ideaItem.ApprovalStatus !== "NA" &&
                    this.state.ideaItem.ApprovalStatus !== "Pending Documents" ? (
                    <>
                      {(this.state.ideaItem.VDType && this.state.ideaItem.VDType !== NO_VD) && (this.state.ideaItem.CustomerSignoffFileName || this.state.ideaItem.GOLFileName || this.state.ideaItem.FPnAFileName)  ? (
                        <>
                          <div
                            className="gol_uploaded_documents"
                            style={{
                              borderTop: "1px solid lightgray",
                              paddingTop: "35px",
                            }}
                          >
                            <p className="u-align-left u-text u-text-2">
                              Project Documents
                            </p>
                            <div className="">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="mt-3 text-left">
                                      {
                                        this.state.ideaItem.CustomerSignoffFileName && (
                                          <div className="row">
                                            <div className="col-md-12">
                                              <button className="file_name" onClick={this.showSignOffContent}>
                                                {
                                                  this.state.ideaItem.CustomerSignoffFileName
                                                }
                                              </button>
                                            </div>
                                          </div>
                                        )

                                      }
                                  </div>

                                  <div className="mt-3 text-left">
                                      {
                                        this.state.ideaItem.GOLFileName && (
                                          <div className="row">
                                            <div className="col-md-12">
                                              <button className="file_name" onClick={(e) => this.showGolOffContent()}>
                                                {this.state.ideaItem.GOLFileName}
                                              </button>
                                            </div>
                                          </div>
                                        )}
                                  </div>
                                    <div className="mt-3 text-left">
                                      {this.state.ideaItem.FPnAFileName && (
                                        <div className="row">
                                          <div className="col-md-12">
                                            <button className="file_name" onClick={(e) => this.showFpnaContent()}>
                                              {this.state.ideaItem.FPnAFileName}
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : null}
                    </>
                  ) : null}



                  {/* LDT Approval starts here */}
                  {
                    this.state.ideaItem.ApprovalStatus === COMPLETE_STATUS
                      ?
                      <>
                        <div className="" style={{ borderTop: "1px solid lightgrey", paddingRight: "30px", paddingTop: "10px" }}>
                          <div className="">
                            <div className="row">
                              <div className="col-md-10" style={{ paddingBottom: "0px" }}>
                                <h3 className="idea_form_header">Client QBR</h3>
                              </div>
                              <div className="col-md-2" >
                                <div className="project_lead_comment_log_button" style={{}}>
                                  <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={(e) => this.toggleLDTApprovalCommentLogModal()}>LDT Lead Log</button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="" style={{ paddingBottom: "30px" }}>
                            <h5 style={{ textAlign: "Left", color: "red" }}>This section is to be filled by  LDT Leads and only if this project was demonstrated during a Client Quarterly Business Review.</h5>
                          </div>

                          <div className="" style={{ marginBottom: "20px" }}>
                            <div className="row">
                              <div className="col-md-5">
                                <div className="">
                                  <div className="row d_flex_align_items_center">
                                    <div className="col-md-8 text-left">
                                      <div className="">
                                        <span className="form-attribute">
                                          <span style={{ color: "red" }}>*&nbsp;</span>
                                          {/* Project demonstrated in Client QBR */}
                                          Shown in Client QBR
                                        </span>
                                      </div>
                                    </div>
                                    <div className="col-md-4 text-left">
                                      <Select
                                        options={YESORNO}
                                        onChange={(e) => this.handleIsQBRChange(e)}
                                        value={this.state.IsQBR}
                                        style={
                                          this.state.selectStyle.IsQBR
                                        }
                                      ></Select>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-2"></div>
                              <div className="col-md-5">
                                {
                                  this.state.IsQBR && this.state.IsQBR.label === "Yes"
                                    ?
                                    <>
                                      <div className="">
                                        <div className="row d_flex_align_items_center">
                                          <div className="col-md-5 text-left">
                                            <div className="">
                                              <span className="form-attribute">
                                                <span style={{ color: "red" }}>*&nbsp;</span>
                                                Date of QBR
                                              </span>
                                            </div>
                                          </div>
                                          <div className="col-md-7">
                                            <input
                                              className="textarea-css form-attribute" type="date"
                                              value={this.state.QBRDate}
                                              style={
                                                this.state.selectStyle.QBRDate
                                              }
                                              onChange={(e) => this.handleQBRDateChange(e.target.value)}
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                    :
                                    null
                                }

                              </div>
                            </div>
                          </div>
                          {
                            this.state.IsQBR && this.state.IsQBR.label === "Yes"
                              ?
                              <div className="" style={{ marginBottom: "20px" }}>
                                <div className="row">
                                  <div className="col-md-5">
                                    <div className="">
                                      <div className="row d_flex_align_items_center">
                                        <div className="col-md-5 text-left">
                                          <span className="form-attribute">
                                            LDT Lead Name
                                          </span>
                                        </div>
                                        <div className="col-md-7 text-left">
                                          <input type="text" disabled value={this.state.LDTApproverName} className="textarea-css form-attribute"
                                            style={
                                              this.state.selectStyle.LDTApproverName
                                            }
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-2"></div>
                                  <div className="col-md-5">
                                    <div className="">
                                      <div className="row d_flex_align_items_center">
                                        <div className="col-md-5 text-left">
                                          <span className="form-attribute">
                                            LDT Lead OHR
                                          </span>
                                        </div>
                                        <div className="col-md-7 text-left">
                                          <input
                                            type="number"
                                            disabled
                                            value={this.state.LDTApproverOHR}
                                            style={
                                              this.state.selectStyle.LDTApproverOHR
                                            }
                                            className="textarea-css form-attribute" />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              :
                              null
                          }
                          <div className="" style={{ marginBottom: "20px" }}>
                            <div className="row">
                              <div className="col-md-5">
                                {
                                  this.state.IsQBR && this.state.IsQBR.label === "No"
                                    ?
                                    <div className="">
                                      <div className="row d_flex_align_items_center">
                                        <div className="col-md-12 text-left" style={{ marginBottom: "5px" }}>
                                          <div className="">
                                            <span className="form-attribute">
                                              LDT Lead Comment
                                            </span>
                                          </div>
                                        </div>
                                        <div className="col-md-12">
                                          <textarea
                                            style={{ width: "100%", resize: "none" }}
                                            type="text"
                                            className="textarea-css form-attribute"
                                            value={this.state.ldtApprovalComment}
                                            onChange={(e) => this.handleLDTApprovalCommentChange(e.target.value)}
                                            rows={4}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    :
                                    null
                                }
                              </div>

                              <div className="col-md-2"></div>
                              <div className="col-md-5">
                                <div className="">
                                  {
                                    this.state.IsQBR && this.state.IsQBR.label === "Yes"
                                      ?
                                      <>
                                        <div className="row d_flex_align_items_center">
                                          <div className="col-md-5 text-left">
                                            <span className="form-attribute">
                                              Last Submitted on
                                            </span>
                                          </div>
                                          <div className="col-md-7 text-left">
                                            <input disabled value={this.formatDateLatest(this.state.QBRDate)} style={{ color: "#122539" }} type="date" className="form-input disabled_input" />
                                          </div>
                                        </div>
                                      </>
                                      :
                                      null
                                  }

                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="" style={{ marginBottom: "20px" }}>
                            <div className="row text-left">
                              <div className="col-md-5">

                              </div>
                              <div className="col-md-2"></div>
                              <div className="col-md-5">

                                {
                                  this.state.displayLDTCommentLog
                                    ?
                                    <>
                                      {
                                        this.state.LDTLogs
                                          ?
                                          <>
                                            <div className="custom_modal ldt_lead_approval_modal">
                                              <div className="modal_body">
                                                <div className="row">
                                                  <div className="col-md-8">
                                                    <h3 className="modal_title">
                                                      LDT Lead Approval Log
                                                    </h3>
                                                  </div>
                                                  <div className="col-md-4">
                                                    <button
                                                      type="button"
                                                      className="close text-right"
                                                      onClick={(e) =>
                                                        this.setState({
                                                          displayLDTCommentLog: false,
                                                        })
                                                      }
                                                    >
                                                      &times;
                                                    </button>
                                                  </div>
                                                </div>

                                                <div className="qc_responsive_comment_log">
                                                  <div className="table table-responsive table-bordered">
                                                    <thead className="text-center">
                                                      <tr>

                                                        <th className="qcHeaderbg qcVDHeader LDTHeaderFullWidthOne">
                                                          <label
                                                            style={{
                                                              fontWeight: 100,
                                                              verticalAlign: "bottom",
                                                            }}
                                                          >
                                                            Project demonstrated in Client QBR
                                                          </label>
                                                        </th>
                                                        <th className="qcHeaderbg qcVDHeader LDTHeaderFullWidthTwo">
                                                          <label
                                                            style={{
                                                              fontWeight: 100,
                                                              verticalAlign: "bottom",
                                                            }}
                                                          >
                                                            QBR Submitted Date
                                                          </label>
                                                        </th>
                                                        <th className="qcHeaderbg qcVDHeader">
                                                          <label
                                                            style={{
                                                              fontWeight: 100,
                                                              verticalAlign: "bottom",
                                                            }}
                                                          >
                                                            Name
                                                          </label>
                                                        </th>

                                                        <th className="qcHeaderbg qcVDHeader">
                                                          <label
                                                            style={{
                                                              fontWeight: 100,
                                                              verticalAlign: "bottom",
                                                            }}
                                                          >
                                                            Role
                                                          </label>
                                                        </th>
                                                        <th className="qcHeaderbg qcVDHeader">
                                                          <label
                                                            style={{
                                                              fontWeight: 100,
                                                              verticalAlign: "bottom",
                                                            }}
                                                          >
                                                            OHR
                                                          </label>
                                                        </th>
                                                        <th
                                                          className="qcHeaderbg"
                                                          style={{
                                                            minWidth: "400px",
                                                          }}
                                                        >
                                                          <label
                                                            style={{
                                                              fontWeight: 100,
                                                              verticalAlign: "bottom",
                                                            }}
                                                          >
                                                            Comment
                                                          </label>
                                                        </th>
                                                        <th className="qcHeaderbg qcVDHeader">
                                                          <label
                                                            style={{
                                                              fontWeight: 100,
                                                              verticalAlign: "bottom",
                                                            }}
                                                          >
                                                            Date & Time
                                                          </label>
                                                        </th>
                                                      </tr>
                                                    </thead>
                                                    <tbody>
                                                      {this.state.LDTLogs.map(
                                                        (item, index) => {
                                                          return (
                                                            <tr key={index}>

                                                              <td>
                                                                <label
                                                                  style={{
                                                                    lineheight: 2,
                                                                    verticalAlign:
                                                                      "bottom",
                                                                  }}
                                                                >
                                                                  <label
                                                                    style={{
                                                                      lineheight: 2,
                                                                      verticalAlign: "bottom",
                                                                    }}
                                                                  >
                                                                    {item.IsQBR
                                                                      ? item.IsQBR
                                                                      : ""}
                                                                  </label>
                                                                </label>
                                                              </td>

                                                              <td>
                                                                <label
                                                                  style={{
                                                                    lineheight: 2,
                                                                    verticalAlign:
                                                                      "bottom",
                                                                  }}
                                                                >
                                                                  <label
                                                                    style={{
                                                                      lineheight: 2,
                                                                      verticalAlign: "bottom",
                                                                    }}
                                                                  >
                                                                    {item.IsQBR === "Yes" ? this.formatDateString(new Date(item.QBRDate)) : ""}

                                                                  </label>
                                                                </label>
                                                              </td>
                                                              <td>
                                                                <label
                                                                  style={{
                                                                    lineheight: 2,
                                                                    verticalAlign:
                                                                      "bottom",
                                                                  }}
                                                                >
                                                                  {item.UserName}
                                                                </label>
                                                              </td>
                                                              <td>
                                                                <label
                                                                  style={{
                                                                    lineheight: 2,
                                                                    verticalAlign:
                                                                      "bottom",
                                                                  }}
                                                                >
                                                                  LDT Lead
                                                                </label>
                                                              </td>

                                                              <td>
                                                                <label
                                                                  style={{
                                                                    lineheight: 2,
                                                                    verticalAlign:
                                                                      "bottom",
                                                                  }}
                                                                >
                                                                  {item.UserOHR}
                                                                </label>
                                                              </td>

                                                              <td>
                                                                <label
                                                                  style={{
                                                                    lineheight: 2,
                                                                    verticalAlign:
                                                                      "bottom",
                                                                  }}
                                                                >
                                                                  <label
                                                                    style={{
                                                                      lineheight: 2,
                                                                      verticalAlign: "bottom",
                                                                    }}
                                                                  >
                                                                    {item.LDTComments
                                                                      ? item.LDTComments
                                                                      : "-"}
                                                                  </label>
                                                                </label>
                                                              </td>


                                                              <td>
                                                                <label
                                                                  style={{
                                                                    lineheight: 2,
                                                                    verticalAlign:
                                                                      "bottom",
                                                                  }}
                                                                >
                                                                  {this.formatDateStringWithTime(
                                                                    new Date(
                                                                      item.CreatedDate
                                                                    )
                                                                  )}
                                                                </label>
                                                              </td>
                                                            </tr>
                                                          );
                                                        }
                                                      )}
                                                    </tbody>
                                                  </div>
                                                </div>

                                              </div>
                                            </div>
                                          </>
                                          :
                                          null

                                      }


                                    </>
                                    :
                                    null
                                }

                              </div>
                            </div>
                          </div>
                          <div className="">
                            <div className="btn-group" style={{ marginTop: 10, marginBottom: "20px" }}>
                              <button
                                className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                                onClick={this.saveLDTApprovalDetails}
                              >
                                Submit LDT Lead Approval
                              </button>
                              <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={this.cancelLDTApproval}>Cancel</button>

                            </div>
                          </div>

                        </div>

                      </>
                      :
                      null
                  }
                  {/* LDT Approval ends here */}



                  {
                    this.state.ideaItem.VDType && this.state.ideaItem.VDType === 'No Value Delivery'
                      && (this.state.ideaItem.ApprovalStatus === "Awaiting Analytics Review")
                      ?
                      <></>
                      :
                      <div className="" style={{ borderTop: "1px solid lightgray", margin: "20px 0px", }}></div>
                  }

                  <div className="btn-group" style={{ marginTop: 10 }}>
                    {this.state.IdeaOwnerCanEdit || this.state.isIdeaDUAOwner ?
                      <>
                        <button className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3" onClick={this.submitIdea}>Submit</button>
                        <button
                          href={redirectURL}
                          className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                          onClick={this.saveEvent}
                        >
                          Cancel
                        </button>
                      </>
                      :
                      <button
                        href={redirectURL}
                        className="u-active-custom-color-6 u-border-2 u-border-active-black u-border-hover-black u-border-white u-btn u-btn-round u-button-style u-custom-color-3 u-hover-custom-color-6 u-radius-6 u-btn-3"
                        onClick={this.saveEvent}
                      >
                        Cancel
                      </button>
                    }

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ViewIdeaPage;



